function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "20px",
    height: "14px",
    viewBox: "0 0 19 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 2.339844 14.074219 C 2.265625 14.074219 2.1875 14.074219 2.082031 14.050781 C 1.984375 13.941406 1.914062 13.859375 1.84375 13.746094 C 1.917969 13.316406 1.679688 13.308594 1.417969 13.328125 C 1.417969 13.328125 1.417969 13.332031 1.417969 13.296875 C 1.492188 12.871094 1.257812 12.859375 0.992188 12.863281 C 0.992188 12.84375 0.992188 12.808594 0.992188 12.777344 C 0.992188 12.617188 0.992188 12.488281 1.023438 12.363281 C 1.175781 12.363281 1.296875 12.363281 1.417969 12.394531 C 1.433594 12.59375 1.347656 12.84375 1.644531 12.796875 C 1.71875 12.785156 1.824219 12.65625 1.832031 12.574219 C 1.859375 12.28125 1.632812 12.382812 1.488281 12.363281 C 1.464844 12.359375 1.441406 12.363281 1.417969 12.332031 C 1.417969 12.171875 1.417969 12.042969 1.449219 11.914062 C 1.625 11.914062 1.769531 11.914062 1.914062 11.945312 C 1.839844 12.371094 2.070312 12.390625 2.339844 12.394531 C 2.265625 12.820312 2.5 12.832031 2.765625 12.828125 C 2.765625 12.847656 2.765625 12.882812 2.765625 12.914062 C 2.765625 13.074219 2.765625 13.203125 2.734375 13.328125 C 2.582031 13.328125 2.460938 13.332031 2.339844 13.296875 C 2.324219 13.097656 2.410156 12.847656 2.113281 12.894531 C 2.039062 12.90625 1.929688 13.035156 1.921875 13.117188 C 1.898438 13.410156 2.125 13.308594 2.269531 13.328125 C 2.292969 13.332031 2.316406 13.328125 2.339844 13.363281 C 2.339844 13.621094 2.339844 13.847656 2.339844 14.074219 Z M 2.339844 14.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 0.0703125 2.457031 C 0.0703125 2.304688 0.0703125 2.152344 0.101562 1.96875 C 0.503906 2.011719 0.523438 1.769531 0.496094 1.488281 C 0.496094 1.488281 0.496094 1.488281 0.527344 1.488281 C 0.703125 1.488281 0.847656 1.488281 0.992188 1.519531 C 0.917969 1.945312 1.148438 1.964844 1.417969 1.96875 C 1.417969 2.152344 1.417969 2.304688 1.386719 2.457031 C 1.234375 2.457031 1.113281 2.457031 0.992188 2.425781 C 0.992188 2.320312 1.019531 2.222656 0.984375 2.179688 C 0.910156 2.082031 0.808594 1.984375 0.703125 1.957031 C 0.65625 1.941406 0.496094 2.128906 0.511719 2.175781 C 0.550781 2.285156 0.652344 2.382812 0.75 2.449219 C 0.808594 2.488281 0.910156 2.457031 0.992188 2.488281 C 0.992188 2.648438 0.992188 2.777344 0.960938 2.90625 C 0.785156 2.90625 0.640625 2.902344 0.496094 2.902344 C 0.496094 2.902344 0.496094 2.90625 0.496094 2.871094 C 0.570312 2.449219 0.339844 2.429688 0.0703125 2.457031 Z M 0.0703125 2.457031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.431373%,97.254902%,97.254902%)",
      fillOpacity: 1
    },
    d: "M 7.300781 0.0742188 C 7.445312 0.0742188 7.59375 0.0742188 7.765625 0.105469 C 7.726562 0.53125 7.957031 0.546875 8.222656 0.519531 C 8.222656 0.519531 8.222656 0.519531 8.222656 0.554688 C 8.222656 0.726562 8.222656 0.871094 8.222656 1.011719 C 8.179688 0.988281 8.140625 0.964844 8.097656 0.945312 C 7.996094 1.0625 7.894531 1.179688 7.773438 1.3125 C 7.601562 1.378906 7.453125 1.429688 7.300781 1.453125 C 7.300781 1.292969 7.300781 1.167969 7.332031 1.042969 C 7.535156 1.03125 7.746094 1.027344 7.710938 0.773438 C 7.699219 0.679688 7.539062 0.601562 7.4375 0.527344 C 7.40625 0.503906 7.347656 0.523438 7.300781 0.488281 C 7.300781 0.328125 7.300781 0.203125 7.300781 0.0742188 Z M 7.300781 0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 10.917969 14.074219 C 10.84375 14.074219 10.765625 14.074219 10.660156 14.050781 C 10.585938 13.941406 10.539062 13.859375 10.492188 13.742188 C 10.570312 13.316406 10.328125 13.308594 10.070312 13.304688 C 10.117188 13.222656 10.164062 13.167969 10.234375 13.101562 C 10.335938 13.078125 10.40625 13.070312 10.492188 13.085938 C 10.550781 13.132812 10.601562 13.152344 10.664062 13.171875 C 10.675781 13.171875 10.703125 13.179688 10.722656 13.171875 C 10.824219 13.097656 10.90625 13.027344 11.007812 12.949219 C 11.085938 12.925781 11.144531 12.910156 11.210938 12.90625 C 11.238281 12.90625 11.253906 12.894531 11.273438 12.882812 C 11.273438 12.882812 11.269531 12.882812 11.289062 12.882812 C 11.320312 12.886719 11.332031 12.886719 11.34375 12.921875 C 11.335938 13.070312 11.328125 13.183594 11.320312 13.296875 C 11.171875 13.324219 11.0625 13.34375 10.917969 13.371094 C 10.917969 13.613281 10.917969 13.84375 10.917969 14.074219 Z M 10.917969 14.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,98.823529%,98.823529%)",
      fillOpacity: 1
    },
    d: "M 10.949219 14.074219 C 10.917969 13.84375 10.917969 13.613281 10.917969 13.371094 C 11.0625 13.34375 11.171875 13.324219 11.320312 13.296875 C 11.328125 13.183594 11.335938 13.070312 11.347656 12.910156 C 11.347656 12.867188 11.347656 12.847656 11.371094 12.835938 C 11.445312 12.808594 11.496094 12.796875 11.5625 12.808594 C 11.882812 12.875 11.847656 13.109375 11.839844 13.328125 C 11.839844 13.328125 11.839844 13.328125 11.808594 13.328125 C 11.40625 13.253906 11.386719 13.496094 11.414062 13.808594 C 11.414062 13.917969 11.414062 13.996094 11.414062 14.074219 C 11.269531 14.074219 11.125 14.074219 10.949219 14.074219 Z M 10.949219 14.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,98.823529%,98.823529%)",
      fillOpacity: 1
    },
    d: "M 10.917969 0.0742188 C 11.0625 0.0742188 11.207031 0.0742188 11.382812 0.105469 C 11.339844 0.53125 11.574219 0.546875 11.839844 0.519531 C 11.839844 0.519531 11.839844 0.519531 11.839844 0.554688 C 11.839844 0.738281 11.839844 0.890625 11.808594 1.042969 C 11.59375 1.042969 11.375 0.996094 11.386719 1.320312 C 11.214844 1.273438 11.066406 1.222656 10.917969 1.152344 C 10.917969 1.101562 10.917969 1.070312 10.949219 1.042969 C 11.296875 1.019531 11.453125 0.847656 11.308594 0.65625 C 11.238281 0.558594 11.050781 0.5625 10.917969 0.519531 C 10.917969 0.519531 10.917969 0.519531 10.917969 0.488281 C 10.917969 0.328125 10.917969 0.203125 10.917969 0.0742188 Z M 10.917969 0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,98.823529%,98.823529%)",
      fillOpacity: 1
    },
    d: "M 7.796875 14.074219 C 7.652344 14.074219 7.507812 14.074219 7.332031 14.039062 C 7.300781 13.78125 7.300781 13.554688 7.332031 13.328125 C 7.765625 13.40625 7.75 13.136719 7.746094 12.84375 C 7.921875 12.878906 8.074219 12.925781 8.222656 13.003906 C 8.222656 13.132812 8.222656 13.230469 8.222656 13.328125 C 8.222656 13.328125 8.222656 13.328125 8.195312 13.328125 C 7.789062 13.253906 7.773438 13.496094 7.796875 13.808594 C 7.796875 13.917969 7.796875 13.996094 7.796875 14.074219 Z M 7.796875 14.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 0.0703125 6.253906 C 0.0703125 6.101562 0.0703125 5.949219 0.101562 5.765625 C 0.253906 5.734375 0.375 5.734375 0.496094 5.765625 C 0.417969 6.277344 0.742188 6.175781 0.992188 6.199219 C 0.992188 6.21875 0.992188 6.253906 0.992188 6.285156 C 0.992188 6.445312 0.992188 6.574219 0.960938 6.703125 C 0.785156 6.703125 0.640625 6.703125 0.496094 6.703125 C 0.496094 6.703125 0.496094 6.703125 0.496094 6.671875 C 0.570312 6.246094 0.339844 6.226562 0.0703125 6.253906 Z M 0.0703125 6.253906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 0.0703125 11.914062 C 0.0703125 11.761719 0.0703125 11.609375 0.101562 11.425781 C 0.503906 11.472656 0.523438 11.226562 0.496094 10.945312 C 0.496094 10.945312 0.496094 10.945312 0.527344 10.945312 C 0.703125 10.945312 0.847656 10.945312 0.992188 10.976562 C 0.992188 11.140625 0.992188 11.265625 0.992188 11.414062 C 0.992188 11.429688 0.992188 11.46875 0.960938 11.46875 C 0.585938 11.402344 0.429688 11.539062 0.464844 11.914062 C 0.3125 11.914062 0.191406 11.914062 0.0703125 11.914062 Z M 0.0703125 11.914062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 17.9375 14.074219 C 17.722656 14.074219 17.507812 14.074219 17.261719 14.042969 C 17.226562 13.933594 17.226562 13.855469 17.257812 13.777344 C 17.632812 13.839844 17.792969 13.707031 17.722656 13.328125 C 17.722656 13.328125 17.722656 13.332031 17.753906 13.332031 C 17.90625 13.328125 18.027344 13.328125 18.148438 13.363281 C 18.148438 13.519531 18.148438 13.648438 18.136719 13.796875 C 18.0625 13.902344 18 13.988281 17.9375 14.074219 Z M 17.9375 14.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 17.226562 13.777344 C 17.226562 13.855469 17.226562 13.933594 17.226562 14.042969 C 17.011719 14.074219 16.796875 14.074219 16.550781 14.050781 C 16.46875 13.941406 16.421875 13.859375 16.375 13.742188 C 16.375 13.585938 16.375 13.457031 16.40625 13.328125 C 16.558594 13.328125 16.679688 13.328125 16.800781 13.328125 C 16.800781 13.328125 16.800781 13.328125 16.800781 13.363281 C 16.726562 13.789062 16.964844 13.800781 17.226562 13.777344 Z M 17.226562 13.777344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 11.445312 14.074219 C 11.414062 13.996094 11.414062 13.917969 11.445312 13.808594 C 11.851562 13.855469 11.863281 13.609375 11.839844 13.328125 C 11.839844 13.328125 11.839844 13.328125 11.871094 13.328125 C 12.023438 13.328125 12.144531 13.328125 12.265625 13.363281 C 12.265625 13.519531 12.265625 13.648438 12.25 13.796875 C 12.175781 13.902344 12.113281 13.988281 12.050781 14.074219 C 11.859375 14.074219 11.667969 14.074219 11.445312 14.074219 Z M 11.445312 14.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 7.832031 14.074219 C 7.796875 13.996094 7.796875 13.917969 7.828125 13.808594 C 8.234375 13.855469 8.246094 13.609375 8.222656 13.328125 C 8.222656 13.328125 8.222656 13.328125 8.253906 13.328125 C 8.65625 13.253906 8.675781 13.492188 8.636719 13.796875 C 8.5625 13.902344 8.5 13.988281 8.4375 14.074219 C 8.246094 14.074219 8.054688 14.074219 7.832031 14.074219 Z M 7.832031 14.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 14.109375 14.074219 C 14.03125 14.074219 13.957031 14.074219 13.851562 14.050781 C 13.75 13.941406 13.683594 13.859375 13.613281 13.746094 C 13.613281 13.585938 13.613281 13.457031 13.644531 13.328125 C 13.820312 13.328125 13.964844 13.328125 14.109375 13.363281 C 14.109375 13.621094 14.109375 13.847656 14.109375 14.074219 Z M 14.109375 14.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 5.035156 14.074219 C 4.910156 14.074219 4.789062 14.074219 4.636719 14.039062 C 4.609375 13.78125 4.609375 13.554688 4.636719 13.328125 C 4.789062 13.328125 4.914062 13.328125 5.035156 13.363281 C 5.035156 13.621094 5.035156 13.847656 5.035156 14.074219 Z M 5.035156 14.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 14.136719 14.074219 C 14.109375 13.847656 14.109375 13.621094 14.109375 13.363281 C 14.109375 13.328125 14.109375 13.332031 14.136719 13.328125 C 14.289062 13.328125 14.414062 13.328125 14.535156 13.363281 C 14.535156 13.621094 14.535156 13.847656 14.535156 14.074219 C 14.410156 14.074219 14.289062 14.074219 14.136719 14.074219 Z M 14.136719 14.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 9.785156 14.074219 C 9.730469 14.074219 9.675781 14.074219 9.597656 14.039062 C 9.570312 13.78125 9.570312 13.554688 9.570312 13.3125 C 9.570312 13.292969 9.570312 13.257812 9.597656 13.257812 C 9.75 13.28125 9.875 13.304688 9.996094 13.359375 C 9.996094 13.519531 9.996094 13.648438 9.984375 13.796875 C 9.90625 13.902344 9.84375 13.988281 9.785156 14.074219 Z M 9.785156 14.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 5.058594 14.074219 C 5.035156 13.847656 5.035156 13.621094 5.035156 13.363281 C 5.035156 13.328125 5.035156 13.332031 5.0625 13.328125 C 5.242188 13.328125 5.386719 13.328125 5.53125 13.359375 C 5.527344 13.519531 5.527344 13.648438 5.503906 13.777344 C 5.402344 13.878906 5.324219 13.976562 5.246094 14.074219 C 5.191406 14.074219 5.140625 14.074219 5.058594 14.074219 Z M 5.058594 14.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 4.609375 13.328125 C 4.609375 13.554688 4.609375 13.78125 4.609375 14.039062 C 4.53125 14.074219 4.457031 14.074219 4.351562 14.050781 C 4.273438 13.96875 4.230469 13.910156 4.183594 13.820312 C 4.160156 13.636719 4.136719 13.484375 4.144531 13.328125 C 4.320312 13.328125 4.464844 13.328125 4.609375 13.328125 Z M 4.609375 13.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 4.113281 13.328125 C 4.136719 13.484375 4.160156 13.636719 4.15625 13.820312 C 4.054688 13.925781 3.976562 14 3.898438 14.074219 C 3.847656 14.074219 3.792969 14.074219 3.714844 14.039062 C 3.6875 13.78125 3.6875 13.554688 3.6875 13.328125 C 3.6875 13.328125 3.6875 13.332031 3.714844 13.328125 C 3.867188 13.328125 3.992188 13.328125 4.113281 13.328125 Z M 4.113281 13.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 14.558594 14.074219 C 14.535156 13.847656 14.535156 13.621094 14.535156 13.363281 C 14.535156 13.328125 14.535156 13.328125 14.5625 13.328125 C 14.742188 13.328125 14.886719 13.328125 15.03125 13.363281 C 15.027344 13.519531 15.027344 13.648438 15.003906 13.777344 C 14.902344 13.878906 14.824219 13.976562 14.746094 14.074219 C 14.691406 14.074219 14.640625 14.074219 14.558594 14.074219 Z M 14.558594 14.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 19.070312 13.328125 C 19.070312 13.515625 19.046875 13.707031 19.078125 13.886719 C 19.117188 14.125 18.976562 14.070312 18.820312 14.050781 C 18.738281 13.941406 18.691406 13.859375 18.644531 13.742188 C 18.644531 13.585938 18.644531 13.457031 18.675781 13.328125 C 18.828125 13.328125 18.949219 13.328125 19.070312 13.328125 Z M 19.070312 13.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 1.417969 14.074219 C 1.34375 14.074219 1.265625 14.074219 1.160156 14.050781 C 1.085938 13.941406 1.039062 13.859375 0.992188 13.742188 C 0.992188 13.585938 0.992188 13.457031 0.992188 13.328125 C 0.992188 13.328125 0.992188 13.332031 1.023438 13.328125 C 1.175781 13.328125 1.296875 13.328125 1.417969 13.332031 C 1.417969 13.332031 1.417969 13.328125 1.417969 13.363281 C 1.417969 13.621094 1.417969 13.847656 1.417969 14.074219 Z M 1.417969 14.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 3.6875 13.328125 C 3.6875 13.554688 3.6875 13.78125 3.6875 14.039062 C 3.609375 14.074219 3.535156 14.074219 3.429688 14.050781 C 3.351562 13.941406 3.308594 13.859375 3.261719 13.746094 C 3.261719 13.585938 3.261719 13.457031 3.261719 13.328125 C 3.261719 13.328125 3.261719 13.332031 3.292969 13.328125 C 3.445312 13.328125 3.566406 13.328125 3.6875 13.328125 Z M 3.6875 13.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 15.027344 13.777344 C 15.027344 13.648438 15.027344 13.519531 15.03125 13.363281 C 15.03125 13.328125 15.03125 13.332031 15.058594 13.332031 C 15.210938 13.328125 15.332031 13.328125 15.457031 13.363281 C 15.457031 13.621094 15.457031 13.847656 15.457031 14.074219 C 15.378906 14.074219 15.304688 14.074219 15.199219 14.050781 C 15.121094 13.941406 15.074219 13.859375 15.027344 13.777344 Z M 15.027344 13.777344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 9.570312 13.332031 C 9.570312 13.554688 9.570312 13.78125 9.570312 14.039062 C 9.496094 14.074219 9.417969 14.074219 9.3125 14.050781 C 9.238281 13.941406 9.191406 13.859375 9.144531 13.742188 C 9.074219 13.320312 9.304688 13.300781 9.570312 13.332031 Z M 9.570312 13.332031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 13.1875 14.074219 C 13.109375 14.074219 13.035156 14.074219 12.929688 14.050781 C 12.851562 13.941406 12.808594 13.859375 12.761719 13.742188 C 12.761719 13.585938 12.761719 13.457031 12.792969 13.328125 C 12.945312 13.328125 13.066406 13.328125 13.1875 13.363281 C 13.1875 13.621094 13.1875 13.847656 13.1875 14.074219 Z M 13.1875 14.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 7.300781 13.328125 C 7.300781 13.554688 7.300781 13.78125 7.300781 14.039062 C 7.226562 14.074219 7.152344 14.074219 7.046875 14.050781 C 6.96875 13.941406 6.921875 13.859375 6.875 13.746094 C 6.875 13.585938 6.878906 13.457031 6.90625 13.328125 C 7.058594 13.328125 7.179688 13.328125 7.300781 13.328125 Z M 7.300781 13.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 5.527344 13.777344 C 5.527344 13.648438 5.527344 13.519531 5.53125 13.363281 C 5.53125 13.328125 5.53125 13.332031 5.558594 13.328125 C 5.710938 13.328125 5.832031 13.328125 5.957031 13.328125 C 5.957031 13.328125 5.953125 13.328125 5.953125 13.363281 C 5.957031 13.621094 5.957031 13.847656 5.957031 14.074219 C 5.878906 14.074219 5.804688 14.074219 5.699219 14.050781 C 5.621094 13.941406 5.574219 13.859375 5.527344 13.777344 Z M 5.527344 13.777344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 0.355469 14.074219 C 0.261719 14.074219 0.171875 14.074219 0.0703125 14.074219 C 0.0703125 13.851562 0.0703125 13.625 0.101562 13.367188 C 0.253906 13.328125 0.375 13.328125 0.496094 13.328125 C 0.496094 13.328125 0.496094 13.328125 0.496094 13.363281 C 0.496094 13.519531 0.496094 13.648438 0.484375 13.796875 C 0.429688 13.902344 0.394531 13.988281 0.355469 14.074219 Z M 0.355469 14.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 2.367188 14.074219 C 2.339844 13.847656 2.339844 13.621094 2.339844 13.363281 C 2.339844 13.328125 2.339844 13.332031 2.339844 13.332031 C 2.460938 13.332031 2.582031 13.328125 2.734375 13.328125 C 2.765625 13.328125 2.765625 13.328125 2.765625 13.363281 C 2.765625 13.519531 2.765625 13.648438 2.75 13.796875 C 2.675781 13.902344 2.613281 13.988281 2.550781 14.074219 C 2.5 14.074219 2.445312 14.074219 2.367188 14.074219 Z M 2.367188 14.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 15.480469 14.074219 C 15.457031 13.847656 15.457031 13.621094 15.457031 13.363281 C 15.457031 13.328125 15.453125 13.332031 15.484375 13.328125 C 15.636719 13.328125 15.757812 13.328125 15.882812 13.359375 C 15.882812 13.519531 15.882812 13.648438 15.867188 13.796875 C 15.792969 13.902344 15.730469 13.988281 15.667969 14.074219 C 15.613281 14.074219 15.5625 14.074219 15.480469 14.074219 Z M 15.480469 14.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 5.980469 14.074219 C 5.957031 13.847656 5.957031 13.621094 5.984375 13.363281 C 6.136719 13.328125 6.257812 13.328125 6.378906 13.363281 C 6.378906 13.519531 6.378906 13.648438 6.367188 13.796875 C 6.292969 13.902344 6.230469 13.988281 6.167969 14.074219 C 6.113281 14.074219 6.0625 14.074219 5.980469 14.074219 Z M 5.980469 14.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 1.445312 14.074219 C 1.417969 13.847656 1.417969 13.621094 1.417969 13.363281 C 1.679688 13.308594 1.917969 13.316406 1.824219 13.753906 C 1.746094 13.890625 1.6875 13.980469 1.628906 14.074219 C 1.578125 14.074219 1.523438 14.074219 1.445312 14.074219 Z M 1.445312 14.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 13.214844 14.074219 C 13.1875 13.847656 13.1875 13.621094 13.1875 13.363281 C 13.1875 13.328125 13.1875 13.332031 13.214844 13.328125 C 13.367188 13.328125 13.492188 13.332031 13.613281 13.328125 C 13.613281 13.457031 13.613281 13.585938 13.589844 13.753906 C 13.511719 13.890625 13.457031 13.980469 13.398438 14.074219 C 13.347656 14.074219 13.292969 14.074219 13.214844 14.074219 Z M 13.214844 14.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 19.070312 4.320312 C 19.070312 4.472656 19.070312 4.625 19.039062 4.808594 C 18.886719 4.839844 18.765625 4.839844 18.644531 4.820312 C 18.644531 4.800781 18.644531 4.765625 18.644531 4.734375 C 18.644531 4.574219 18.644531 4.445312 18.675781 4.320312 C 18.828125 4.320312 18.949219 4.320312 19.070312 4.320312 Z M 19.070312 4.320312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 0.0703125 5.289062 C 0.0703125 5.136719 0.0703125 4.984375 0.101562 4.796875 C 0.253906 4.765625 0.375 4.769531 0.496094 4.785156 C 0.496094 4.804688 0.496094 4.839844 0.496094 4.871094 C 0.496094 5.03125 0.496094 5.160156 0.464844 5.289062 C 0.3125 5.289062 0.191406 5.289062 0.0703125 5.289062 Z M 0.0703125 5.289062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 0.0703125 9.085938 C 0.0703125 8.933594 0.0703125 8.78125 0.101562 8.597656 C 0.253906 8.5625 0.375 8.5625 0.496094 8.597656 C 0.496094 8.78125 0.496094 8.933594 0.464844 9.085938 C 0.3125 9.085938 0.191406 9.085938 0.0703125 9.085938 Z M 0.0703125 9.085938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 19.070312 8.5625 C 19.070312 8.714844 19.070312 8.867188 19.039062 9.050781 C 18.886719 9.085938 18.765625 9.085938 18.644531 9.050781 C 18.644531 8.867188 18.644531 8.714844 18.675781 8.5625 C 18.828125 8.5625 18.949219 8.5625 19.070312 8.5625 Z M 19.070312 8.5625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 0.0703125 10.5 C 0.0703125 10.347656 0.0703125 10.195312 0.101562 10.011719 C 0.253906 9.980469 0.375 9.980469 0.496094 10.011719 C 0.496094 10.195312 0.496094 10.347656 0.496094 10.5 C 0.496094 10.5 0.496094 10.5 0.464844 10.5 C 0.3125 10.5 0.191406 10.5 0.0703125 10.5 Z M 0.0703125 10.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,98.823529%,98.823529%)",
      fillOpacity: 1
    },
    d: "M 19.070312 9.980469 C 19.070312 10.128906 19.070312 10.28125 19.039062 10.46875 C 18.886719 10.5 18.765625 10.5 18.644531 10.46875 C 18.644531 10.28125 18.644531 10.128906 18.675781 9.980469 C 18.828125 9.980469 18.949219 9.980469 19.070312 9.980469 Z M 19.070312 9.980469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 19.070312 6.179688 C 19.070312 6.332031 19.070312 6.484375 19.039062 6.667969 C 18.886719 6.703125 18.765625 6.703125 18.644531 6.671875 C 18.644531 6.511719 18.644531 6.382812 18.644531 6.238281 C 18.644531 6.21875 18.644531 6.183594 18.675781 6.183594 C 18.828125 6.183594 18.949219 6.179688 19.070312 6.179688 Z M 19.070312 6.179688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 0.0703125 7.671875 C 0.0703125 7.519531 0.0703125 7.367188 0.101562 7.179688 C 0.253906 7.148438 0.375 7.148438 0.496094 7.148438 C 0.496094 7.148438 0.496094 7.148438 0.496094 7.179688 C 0.496094 7.367188 0.496094 7.519531 0.464844 7.671875 C 0.3125 7.671875 0.191406 7.671875 0.0703125 7.671875 Z M 0.0703125 7.671875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,98.823529%,98.823529%)",
      fillOpacity: 1
    },
    d: "M 19.070312 7.148438 C 19.070312 7.300781 19.070312 7.453125 19.039062 7.636719 C 18.886719 7.671875 18.765625 7.671875 18.644531 7.636719 C 18.644531 7.453125 18.644531 7.300781 18.675781 7.148438 C 18.828125 7.148438 18.949219 7.148438 19.070312 7.148438 Z M 19.070312 7.148438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 0.0703125 1.042969 C 0.0703125 0.890625 0.0703125 0.738281 0.101562 0.554688 C 0.253906 0.523438 0.375 0.523438 0.496094 0.523438 C 0.496094 0.519531 0.496094 0.519531 0.496094 0.554688 C 0.496094 0.738281 0.496094 0.890625 0.496094 1.042969 C 0.496094 1.042969 0.496094 1.042969 0.464844 1.042969 C 0.3125 1.042969 0.191406 1.042969 0.0703125 1.042969 Z M 0.0703125 1.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 19.070312 1.9375 C 19.070312 2.089844 19.070312 2.242188 19.039062 2.425781 C 18.886719 2.457031 18.765625 2.457031 18.644531 2.425781 C 18.644531 2.242188 18.644531 2.089844 18.675781 1.9375 C 18.828125 1.9375 18.949219 1.9375 19.070312 1.9375 Z M 19.070312 1.9375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 19.070312 13.296875 C 18.949219 13.328125 18.828125 13.328125 18.675781 13.328125 C 18.644531 13.328125 18.644531 13.328125 18.644531 13.296875 C 18.644531 13.136719 18.644531 13.011719 18.644531 12.863281 C 18.644531 12.847656 18.644531 12.8125 18.675781 12.808594 C 18.828125 12.808594 18.949219 12.808594 19.070312 12.808594 C 19.070312 12.960938 19.070312 13.113281 19.070312 13.296875 Z M 19.070312 13.296875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 18.148438 0.0742188 C 18.292969 0.0742188 18.4375 0.0742188 18.613281 0.105469 C 18.644531 0.265625 18.644531 0.394531 18.644531 0.519531 C 18.644531 0.519531 18.644531 0.519531 18.613281 0.519531 C 18.4375 0.519531 18.292969 0.519531 18.148438 0.488281 C 18.148438 0.328125 18.148438 0.203125 18.148438 0.0742188 Z M 18.148438 0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 17.226562 0.0742188 C 17.371094 0.0742188 17.515625 0.0742188 17.691406 0.105469 C 17.722656 0.265625 17.722656 0.394531 17.695312 0.523438 C 17.542969 0.523438 17.421875 0.519531 17.28125 0.519531 C 17.265625 0.519531 17.230469 0.523438 17.230469 0.488281 C 17.226562 0.328125 17.226562 0.203125 17.226562 0.0742188 Z M 17.226562 0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 19.070312 0.519531 C 19.070312 0.671875 19.070312 0.824219 19.039062 1.011719 C 18.886719 1.042969 18.765625 1.042969 18.644531 1.011719 C 18.644531 0.824219 18.644531 0.671875 18.644531 0.519531 C 18.644531 0.519531 18.644531 0.519531 18.675781 0.519531 C 18.828125 0.519531 18.949219 0.519531 19.070312 0.519531 Z M 19.070312 0.519531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 6.378906 0.0742188 C 6.523438 0.0742188 6.671875 0.0742188 6.847656 0.105469 C 6.875 0.265625 6.875 0.394531 6.847656 0.519531 C 6.671875 0.519531 6.523438 0.519531 6.378906 0.488281 C 6.378906 0.328125 6.378906 0.203125 6.378906 0.0742188 Z M 6.378906 0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 12.265625 0.0742188 C 12.410156 0.0742188 12.554688 0.0742188 12.730469 0.105469 C 12.761719 0.265625 12.761719 0.394531 12.730469 0.519531 C 12.554688 0.519531 12.410156 0.519531 12.265625 0.519531 C 12.265625 0.519531 12.265625 0.523438 12.265625 0.488281 C 12.265625 0.328125 12.265625 0.203125 12.265625 0.0742188 Z M 12.265625 0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 0.0703125 12.882812 C 0.0703125 12.730469 0.0703125 12.578125 0.101562 12.394531 C 0.253906 12.363281 0.375 12.363281 0.496094 12.394531 C 0.496094 12.554688 0.496094 12.679688 0.496094 12.828125 C 0.496094 12.84375 0.496094 12.878906 0.464844 12.882812 C 0.3125 12.882812 0.191406 12.882812 0.0703125 12.882812 Z M 0.0703125 12.882812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 9.996094 0.0742188 C 10.140625 0.0742188 10.285156 0.0742188 10.460938 0.105469 C 10.492188 0.265625 10.492188 0.394531 10.492188 0.519531 C 10.492188 0.519531 10.492188 0.519531 10.460938 0.519531 C 10.285156 0.519531 10.140625 0.519531 9.996094 0.488281 C 9.996094 0.328125 9.996094 0.203125 9.996094 0.0742188 Z M 9.996094 0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 8.648438 0.0742188 C 8.792969 0.0742188 8.9375 0.0742188 9.113281 0.105469 C 9.144531 0.265625 9.144531 0.394531 9.113281 0.519531 C 8.9375 0.519531 8.792969 0.519531 8.648438 0.519531 C 8.648438 0.519531 8.648438 0.523438 8.648438 0.488281 C 8.648438 0.332031 8.648438 0.203125 8.648438 0.0742188 Z M 8.648438 0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 2.765625 0.0742188 C 2.910156 0.0742188 3.054688 0.0742188 3.230469 0.105469 C 3.261719 0.265625 3.261719 0.394531 3.230469 0.519531 C 3.054688 0.519531 2.910156 0.519531 2.765625 0.488281 C 2.765625 0.328125 2.765625 0.203125 2.765625 0.0742188 Z M 2.765625 0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 1.84375 0.0742188 C 1.988281 0.0742188 2.132812 0.0742188 2.308594 0.105469 C 2.339844 0.265625 2.339844 0.394531 2.308594 0.523438 C 2.15625 0.523438 2.035156 0.523438 1.898438 0.523438 C 1.878906 0.519531 1.84375 0.519531 1.84375 0.488281 C 1.84375 0.328125 1.84375 0.203125 1.84375 0.0742188 Z M 1.84375 0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 0.496094 0.0742188 C 0.640625 0.0742188 0.785156 0.0742188 0.960938 0.105469 C 0.992188 0.265625 0.992188 0.394531 0.960938 0.519531 C 0.785156 0.519531 0.640625 0.519531 0.496094 0.519531 C 0.496094 0.519531 0.496094 0.519531 0.496094 0.488281 C 0.496094 0.328125 0.496094 0.203125 0.496094 0.0742188 Z M 0.496094 0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 0.0703125 3.425781 C 0.0703125 3.273438 0.0703125 3.121094 0.101562 2.9375 C 0.253906 2.90625 0.375 2.90625 0.496094 2.90625 C 0.496094 2.90625 0.496094 2.902344 0.496094 2.9375 C 0.496094 3.09375 0.496094 3.222656 0.496094 3.371094 C 0.496094 3.386719 0.496094 3.421875 0.464844 3.425781 C 0.3125 3.425781 0.191406 3.425781 0.0703125 3.425781 Z M 0.0703125 3.425781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 13.613281 0.0742188 C 13.757812 0.0742188 13.902344 0.0742188 14.078125 0.105469 C 14.109375 0.265625 14.109375 0.394531 14.078125 0.523438 C 13.925781 0.519531 13.804688 0.519531 13.664062 0.519531 C 13.648438 0.519531 13.613281 0.523438 13.613281 0.488281 C 13.613281 0.328125 13.613281 0.203125 13.613281 0.0742188 Z M 13.613281 0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 19.070312 3.351562 C 19.070312 3.503906 19.070312 3.65625 19.039062 3.839844 C 18.886719 3.871094 18.765625 3.871094 18.644531 3.839844 C 18.644531 3.679688 18.644531 3.554688 18.644531 3.40625 C 18.644531 3.390625 18.644531 3.351562 18.675781 3.351562 C 18.828125 3.351562 18.949219 3.351562 19.070312 3.351562 Z M 19.070312 3.351562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 15.878906 0.0742188 C 16.023438 0.0742188 16.171875 0.0742188 16.347656 0.105469 C 16.375 0.265625 16.375 0.394531 16.347656 0.519531 C 16.171875 0.519531 16.023438 0.519531 15.878906 0.488281 C 15.878906 0.328125 15.878906 0.203125 15.878906 0.0742188 Z M 15.878906 0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 14.535156 0.0742188 C 14.679688 0.0742188 14.824219 0.0742188 15 0.105469 C 15.027344 0.265625 15.027344 0.394531 15.011719 0.519531 C 14.992188 0.519531 14.960938 0.519531 14.929688 0.519531 C 14.777344 0.523438 14.65625 0.523438 14.535156 0.488281 C 14.535156 0.328125 14.535156 0.203125 14.535156 0.0742188 Z M 14.535156 0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,98.823529%,98.823529%)",
      fillOpacity: 1
    },
    d: "M 15.699219 14.074219 C 15.730469 13.988281 15.792969 13.902344 15.898438 13.796875 C 16.085938 13.777344 16.230469 13.777344 16.375 13.777344 C 16.421875 13.859375 16.46875 13.941406 16.515625 14.050781 C 16.257812 14.074219 15.996094 14.074219 15.699219 14.074219 Z M 15.699219 14.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 12.761719 13.777344 C 12.808594 13.859375 12.851562 13.941406 12.902344 14.050781 C 12.640625 14.074219 12.378906 14.074219 12.085938 14.074219 C 12.113281 13.988281 12.175781 13.902344 12.28125 13.796875 C 12.472656 13.777344 12.617188 13.777344 12.761719 13.777344 Z M 12.761719 13.777344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.725491%,93.725491%,93.725491%)",
      fillOpacity: 1
    },
    d: "M 9.816406 14.074219 C 9.84375 13.988281 9.90625 13.902344 10.015625 13.796875 C 10.203125 13.777344 10.347656 13.777344 10.492188 13.777344 C 10.539062 13.859375 10.585938 13.941406 10.632812 14.050781 C 10.371094 14.074219 10.109375 14.074219 9.816406 14.074219 Z M 9.816406 14.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.725491%,93.725491%,93.725491%)",
      fillOpacity: 1
    },
    d: "M 2.585938 14.074219 C 2.613281 13.988281 2.675781 13.902344 2.78125 13.796875 C 2.972656 13.777344 3.117188 13.777344 3.261719 13.777344 C 3.308594 13.859375 3.351562 13.941406 3.402344 14.050781 C 3.140625 14.074219 2.878906 14.074219 2.585938 14.074219 Z M 2.585938 14.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.725491%,93.725491%,93.725491%)",
      fillOpacity: 1
    },
    d: "M 6.199219 14.074219 C 6.230469 13.988281 6.292969 13.902344 6.398438 13.796875 C 6.585938 13.777344 6.730469 13.777344 6.875 13.777344 C 6.921875 13.859375 6.96875 13.941406 7.015625 14.050781 C 6.757812 14.074219 6.496094 14.074219 6.199219 14.074219 Z M 6.199219 14.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,98.823529%,98.823529%)",
      fillOpacity: 1
    },
    d: "M 9.144531 13.777344 C 9.191406 13.859375 9.238281 13.941406 9.285156 14.050781 C 9.027344 14.074219 8.765625 14.074219 8.46875 14.074219 C 8.5 13.988281 8.5625 13.902344 8.667969 13.796875 C 8.855469 13.777344 9 13.777344 9.144531 13.777344 Z M 9.144531 13.777344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.725491%,93.725491%,93.725491%)",
      fillOpacity: 1
    },
    d: "M 18.644531 13.777344 C 18.691406 13.859375 18.738281 13.941406 18.785156 14.050781 C 18.527344 14.074219 18.265625 14.074219 17.96875 14.074219 C 18 13.988281 18.0625 13.902344 18.167969 13.796875 C 18.355469 13.777344 18.5 13.777344 18.644531 13.777344 Z M 18.644531 13.777344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 19.070312 10.945312 C 19.070312 11.097656 19.070312 11.25 19.042969 11.433594 C 18.890625 11.441406 18.769531 11.417969 18.644531 11.363281 C 18.644531 11.203125 18.644531 11.074219 18.675781 10.945312 C 18.828125 10.945312 18.949219 10.945312 19.070312 10.945312 Z M 19.070312 10.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 5.457031 0.0742188 C 5.605469 0.0742188 5.75 0.0742188 5.925781 0.105469 C 5.957031 0.265625 5.957031 0.394531 5.925781 0.523438 C 5.773438 0.523438 5.652344 0.523438 5.527344 0.492188 C 5.5 0.335938 5.480469 0.203125 5.457031 0.0742188 Z M 5.457031 0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 3.6875 0.0742188 C 3.832031 0.0742188 3.976562 0.0742188 4.152344 0.101562 C 4.160156 0.261719 4.136719 0.390625 4.082031 0.523438 C 3.929688 0.523438 3.808594 0.523438 3.6875 0.488281 C 3.6875 0.328125 3.6875 0.203125 3.6875 0.0742188 Z M 3.6875 0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 4.113281 0.523438 C 4.136719 0.390625 4.160156 0.261719 4.183594 0.101562 C 4.304688 0.0742188 4.425781 0.0742188 4.578125 0.105469 C 4.609375 0.265625 4.609375 0.394531 4.578125 0.523438 C 4.425781 0.519531 4.304688 0.519531 4.164062 0.519531 C 4.148438 0.519531 4.113281 0.523438 4.113281 0.523438 Z M 4.113281 0.523438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 5.429688 0.0742188 C 5.480469 0.203125 5.5 0.335938 5.527344 0.492188 C 5.53125 0.519531 5.53125 0.519531 5.5 0.519531 C 5.324219 0.519531 5.179688 0.519531 5.035156 0.488281 C 5.035156 0.328125 5.035156 0.203125 5.035156 0.0742188 C 5.15625 0.0742188 5.277344 0.0742188 5.429688 0.0742188 Z M 5.429688 0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 18.644531 11.394531 C 18.769531 11.417969 18.890625 11.441406 19.042969 11.46875 C 19.070312 11.597656 19.070312 11.722656 19.039062 11.882812 C 18.886719 11.914062 18.765625 11.914062 18.644531 11.882812 C 18.644531 11.699219 18.644531 11.546875 18.644531 11.394531 Z M 18.644531 11.394531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 0.460938 0.0742188 C 0.496094 0.203125 0.496094 0.328125 0.496094 0.488281 C 0.375 0.523438 0.253906 0.523438 0.101562 0.519531 C 0.0703125 0.378906 0.0703125 0.234375 0.0703125 0.0742188 C 0.1875 0.0742188 0.308594 0.0742188 0.460938 0.0742188 Z M 0.460938 0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 0.0703125 10.53125 C 0.191406 10.5 0.3125 10.5 0.464844 10.53125 C 0.496094 10.691406 0.496094 10.820312 0.496094 10.945312 C 0.496094 10.945312 0.496094 10.945312 0.464844 10.945312 C 0.3125 10.945312 0.191406 10.945312 0.0703125 10.945312 C 0.0703125 10.820312 0.0703125 10.691406 0.0703125 10.53125 Z M 0.0703125 10.53125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 18.644531 11.914062 C 18.765625 11.914062 18.886719 11.914062 19.039062 11.914062 C 19.070312 12.042969 19.070312 12.171875 19.039062 12.328125 C 18.886719 12.363281 18.765625 12.363281 18.644531 12.363281 C 18.644531 12.363281 18.644531 12.363281 18.644531 12.328125 C 18.644531 12.171875 18.644531 12.042969 18.644531 11.914062 Z M 18.644531 11.914062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 0.496094 12.359375 C 0.375 12.363281 0.253906 12.363281 0.101562 12.363281 C 0.0703125 12.234375 0.0703125 12.105469 0.0703125 11.945312 C 0.191406 11.914062 0.3125 11.914062 0.464844 11.914062 C 0.496094 11.914062 0.496094 11.914062 0.496094 11.945312 C 0.496094 12.105469 0.496094 12.234375 0.496094 12.363281 C 0.496094 12.363281 0.496094 12.359375 0.496094 12.359375 Z M 0.496094 12.359375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 19.070312 10.914062 C 18.949219 10.945312 18.828125 10.945312 18.675781 10.945312 C 18.644531 10.945312 18.644531 10.945312 18.644531 10.914062 C 18.644531 10.753906 18.644531 10.628906 18.644531 10.5 C 18.765625 10.5 18.886719 10.5 19.039062 10.5 C 19.070312 10.628906 19.070312 10.753906 19.070312 10.914062 Z M 19.070312 10.914062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 0.0703125 10.980469 C 0.191406 10.945312 0.3125 10.945312 0.464844 10.945312 C 0.523438 11.226562 0.503906 11.472656 0.101562 11.394531 C 0.0703125 11.265625 0.0703125 11.136719 0.0703125 10.980469 Z M 0.0703125 10.980469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 0.0703125 12.914062 C 0.191406 12.882812 0.3125 12.882812 0.464844 12.914062 C 0.496094 13.074219 0.496094 13.203125 0.496094 13.332031 C 0.375 13.328125 0.253906 13.328125 0.101562 13.328125 C 0.0703125 13.203125 0.0703125 13.074219 0.0703125 12.914062 Z M 0.0703125 12.914062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 18.644531 12.363281 C 18.765625 12.363281 18.886719 12.363281 19.039062 12.363281 C 19.070312 12.488281 19.070312 12.617188 19.070312 12.777344 C 18.949219 12.808594 18.828125 12.808594 18.675781 12.777344 C 18.644531 12.617188 18.644531 12.488281 18.644531 12.363281 Z M 18.644531 12.363281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 18.644531 2.457031 C 18.765625 2.457031 18.886719 2.457031 19.039062 2.457031 C 19.070312 2.585938 19.070312 2.710938 19.039062 2.871094 C 18.886719 2.902344 18.765625 2.902344 18.644531 2.902344 C 18.644531 2.902344 18.644531 2.90625 18.644531 2.871094 C 18.644531 2.710938 18.644531 2.585938 18.644531 2.457031 Z M 18.644531 2.457031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 0.496094 2.871094 C 0.375 2.90625 0.253906 2.90625 0.101562 2.902344 C 0.0703125 2.777344 0.0703125 2.648438 0.0703125 2.488281 C 0.339844 2.429688 0.570312 2.449219 0.496094 2.871094 Z M 0.496094 2.871094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 19.070312 1.902344 C 18.949219 1.9375 18.828125 1.9375 18.675781 1.9375 C 18.644531 1.9375 18.644531 1.9375 18.644531 1.90625 C 18.644531 1.746094 18.644531 1.617188 18.675781 1.488281 C 18.828125 1.488281 18.949219 1.488281 19.070312 1.488281 C 19.070312 1.617188 19.070312 1.746094 19.070312 1.902344 Z M 19.070312 1.902344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 0.0703125 4.320312 C 0.0703125 4.191406 0.0703125 4.0625 0.101562 3.902344 C 0.253906 3.871094 0.375 3.871094 0.496094 3.871094 C 0.496094 3.871094 0.496094 3.871094 0.496094 3.902344 C 0.496094 4.0625 0.496094 4.191406 0.496094 4.320312 C 0.496094 4.320312 0.496094 4.320312 0.464844 4.320312 C 0.3125 4.320312 0.191406 4.320312 0.0703125 4.320312 Z M 0.0703125 4.320312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 0.496094 3.871094 C 0.375 3.871094 0.253906 3.871094 0.101562 3.871094 C 0.0703125 3.746094 0.0703125 3.617188 0.0703125 3.457031 C 0.191406 3.425781 0.3125 3.425781 0.464844 3.457031 C 0.496094 3.617188 0.496094 3.746094 0.496094 3.871094 Z M 0.496094 3.871094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 18.644531 2.902344 C 18.765625 2.902344 18.886719 2.902344 19.039062 2.902344 C 19.070312 3.03125 19.070312 3.160156 19.070312 3.320312 C 18.949219 3.351562 18.828125 3.351562 18.675781 3.320312 C 18.644531 3.160156 18.644531 3.03125 18.644531 2.902344 Z M 18.644531 2.902344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 10.492188 0.519531 C 10.492188 0.394531 10.492188 0.265625 10.492188 0.105469 C 10.613281 0.0742188 10.734375 0.0742188 10.886719 0.0742188 C 10.917969 0.203125 10.917969 0.328125 10.886719 0.488281 C 10.734375 0.519531 10.613281 0.519531 10.492188 0.519531 Z M 10.492188 0.519531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 19.070312 0.484375 C 18.949219 0.519531 18.828125 0.519531 18.675781 0.523438 C 18.644531 0.394531 18.644531 0.265625 18.644531 0.105469 C 18.78125 0.0742188 18.917969 0.0742188 19.070312 0.0742188 C 19.070312 0.199219 19.070312 0.324219 19.070312 0.484375 Z M 19.070312 0.484375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 17.722656 0.523438 C 17.722656 0.394531 17.722656 0.265625 17.722656 0.105469 C 17.84375 0.0742188 17.96875 0.0742188 18.117188 0.0742188 C 18.148438 0.203125 18.148438 0.328125 18.148438 0.488281 C 18.148438 0.519531 18.148438 0.519531 18.117188 0.519531 C 17.96875 0.519531 17.84375 0.519531 17.722656 0.519531 C 17.722656 0.519531 17.722656 0.523438 17.722656 0.523438 Z M 17.722656 0.523438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 17.195312 0.0742188 C 17.226562 0.203125 17.226562 0.328125 17.199219 0.488281 C 17.046875 0.523438 16.925781 0.523438 16.800781 0.488281 C 16.800781 0.328125 16.800781 0.203125 16.800781 0.0742188 C 16.921875 0.0742188 17.046875 0.0742188 17.195312 0.0742188 Z M 17.195312 0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 16.773438 0.0742188 C 16.800781 0.203125 16.800781 0.328125 16.800781 0.488281 C 16.800781 0.519531 16.800781 0.519531 16.773438 0.519531 C 16.621094 0.519531 16.5 0.519531 16.375 0.519531 C 16.375 0.394531 16.375 0.265625 16.375 0.105469 C 16.5 0.0742188 16.621094 0.0742188 16.773438 0.0742188 Z M 16.773438 0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 15.851562 0.0742188 C 15.878906 0.203125 15.878906 0.328125 15.878906 0.488281 C 15.878906 0.519531 15.878906 0.519531 15.851562 0.519531 C 15.699219 0.519531 15.578125 0.519531 15.457031 0.519531 C 15.457031 0.519531 15.457031 0.519531 15.457031 0.488281 C 15.457031 0.328125 15.457031 0.203125 15.457031 0.0742188 C 15.578125 0.0742188 15.699219 0.0742188 15.851562 0.0742188 Z M 15.851562 0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 15.425781 0.0742188 C 15.457031 0.203125 15.457031 0.328125 15.425781 0.488281 C 15.273438 0.519531 15.148438 0.523438 15.027344 0.523438 C 15.027344 0.394531 15.027344 0.265625 15.03125 0.105469 C 15.152344 0.0742188 15.273438 0.0742188 15.425781 0.0742188 Z M 15.425781 0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 14.503906 0.0742188 C 14.535156 0.203125 14.535156 0.328125 14.535156 0.488281 C 14.535156 0.519531 14.535156 0.519531 14.503906 0.519531 C 14.351562 0.519531 14.230469 0.519531 14.109375 0.519531 C 14.109375 0.519531 14.109375 0.523438 14.109375 0.523438 C 14.109375 0.394531 14.109375 0.265625 14.109375 0.105469 C 14.230469 0.0742188 14.351562 0.0742188 14.503906 0.0742188 Z M 14.503906 0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 13.582031 0.0742188 C 13.613281 0.203125 13.613281 0.328125 13.582031 0.488281 C 13.429688 0.523438 13.308594 0.523438 13.1875 0.488281 C 13.1875 0.328125 13.1875 0.203125 13.1875 0.0742188 C 13.308594 0.0742188 13.429688 0.0742188 13.582031 0.0742188 Z M 13.582031 0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 13.15625 0.0742188 C 13.1875 0.203125 13.1875 0.328125 13.1875 0.488281 C 13.1875 0.519531 13.1875 0.519531 13.15625 0.519531 C 13.003906 0.519531 12.882812 0.519531 12.761719 0.519531 C 12.761719 0.394531 12.761719 0.265625 12.761719 0.105469 C 12.882812 0.0742188 13.003906 0.0742188 13.15625 0.0742188 Z M 13.15625 0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 12.234375 0.0742188 C 12.265625 0.203125 12.265625 0.328125 12.234375 0.488281 C 12.082031 0.519531 11.960938 0.519531 11.839844 0.519531 C 11.839844 0.519531 11.839844 0.519531 11.839844 0.488281 C 11.839844 0.328125 11.839844 0.203125 11.839844 0.0742188 C 11.960938 0.0742188 12.082031 0.0742188 12.234375 0.0742188 Z M 12.234375 0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 11.808594 0.0742188 C 11.839844 0.203125 11.839844 0.328125 11.839844 0.488281 C 11.574219 0.546875 11.339844 0.53125 11.414062 0.105469 C 11.535156 0.0742188 11.65625 0.0742188 11.808594 0.0742188 Z M 11.808594 0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 0.0703125 1.074219 C 0.191406 1.042969 0.3125 1.042969 0.464844 1.074219 C 0.496094 1.234375 0.496094 1.363281 0.496094 1.488281 C 0.496094 1.488281 0.496094 1.488281 0.464844 1.488281 C 0.3125 1.488281 0.191406 1.488281 0.0703125 1.488281 C 0.0703125 1.363281 0.0703125 1.234375 0.0703125 1.074219 Z M 0.0703125 1.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 9.964844 0.0742188 C 9.996094 0.203125 9.996094 0.328125 9.996094 0.488281 C 9.996094 0.519531 9.996094 0.519531 9.964844 0.519531 C 9.8125 0.519531 9.691406 0.519531 9.570312 0.488281 C 9.570312 0.328125 9.570312 0.203125 9.570312 0.0742188 C 9.691406 0.0742188 9.8125 0.0742188 9.964844 0.0742188 Z M 9.964844 0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 9.539062 0.0742188 C 9.570312 0.203125 9.570312 0.328125 9.570312 0.488281 C 9.570312 0.519531 9.570312 0.519531 9.539062 0.523438 C 9.390625 0.523438 9.265625 0.523438 9.144531 0.523438 C 9.144531 0.519531 9.144531 0.519531 9.144531 0.519531 C 9.144531 0.394531 9.144531 0.265625 9.144531 0.105469 C 9.265625 0.0742188 9.386719 0.0742188 9.539062 0.0742188 Z M 9.539062 0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 8.617188 0.0742188 C 8.648438 0.203125 8.648438 0.332031 8.617188 0.488281 C 8.46875 0.523438 8.34375 0.523438 8.222656 0.519531 C 8.222656 0.519531 8.222656 0.519531 8.222656 0.488281 C 8.222656 0.328125 8.222656 0.203125 8.222656 0.0742188 C 8.34375 0.0742188 8.46875 0.0742188 8.617188 0.0742188 Z M 8.617188 0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 8.195312 0.0742188 C 8.222656 0.203125 8.222656 0.328125 8.222656 0.488281 C 7.957031 0.546875 7.726562 0.53125 7.796875 0.105469 C 7.921875 0.0742188 8.042969 0.0742188 8.195312 0.0742188 Z M 8.195312 0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 6.878906 0.519531 C 6.875 0.394531 6.875 0.265625 6.875 0.105469 C 7 0.0742188 7.121094 0.0742188 7.273438 0.0742188 C 7.300781 0.203125 7.300781 0.328125 7.300781 0.488281 C 7.300781 0.519531 7.300781 0.519531 7.273438 0.519531 C 7.121094 0.519531 7 0.519531 6.875 0.519531 C 6.875 0.519531 6.878906 0.519531 6.878906 0.519531 Z M 6.878906 0.519531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 5.957031 0.523438 C 5.957031 0.394531 5.957031 0.265625 5.957031 0.105469 C 6.078125 0.0742188 6.199219 0.0742188 6.351562 0.0742188 C 6.378906 0.203125 6.378906 0.328125 6.378906 0.488281 C 6.378906 0.519531 6.378906 0.519531 6.351562 0.519531 C 6.199219 0.519531 6.078125 0.519531 5.953125 0.519531 C 5.957031 0.519531 5.957031 0.523438 5.957031 0.523438 Z M 5.957031 0.523438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 5.003906 0.0742188 C 5.035156 0.203125 5.035156 0.328125 5.035156 0.488281 C 5.035156 0.519531 5.035156 0.519531 5.003906 0.519531 C 4.851562 0.519531 4.730469 0.519531 4.609375 0.519531 C 4.609375 0.519531 4.609375 0.523438 4.609375 0.523438 C 4.609375 0.394531 4.609375 0.265625 4.609375 0.105469 C 4.730469 0.0742188 4.851562 0.0742188 5.003906 0.0742188 Z M 5.003906 0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 3.65625 0.0742188 C 3.6875 0.203125 3.6875 0.328125 3.6875 0.488281 C 3.6875 0.519531 3.6875 0.519531 3.65625 0.519531 C 3.503906 0.519531 3.382812 0.519531 3.261719 0.519531 C 3.261719 0.394531 3.261719 0.265625 3.261719 0.105469 C 3.382812 0.0742188 3.503906 0.0742188 3.65625 0.0742188 Z M 3.65625 0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 2.339844 0.523438 C 2.339844 0.394531 2.339844 0.265625 2.339844 0.105469 C 2.460938 0.0742188 2.582031 0.0742188 2.734375 0.0742188 C 2.765625 0.203125 2.765625 0.328125 2.765625 0.488281 C 2.765625 0.519531 2.765625 0.519531 2.734375 0.519531 C 2.582031 0.519531 2.460938 0.519531 2.339844 0.519531 C 2.339844 0.519531 2.339844 0.523438 2.339844 0.523438 Z M 2.339844 0.523438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 1.8125 0.0742188 C 1.84375 0.203125 1.84375 0.328125 1.8125 0.488281 C 1.660156 0.519531 1.539062 0.519531 1.417969 0.488281 C 1.417969 0.328125 1.417969 0.203125 1.417969 0.0742188 C 1.539062 0.0742188 1.660156 0.0742188 1.8125 0.0742188 Z M 1.8125 0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 1.386719 0.0742188 C 1.417969 0.203125 1.417969 0.328125 1.417969 0.488281 C 1.417969 0.519531 1.417969 0.519531 1.386719 0.519531 C 1.234375 0.519531 1.113281 0.519531 0.992188 0.519531 C 0.992188 0.394531 0.992188 0.265625 0.992188 0.105469 C 1.113281 0.0742188 1.234375 0.0742188 1.386719 0.0742188 Z M 1.386719 0.0742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 0.0703125 1.519531 C 0.191406 1.488281 0.3125 1.488281 0.464844 1.488281 C 0.523438 1.769531 0.503906 2.011719 0.101562 1.9375 C 0.0703125 1.808594 0.0703125 1.679688 0.0703125 1.519531 Z M 0.0703125 1.519531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 19.070312 1.457031 C 18.949219 1.488281 18.828125 1.488281 18.675781 1.488281 C 18.644531 1.488281 18.644531 1.488281 18.644531 1.457031 C 18.644531 1.296875 18.644531 1.171875 18.644531 1.042969 C 18.765625 1.042969 18.886719 1.042969 19.039062 1.042969 C 19.070312 1.171875 19.070312 1.296875 19.070312 1.457031 Z M 19.070312 1.457031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 0.496094 8.5625 C 0.375 8.5625 0.253906 8.5625 0.101562 8.5625 C 0.0703125 8.4375 0.0703125 8.308594 0.101562 8.148438 C 0.253906 8.117188 0.375 8.117188 0.496094 8.148438 C 0.496094 8.308594 0.496094 8.4375 0.496094 8.5625 Z M 0.496094 8.5625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 18.644531 7.671875 C 18.765625 7.671875 18.886719 7.671875 19.039062 7.671875 C 19.070312 7.796875 19.070312 7.925781 19.039062 8.085938 C 18.886719 8.117188 18.765625 8.117188 18.644531 8.085938 C 18.644531 7.925781 18.644531 7.796875 18.644531 7.671875 Z M 18.644531 7.671875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 0.496094 8.117188 C 0.375 8.117188 0.253906 8.117188 0.101562 8.117188 C 0.0703125 7.988281 0.0703125 7.863281 0.0703125 7.703125 C 0.191406 7.671875 0.3125 7.671875 0.464844 7.671875 C 0.496094 7.671875 0.496094 7.671875 0.496094 7.703125 C 0.496094 7.863281 0.496094 7.988281 0.496094 8.117188 Z M 0.496094 8.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 19.070312 7.117188 C 18.949219 7.148438 18.828125 7.148438 18.675781 7.148438 C 18.644531 7.148438 18.644531 7.148438 18.644531 7.117188 C 18.644531 6.957031 18.644531 6.828125 18.644531 6.703125 C 18.765625 6.703125 18.886719 6.703125 19.039062 6.703125 C 19.070312 6.828125 19.070312 6.957031 19.070312 7.117188 Z M 19.070312 7.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 19.070312 9.945312 C 18.949219 9.980469 18.828125 9.980469 18.675781 9.980469 C 18.644531 9.980469 18.644531 9.980469 18.644531 9.945312 C 18.644531 9.789062 18.644531 9.660156 18.675781 9.53125 C 18.828125 9.53125 18.949219 9.53125 19.070312 9.53125 C 19.070312 9.660156 19.070312 9.789062 19.070312 9.945312 Z M 19.070312 9.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 0.496094 9.980469 C 0.375 9.980469 0.253906 9.980469 0.101562 9.980469 C 0.0703125 9.851562 0.0703125 9.722656 0.101562 9.5625 C 0.253906 9.53125 0.375 9.53125 0.496094 9.5625 C 0.496094 9.722656 0.496094 9.851562 0.496094 9.980469 Z M 0.496094 9.980469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 19.070312 9.5 C 18.949219 9.53125 18.828125 9.53125 18.675781 9.53125 C 18.644531 9.53125 18.644531 9.53125 18.644531 9.5 C 18.644531 9.339844 18.644531 9.210938 18.644531 9.085938 C 18.765625 9.085938 18.886719 9.085938 19.039062 9.085938 C 19.070312 9.210938 19.070312 9.339844 19.070312 9.5 Z M 19.070312 9.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 18.644531 3.871094 C 18.765625 3.871094 18.886719 3.871094 19.039062 3.871094 C 19.070312 4 19.070312 4.128906 19.070312 4.289062 C 18.949219 4.320312 18.828125 4.320312 18.675781 4.320312 C 18.644531 4.320312 18.644531 4.320312 18.644531 4.289062 C 18.644531 4.128906 18.644531 4 18.644531 3.871094 Z M 18.644531 3.871094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 0.496094 9.53125 C 0.375 9.53125 0.253906 9.53125 0.101562 9.53125 C 0.0703125 9.402344 0.0703125 9.277344 0.0703125 9.117188 C 0.191406 9.085938 0.3125 9.085938 0.464844 9.085938 C 0.496094 9.085938 0.496094 9.085938 0.496094 9.117188 C 0.496094 9.277344 0.496094 9.40625 0.496094 9.53125 Z M 0.496094 9.53125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 18.644531 8.117188 C 18.765625 8.117188 18.886719 8.117188 19.039062 8.117188 C 19.070312 8.246094 19.070312 8.371094 19.070312 8.53125 C 18.949219 8.5625 18.828125 8.5625 18.675781 8.5625 C 18.644531 8.5625 18.644531 8.5625 18.644531 8.53125 C 18.644531 8.371094 18.644531 8.246094 18.644531 8.117188 Z M 18.644531 8.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 19.070312 5.289062 C 19.070312 5.414062 19.070312 5.542969 19.039062 5.703125 C 18.886719 5.734375 18.765625 5.734375 18.644531 5.734375 C 18.644531 5.734375 18.644531 5.734375 18.644531 5.703125 C 18.644531 5.542969 18.644531 5.414062 18.644531 5.285156 C 18.644531 5.289062 18.644531 5.289062 18.675781 5.289062 C 18.828125 5.289062 18.949219 5.289062 19.070312 5.289062 Z M 19.070312 5.289062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 0.0703125 5.320312 C 0.191406 5.289062 0.3125 5.289062 0.464844 5.289062 C 0.496094 5.289062 0.496094 5.285156 0.496094 5.320312 C 0.496094 5.480469 0.496094 5.605469 0.496094 5.734375 C 0.375 5.734375 0.253906 5.734375 0.101562 5.734375 C 0.0703125 5.605469 0.0703125 5.480469 0.0703125 5.320312 Z M 0.0703125 5.320312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 19.070312 5.253906 C 18.949219 5.289062 18.828125 5.289062 18.675781 5.253906 C 18.644531 5.09375 18.644531 4.964844 18.644531 4.839844 C 18.765625 4.839844 18.886719 4.839844 19.039062 4.839844 C 19.070312 4.96875 19.070312 5.097656 19.070312 5.253906 Z M 19.070312 5.253906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 0.496094 7.148438 C 0.375 7.148438 0.253906 7.148438 0.101562 7.148438 C 0.0703125 7.019531 0.0703125 6.894531 0.101562 6.734375 C 0.253906 6.703125 0.375 6.703125 0.496094 6.703125 C 0.496094 6.703125 0.496094 6.703125 0.496094 6.734375 C 0.496094 6.894531 0.496094 7.019531 0.496094 7.148438 Z M 0.496094 7.148438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 0.0703125 4.351562 C 0.191406 4.320312 0.3125 4.320312 0.464844 4.351562 C 0.496094 4.511719 0.496094 4.640625 0.496094 4.769531 C 0.375 4.769531 0.253906 4.765625 0.101562 4.765625 C 0.0703125 4.636719 0.0703125 4.511719 0.0703125 4.351562 Z M 0.0703125 4.351562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 0.496094 6.671875 C 0.375 6.703125 0.253906 6.703125 0.101562 6.703125 C 0.0703125 6.574219 0.0703125 6.445312 0.0703125 6.289062 C 0.339844 6.226562 0.570312 6.246094 0.496094 6.671875 Z M 0.496094 6.671875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 18.644531 5.734375 C 18.765625 5.734375 18.886719 5.734375 19.039062 5.734375 C 19.070312 5.863281 19.070312 5.988281 19.070312 6.148438 C 18.949219 6.179688 18.828125 6.183594 18.675781 6.152344 C 18.644531 5.992188 18.644531 5.863281 18.644531 5.734375 Z M 18.644531 5.734375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 0.992188 13.777344 C 1.039062 13.859375 1.085938 13.941406 1.132812 14.050781 C 0.964844 14.074219 0.796875 14.074219 0.597656 14.042969 C 0.566406 13.933594 0.566406 13.855469 0.597656 13.777344 C 0.75 13.777344 0.871094 13.777344 0.992188 13.777344 Z M 0.992188 13.777344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.470588%,96.470588%,96.470588%)",
      fillOpacity: 1
    },
    d: "M 5.503906 13.777344 C 5.574219 13.859375 5.621094 13.941406 5.667969 14.050781 C 5.550781 14.074219 5.429688 14.074219 5.277344 14.074219 C 5.324219 13.976562 5.402344 13.878906 5.503906 13.777344 Z M 5.503906 13.777344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.078432%,96.078432%,96.470588%)",
      fillOpacity: 1
    },
    d: "M 13.429688 14.074219 C 13.457031 13.980469 13.511719 13.890625 13.589844 13.789062 C 13.683594 13.859375 13.75 13.941406 13.824219 14.050781 C 13.703125 14.074219 13.582031 14.074219 13.429688 14.074219 Z M 13.429688 14.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.470588%,96.470588%,96.470588%)",
      fillOpacity: 1
    },
    d: "M 1.660156 14.074219 C 1.6875 13.980469 1.746094 13.890625 1.824219 13.785156 C 1.914062 13.859375 1.984375 13.941406 2.054688 14.050781 C 1.933594 14.074219 1.8125 14.074219 1.660156 14.074219 Z M 1.660156 14.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.078432%,96.078432%,96.470588%)",
      fillOpacity: 1
    },
    d: "M 15.003906 13.777344 C 15.074219 13.859375 15.121094 13.941406 15.167969 14.050781 C 15.050781 14.074219 14.929688 14.074219 14.777344 14.074219 C 14.824219 13.976562 14.902344 13.878906 15.003906 13.777344 Z M 15.003906 13.777344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.470588%,96.470588%,96.470588%)",
      fillOpacity: 1
    },
    d: "M 3.929688 14.074219 C 3.976562 14 4.054688 13.925781 4.15625 13.851562 C 4.230469 13.910156 4.273438 13.96875 4.324219 14.050781 C 4.203125 14.074219 4.082031 14.074219 3.929688 14.074219 Z M 3.929688 14.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.470588%,96.470588%,96.470588%)",
      fillOpacity: 1
    },
    d: "M 0.566406 13.777344 C 0.566406 13.855469 0.566406 13.933594 0.566406 14.042969 C 0.515625 14.074219 0.460938 14.074219 0.382812 14.074219 C 0.394531 13.988281 0.429688 13.902344 0.5 13.796875 C 0.53125 13.777344 0.566406 13.777344 0.566406 13.777344 Z M 0.566406 13.777344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 0.496094 13.328125 C 0.496094 13.203125 0.496094 13.074219 0.496094 12.914062 C 0.496094 12.878906 0.496094 12.84375 0.527344 12.828125 C 0.703125 12.808594 0.847656 12.808594 0.992188 12.808594 C 0.992188 12.808594 0.992188 12.84375 0.992188 12.894531 C 0.992188 13.074219 0.992188 13.203125 0.992188 13.332031 C 0.992188 13.332031 0.992188 13.328125 0.960938 13.328125 C 0.785156 13.328125 0.640625 13.328125 0.496094 13.328125 Z M 0.496094 13.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 2.765625 12.882812 C 2.765625 12.882812 2.765625 12.847656 2.765625 12.796875 C 2.765625 12.617188 2.765625 12.488281 2.796875 12.363281 C 2.972656 12.363281 3.117188 12.363281 3.261719 12.394531 C 3.261719 12.554688 3.261719 12.683594 3.261719 12.828125 C 3.261719 12.847656 3.261719 12.882812 3.230469 12.882812 C 3.054688 12.882812 2.910156 12.882812 2.765625 12.882812 Z M 2.765625 12.882812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 2.765625 12.914062 C 2.910156 12.882812 3.054688 12.882812 3.230469 12.914062 C 3.261719 13.074219 3.261719 13.203125 3.261719 13.332031 C 3.261719 13.332031 3.261719 13.328125 3.230469 13.328125 C 3.054688 13.328125 2.910156 13.328125 2.765625 13.328125 C 2.765625 13.203125 2.765625 13.074219 2.765625 12.914062 Z M 2.765625 12.914062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 0.992188 12.777344 C 0.847656 12.808594 0.703125 12.808594 0.527344 12.808594 C 0.496094 12.679688 0.496094 12.554688 0.496094 12.394531 C 0.496094 12.359375 0.496094 12.363281 0.527344 12.363281 C 0.703125 12.363281 0.847656 12.363281 0.992188 12.363281 C 0.992188 12.363281 0.992188 12.359375 0.992188 12.359375 C 0.992188 12.488281 0.992188 12.617188 0.992188 12.777344 Z M 0.992188 12.777344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 1.914062 11.914062 C 1.769531 11.914062 1.625 11.914062 1.449219 11.914062 C 1.417969 11.914062 1.417969 11.914062 1.417969 11.882812 C 1.417969 11.722656 1.417969 11.597656 1.449219 11.46875 C 1.601562 11.46875 1.722656 11.46875 1.847656 11.496094 C 1.871094 11.65625 1.890625 11.785156 1.914062 11.914062 Z M 1.914062 11.914062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 2.765625 12.363281 C 2.765625 12.488281 2.765625 12.617188 2.765625 12.777344 C 2.5 12.832031 2.265625 12.820312 2.339844 12.394531 C 2.339844 12.363281 2.339844 12.363281 2.371094 12.363281 C 2.523438 12.363281 2.644531 12.363281 2.765625 12.363281 Z M 2.765625 12.363281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 1.417969 12.363281 C 1.441406 12.363281 1.464844 12.359375 1.488281 12.363281 C 1.632812 12.382812 1.859375 12.28125 1.832031 12.574219 C 1.824219 12.65625 1.71875 12.785156 1.644531 12.796875 C 1.347656 12.84375 1.433594 12.59375 1.417969 12.394531 C 1.417969 12.363281 1.417969 12.363281 1.417969 12.363281 Z M 1.417969 12.363281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 1.417969 12.363281 C 1.296875 12.363281 1.175781 12.363281 1.023438 12.363281 C 0.992188 12.359375 0.992188 12.363281 0.992188 12.328125 C 0.992188 12.171875 0.992188 12.042969 0.992188 11.914062 C 0.992188 11.914062 0.992188 11.914062 1.023438 11.914062 C 1.175781 11.914062 1.296875 11.914062 1.417969 11.914062 C 1.417969 12.042969 1.417969 12.171875 1.417969 12.332031 C 1.417969 12.363281 1.417969 12.363281 1.417969 12.363281 Z M 1.417969 12.363281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 2.339844 12.363281 C 2.070312 12.390625 1.839844 12.371094 1.914062 11.945312 C 1.914062 11.914062 1.914062 11.914062 1.945312 11.914062 C 2.097656 11.914062 2.21875 11.914062 2.339844 11.945312 C 2.339844 12.105469 2.339844 12.234375 2.339844 12.363281 Z M 2.339844 12.363281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 2.339844 13.328125 C 2.316406 13.328125 2.292969 13.332031 2.269531 13.328125 C 2.125 13.308594 1.898438 13.410156 1.921875 13.117188 C 1.929688 13.035156 2.039062 12.90625 2.113281 12.894531 C 2.410156 12.847656 2.324219 13.097656 2.339844 13.296875 C 2.339844 13.332031 2.339844 13.328125 2.339844 13.328125 Z M 2.339844 13.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 1.023438 13.328125 C 0.992188 13.203125 0.992188 13.074219 0.992188 12.914062 C 1.257812 12.859375 1.492188 12.871094 1.417969 13.296875 C 1.296875 13.328125 1.175781 13.328125 1.023438 13.328125 Z M 1.023438 13.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 0.992188 2.457031 C 0.910156 2.457031 0.808594 2.488281 0.75 2.449219 C 0.652344 2.382812 0.550781 2.285156 0.511719 2.175781 C 0.496094 2.128906 0.65625 1.941406 0.703125 1.957031 C 0.808594 1.984375 0.910156 2.082031 0.984375 2.179688 C 1.019531 2.222656 0.992188 2.320312 0.992188 2.425781 C 0.992188 2.457031 0.992188 2.457031 0.992188 2.457031 Z M 0.992188 2.457031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 1.417969 2.457031 C 1.417969 2.304688 1.417969 2.152344 1.417969 1.96875 C 1.417969 1.9375 1.417969 1.9375 1.449219 1.9375 C 1.601562 1.9375 1.722656 1.9375 1.84375 1.96875 C 1.84375 2.152344 1.84375 2.304688 1.8125 2.457031 C 1.660156 2.457031 1.539062 2.457031 1.417969 2.457031 Z M 1.417969 2.457031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 0.527344 1.488281 C 0.496094 1.363281 0.496094 1.234375 0.496094 1.074219 C 0.496094 1.042969 0.496094 1.042969 0.527344 1.042969 C 0.703125 1.042969 0.847656 1.042969 0.992188 1.042969 C 0.992188 1.042969 0.992188 1.042969 0.992188 1.074219 C 0.992188 1.234375 0.992188 1.363281 0.992188 1.488281 C 0.847656 1.488281 0.703125 1.488281 0.527344 1.488281 Z M 0.527344 1.488281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 0.496094 3.351562 C 0.496094 3.222656 0.496094 3.09375 0.496094 2.9375 C 0.640625 2.902344 0.785156 2.90625 0.960938 2.90625 C 0.992188 2.902344 0.992188 2.902344 0.992188 2.9375 C 0.992188 3.097656 0.992188 3.222656 0.960938 3.351562 C 0.785156 3.351562 0.640625 3.351562 0.496094 3.351562 Z M 0.496094 3.351562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 0.992188 2.457031 C 1.113281 2.457031 1.234375 2.457031 1.386719 2.457031 C 1.417969 2.457031 1.417969 2.457031 1.417969 2.488281 C 1.417969 2.648438 1.417969 2.777344 1.417969 2.90625 C 1.417969 2.902344 1.417969 2.902344 1.386719 2.902344 C 1.234375 2.902344 1.113281 2.902344 0.992188 2.902344 C 0.992188 2.902344 0.992188 2.902344 0.992188 2.90625 C 0.992188 2.777344 0.992188 2.648438 0.992188 2.488281 C 0.992188 2.457031 0.992188 2.457031 0.992188 2.457031 Z M 0.992188 2.457031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 1.417969 1.9375 C 1.148438 1.964844 0.917969 1.945312 0.992188 1.519531 C 0.992188 1.488281 0.992188 1.488281 1.023438 1.488281 C 1.175781 1.488281 1.296875 1.488281 1.417969 1.519531 C 1.417969 1.679688 1.417969 1.808594 1.417969 1.9375 Z M 1.417969 1.9375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(84.313726%,1.176471%,15.686275%)",
      fillOpacity: 1
    },
    d: "M 10.917969 1.171875 C 11.066406 1.222656 11.214844 1.273438 11.410156 1.335938 C 11.585938 1.394531 11.710938 1.4375 11.859375 1.5 C 12.160156 1.679688 12.441406 1.835938 12.738281 2.011719 C 12.894531 2.128906 13.039062 2.226562 13.1875 2.339844 C 13.214844 2.375 13.234375 2.382812 13.269531 2.402344 C 13.316406 2.449219 13.359375 2.480469 13.421875 2.519531 C 13.582031 2.699219 13.71875 2.867188 13.824219 3.039062 C 11.625 3.046875 9.464844 3.050781 7.300781 3.050781 C 6.628906 3.050781 5.953125 3.039062 5.292969 3.015625 C 5.316406 2.96875 5.328125 2.941406 5.363281 2.90625 C 5.4375 2.828125 5.496094 2.757812 5.570312 2.683594 C 5.640625 2.621094 5.6875 2.566406 5.757812 2.507812 C 5.835938 2.441406 5.898438 2.378906 5.980469 2.308594 C 6.132812 2.183594 6.257812 2.0625 6.414062 1.941406 C 6.726562 1.785156 7.015625 1.636719 7.304688 1.484375 C 7.453125 1.429688 7.601562 1.378906 7.796875 1.3125 C 8.117188 1.222656 8.386719 1.15625 8.6875 1.089844 C 8.835938 1.078125 8.953125 1.0625 9.085938 1.078125 C 9.304688 1.082031 9.507812 1.058594 9.738281 1.035156 C 9.84375 1.03125 9.917969 1.03125 10.019531 1.035156 C 10.074219 1.039062 10.109375 1.035156 10.164062 1.039062 C 10.429688 1.089844 10.675781 1.132812 10.917969 1.171875 Z M 10.917969 1.171875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 7.300781 1.453125 C 7.015625 1.636719 6.726562 1.785156 6.40625 1.9375 C 6.375 1.933594 6.367188 1.925781 6.371094 1.894531 C 6.378906 1.738281 6.378906 1.613281 6.410156 1.488281 C 6.785156 1.550781 6.945312 1.417969 6.878906 1.042969 C 6.875 1.042969 6.875 1.042969 6.90625 1.042969 C 7.058594 1.042969 7.179688 1.042969 7.300781 1.042969 C 7.300781 1.167969 7.300781 1.292969 7.300781 1.453125 Z M 7.300781 1.453125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 8.660156 1.089844 C 8.386719 1.15625 8.117188 1.222656 7.820312 1.296875 C 7.894531 1.179688 7.996094 1.0625 8.097656 0.945312 C 8.140625 0.964844 8.179688 0.988281 8.222656 1.011719 C 8.222656 0.871094 8.222656 0.726562 8.222656 0.554688 C 8.34375 0.523438 8.46875 0.523438 8.621094 0.523438 C 8.648438 0.523438 8.648438 0.519531 8.648438 0.554688 C 8.652344 0.757812 8.65625 0.921875 8.660156 1.089844 Z M 8.660156 1.089844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 7.300781 0.519531 C 7.347656 0.523438 7.40625 0.503906 7.4375 0.527344 C 7.539062 0.601562 7.699219 0.679688 7.710938 0.773438 C 7.746094 1.027344 7.535156 1.03125 7.332031 1.042969 C 7.300781 1.042969 7.300781 1.042969 7.300781 1.011719 C 7.300781 0.824219 7.300781 0.671875 7.300781 0.519531 Z M 7.300781 0.519531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(84.313726%,1.176471%,15.686275%)",
      fillOpacity: 1
    },
    d: "M 8.222656 12.972656 C 8.074219 12.925781 7.921875 12.878906 7.742188 12.84375 C 7.710938 12.859375 7.707031 12.855469 7.695312 12.832031 C 7.441406 12.707031 7.199219 12.605469 6.945312 12.484375 C 6.640625 12.28125 6.355469 12.097656 6.054688 11.894531 C 5.78125 11.648438 5.515625 11.421875 5.253906 11.199219 C 5.253906 11.203125 5.253906 11.207031 5.253906 11.179688 C 5.257812 11.136719 5.257812 11.117188 5.289062 11.097656 C 7.507812 11.097656 9.691406 11.09375 11.875 11.097656 C 12.539062 11.097656 13.199219 11.109375 13.851562 11.136719 C 13.808594 11.203125 13.777344 11.25 13.726562 11.308594 C 13.671875 11.359375 13.636719 11.402344 13.578125 11.453125 C 13.261719 11.710938 12.96875 11.957031 12.648438 12.207031 C 12.566406 12.253906 12.503906 12.304688 12.425781 12.351562 C 12.382812 12.375 12.355469 12.398438 12.304688 12.425781 C 12.128906 12.507812 11.980469 12.582031 11.828125 12.65625 C 11.738281 12.703125 11.640625 12.742188 11.546875 12.785156 C 11.496094 12.796875 11.445312 12.808594 11.355469 12.832031 C 11.296875 12.851562 11.28125 12.863281 11.269531 12.882812 C 11.269531 12.882812 11.273438 12.882812 11.253906 12.878906 C 11.222656 12.882812 11.214844 12.890625 11.203125 12.898438 C 11.144531 12.910156 11.085938 12.925781 10.980469 12.949219 C 10.859375 13.03125 10.78125 13.105469 10.703125 13.179688 C 10.703125 13.179688 10.675781 13.171875 10.660156 13.148438 C 10.589844 13.105469 10.535156 13.082031 10.480469 13.058594 C 10.40625 13.070312 10.335938 13.078125 10.203125 13.097656 C 9.953125 13.113281 9.761719 13.121094 9.539062 13.125 C 9.414062 13.121094 9.3125 13.121094 9.191406 13.117188 C 9.136719 13.132812 9.101562 13.15625 9.042969 13.179688 C 8.96875 13.179688 8.917969 13.175781 8.859375 13.15625 C 8.78125 13.109375 8.714844 13.082031 8.621094 13.046875 C 8.472656 13.015625 8.347656 12.996094 8.222656 12.972656 Z M 8.222656 12.972656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 10.492188 13.742188 C 10.347656 13.777344 10.203125 13.777344 10.027344 13.777344 C 9.996094 13.648438 9.996094 13.519531 10.015625 13.359375 C 10.03125 13.328125 10.066406 13.328125 10.066406 13.328125 C 10.328125 13.308594 10.570312 13.316406 10.492188 13.742188 Z M 10.492188 13.742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,89.411765%,90.196079%)",
      fillOpacity: 1
    },
    d: "M 10.070312 13.304688 C 10.066406 13.328125 10.03125 13.328125 10.011719 13.328125 C 9.875 13.304688 9.75 13.28125 9.597656 13.234375 C 9.570312 13.1875 9.570312 13.15625 9.570312 13.128906 C 9.761719 13.121094 9.953125 13.113281 10.175781 13.105469 C 10.164062 13.167969 10.117188 13.222656 10.070312 13.304688 Z M 10.070312 13.304688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,89.411765%,90.196079%)",
      fillOpacity: 1
    },
    d: "M 10.722656 13.171875 C 10.78125 13.105469 10.859375 13.03125 10.960938 12.960938 C 10.90625 13.027344 10.824219 13.097656 10.722656 13.171875 Z M 10.722656 13.171875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,89.411765%,90.196079%)",
      fillOpacity: 1
    },
    d: "M 10.492188 13.085938 C 10.535156 13.082031 10.589844 13.105469 10.644531 13.152344 C 10.601562 13.152344 10.550781 13.132812 10.492188 13.085938 Z M 10.492188 13.085938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,89.411765%,90.196079%)",
      fillOpacity: 1
    },
    d: "M 11.289062 12.882812 C 11.28125 12.863281 11.296875 12.851562 11.332031 12.847656 C 11.347656 12.847656 11.347656 12.867188 11.347656 12.878906 C 11.332031 12.886719 11.320312 12.886719 11.289062 12.882812 Z M 11.289062 12.882812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,89.411765%,90.196079%)",
      fillOpacity: 1
    },
    d: "M 11.210938 12.90625 C 11.214844 12.890625 11.222656 12.882812 11.253906 12.878906 C 11.253906 12.894531 11.238281 12.90625 11.210938 12.90625 Z M 11.210938 12.90625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.078432%,96.078432%,96.470588%)",
      fillOpacity: 1
    },
    d: "M 11.5625 12.808594 C 11.640625 12.742188 11.738281 12.703125 11.828125 12.65625 C 11.980469 12.582031 12.128906 12.507812 12.304688 12.457031 C 12.335938 12.59375 12.335938 12.699219 12.324219 12.835938 C 12.296875 13.019531 12.28125 13.175781 12.265625 13.328125 C 12.144531 13.328125 12.023438 13.328125 11.871094 13.328125 C 11.847656 13.109375 11.882812 12.875 11.5625 12.808594 Z M 11.5625 12.808594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 11.808594 13.328125 C 11.863281 13.609375 11.851562 13.855469 11.445312 13.777344 C 11.386719 13.496094 11.40625 13.253906 11.808594 13.328125 Z M 11.808594 13.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.470588%,96.470588%,96.470588%)",
      fillOpacity: 1
    },
    d: "M 10.917969 1.152344 C 10.675781 1.132812 10.429688 1.089844 10.183594 1.023438 C 10.523438 1.011719 10.503906 0.765625 10.492188 0.519531 C 10.613281 0.519531 10.734375 0.519531 10.886719 0.519531 C 10.917969 0.519531 10.917969 0.519531 10.917969 0.554688 C 10.917969 0.738281 10.917969 0.890625 10.917969 1.042969 C 10.917969 1.070312 10.917969 1.101562 10.917969 1.152344 Z M 10.917969 1.152344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 11.839844 0.554688 C 11.960938 0.519531 12.082031 0.519531 12.234375 0.523438 C 12.265625 0.523438 12.265625 0.519531 12.265625 0.554688 C 12.265625 0.738281 12.265625 0.890625 12.234375 1.042969 C 12.082031 1.042969 11.960938 1.042969 11.839844 1.042969 C 11.839844 0.890625 11.839844 0.738281 11.839844 0.554688 Z M 11.839844 0.554688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.725491%,93.725491%,93.725491%)",
      fillOpacity: 1
    },
    d: "M 10.949219 1.042969 C 10.917969 0.890625 10.917969 0.738281 10.917969 0.554688 C 11.050781 0.5625 11.238281 0.558594 11.308594 0.65625 C 11.453125 0.847656 11.296875 1.019531 10.949219 1.042969 Z M 10.949219 1.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,89.411765%,90.196079%)",
      fillOpacity: 1
    },
    d: "M 11.839844 1.484375 C 11.710938 1.4375 11.585938 1.394531 11.433594 1.335938 C 11.375 0.996094 11.59375 1.042969 11.808594 1.042969 C 11.839844 1.042969 11.839844 1.042969 11.839844 1.074219 C 11.839844 1.230469 11.839844 1.359375 11.839844 1.484375 Z M 11.839844 1.484375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 9.539062 13.125 C 9.570312 13.15625 9.570312 13.1875 9.570312 13.234375 C 9.570312 13.257812 9.570312 13.292969 9.570312 13.3125 C 9.304688 13.300781 9.074219 13.320312 9.144531 13.742188 C 9 13.777344 8.855469 13.777344 8.679688 13.777344 C 8.675781 13.492188 8.65625 13.253906 8.253906 13.328125 C 8.222656 13.230469 8.222656 13.132812 8.222656 13.003906 C 8.347656 12.996094 8.472656 13.015625 8.628906 13.070312 C 8.730469 13.128906 8.800781 13.152344 8.871094 13.175781 C 8.917969 13.175781 8.96875 13.179688 9.0625 13.179688 C 9.144531 13.160156 9.179688 13.144531 9.214844 13.125 C 9.3125 13.121094 9.414062 13.121094 9.539062 13.125 Z M 9.539062 13.125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 8.195312 13.328125 C 8.246094 13.609375 8.234375 13.855469 7.828125 13.777344 C 7.773438 13.496094 7.789062 13.253906 8.195312 13.328125 Z M 8.195312 13.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 7.707031 12.855469 C 7.707031 12.855469 7.710938 12.859375 7.714844 12.855469 C 7.75 13.136719 7.765625 13.40625 7.332031 13.328125 C 7.300781 13.328125 7.300781 13.328125 7.300781 13.296875 C 7.300781 13.136719 7.300781 13.011719 7.335938 12.882812 C 7.480469 12.875 7.59375 12.863281 7.707031 12.855469 Z M 7.707031 12.855469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 0.992188 6.253906 C 0.992188 6.253906 0.992188 6.21875 0.992188 6.167969 C 0.992188 5.988281 0.992188 5.863281 0.992188 5.734375 C 0.992188 5.734375 0.992188 5.734375 1.023438 5.734375 C 1.175781 5.734375 1.296875 5.734375 1.417969 5.734375 C 1.417969 5.734375 1.417969 5.734375 1.417969 5.765625 C 1.417969 5.925781 1.417969 6.054688 1.417969 6.199219 C 1.417969 6.230469 1.417969 6.242188 1.386719 6.253906 C 1.234375 6.253906 1.113281 6.253906 0.992188 6.253906 Z M 0.992188 6.253906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 0.992188 5.734375 C 0.992188 5.863281 0.992188 5.988281 0.992188 6.148438 C 0.742188 6.175781 0.417969 6.277344 0.496094 5.765625 C 0.496094 5.734375 0.496094 5.734375 0.527344 5.734375 C 0.703125 5.734375 0.847656 5.734375 0.992188 5.734375 Z M 0.992188 5.734375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 0.496094 7.148438 C 0.496094 7.019531 0.496094 6.894531 0.496094 6.734375 C 0.640625 6.703125 0.785156 6.703125 0.960938 6.703125 C 0.992188 6.703125 0.992188 6.703125 0.992188 6.734375 C 0.992188 6.894531 0.992188 7.019531 0.960938 7.148438 C 0.785156 7.148438 0.640625 7.148438 0.496094 7.148438 Z M 0.496094 7.148438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 0.992188 6.285156 C 1.113281 6.253906 1.234375 6.253906 1.386719 6.289062 C 1.417969 6.445312 1.417969 6.574219 1.386719 6.703125 C 1.234375 6.703125 1.113281 6.703125 0.992188 6.703125 C 0.992188 6.574219 0.992188 6.445312 0.992188 6.285156 Z M 0.992188 6.285156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 0.496094 11.914062 C 0.429688 11.539062 0.585938 11.402344 0.960938 11.5 C 0.992188 11.660156 0.992188 11.789062 0.992188 11.914062 C 0.992188 11.914062 0.992188 11.914062 0.960938 11.914062 C 0.785156 11.914062 0.640625 11.914062 0.496094 11.914062 Z M 0.496094 11.914062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 0.527344 10.945312 C 0.496094 10.820312 0.496094 10.691406 0.496094 10.53125 C 0.496094 10.5 0.496094 10.5 0.527344 10.5 C 0.703125 10.5 0.847656 10.5 0.992188 10.53125 C 0.992188 10.691406 0.992188 10.820312 0.992188 10.945312 C 0.847656 10.945312 0.703125 10.945312 0.527344 10.945312 Z M 0.527344 10.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 1.023438 11.914062 C 0.992188 11.789062 0.992188 11.660156 0.992188 11.5 C 0.992188 11.46875 0.992188 11.429688 1.023438 11.414062 C 1.175781 11.394531 1.296875 11.394531 1.417969 11.410156 C 1.417969 11.441406 1.417969 11.457031 1.417969 11.46875 C 1.417969 11.597656 1.417969 11.722656 1.417969 11.882812 C 1.296875 11.914062 1.175781 11.914062 1.023438 11.914062 Z M 1.023438 11.914062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 1.417969 11.394531 C 1.296875 11.394531 1.175781 11.394531 1.023438 11.394531 C 0.992188 11.265625 0.992188 11.140625 0.992188 10.976562 C 0.992188 10.945312 0.992188 10.945312 1.023438 10.945312 C 1.175781 10.945312 1.296875 10.945312 1.417969 10.980469 C 1.417969 11.136719 1.417969 11.265625 1.417969 11.394531 Z M 1.417969 11.394531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 17.722656 13.328125 C 17.792969 13.707031 17.632812 13.839844 17.257812 13.777344 C 17.226562 13.777344 17.226562 13.777344 17.226562 13.746094 C 17.300781 13.320312 17.070312 13.304688 16.800781 13.328125 C 16.800781 13.328125 16.800781 13.328125 16.800781 13.296875 C 16.878906 12.871094 16.640625 12.859375 16.375 12.863281 C 16.375 12.84375 16.378906 12.808594 16.375 12.777344 C 16.375 12.617188 16.375 12.488281 16.40625 12.363281 C 16.558594 12.363281 16.679688 12.363281 16.800781 12.394531 C 16.820312 12.59375 16.730469 12.84375 17.03125 12.796875 C 17.105469 12.785156 17.210938 12.65625 17.21875 12.574219 C 17.246094 12.28125 17.015625 12.382812 16.871094 12.363281 C 16.847656 12.359375 16.824219 12.363281 16.800781 12.332031 C 16.800781 12.171875 16.800781 12.042969 16.832031 11.914062 C 17.007812 11.914062 17.152344 11.914062 17.296875 11.945312 C 17.222656 12.371094 17.457031 12.386719 17.722656 12.394531 C 17.648438 12.820312 17.886719 12.832031 18.148438 12.828125 C 18.148438 12.847656 18.148438 12.882812 18.148438 12.914062 C 18.148438 13.074219 18.148438 13.203125 18.148438 13.328125 C 18.027344 13.328125 17.90625 13.328125 17.753906 13.296875 C 17.707031 13.097656 17.792969 12.847656 17.496094 12.894531 C 17.421875 12.90625 17.316406 13.035156 17.308594 13.117188 C 17.28125 13.410156 17.507812 13.308594 17.652344 13.328125 C 17.675781 13.332031 17.699219 13.328125 17.722656 13.328125 Z M 17.722656 13.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 18.644531 13.742188 C 18.5 13.777344 18.355469 13.777344 18.179688 13.777344 C 18.148438 13.648438 18.148438 13.519531 18.148438 13.363281 C 18.148438 13.328125 18.148438 13.328125 18.179688 13.328125 C 18.355469 13.328125 18.5 13.328125 18.644531 13.328125 C 18.644531 13.457031 18.644531 13.585938 18.644531 13.742188 Z M 18.644531 13.742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 16.375 13.742188 C 16.230469 13.777344 16.085938 13.777344 15.910156 13.777344 C 15.882812 13.648438 15.882812 13.519531 15.878906 13.363281 C 15.878906 13.328125 15.878906 13.328125 15.910156 13.328125 C 16.085938 13.328125 16.230469 13.328125 16.378906 13.328125 C 16.375 13.328125 16.375 13.328125 16.375 13.328125 C 16.375 13.457031 16.375 13.585938 16.375 13.742188 Z M 16.375 13.742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 16.800781 13.363281 C 17.070312 13.304688 17.300781 13.320312 17.226562 13.746094 C 16.964844 13.800781 16.726562 13.789062 16.800781 13.363281 Z M 16.800781 13.363281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 16.375 12.882812 C 16.640625 12.859375 16.878906 12.871094 16.800781 13.296875 C 16.679688 13.328125 16.558594 13.328125 16.40625 13.328125 C 16.375 13.328125 16.375 13.328125 16.375 13.296875 C 16.375 13.136719 16.375 13.007812 16.375 12.882812 Z M 16.375 12.882812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 12.761719 13.742188 C 12.617188 13.777344 12.472656 13.777344 12.296875 13.777344 C 12.265625 13.648438 12.265625 13.519531 12.296875 13.363281 C 12.472656 13.328125 12.617188 13.328125 12.761719 13.328125 C 12.761719 13.457031 12.761719 13.585938 12.761719 13.742188 Z M 12.761719 13.742188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 14.109375 13.328125 C 13.964844 13.328125 13.820312 13.328125 13.644531 13.328125 C 13.613281 13.328125 13.613281 13.328125 13.613281 13.300781 C 13.570312 12.867188 13.773438 12.757812 14.109375 12.839844 C 14.109375 13.027344 14.109375 13.179688 14.109375 13.332031 C 14.109375 13.332031 14.109375 13.328125 14.109375 13.328125 Z M 14.109375 13.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 5.035156 13.328125 C 4.914062 13.328125 4.789062 13.328125 4.636719 13.328125 C 4.609375 13.328125 4.609375 13.328125 4.609375 13.296875 C 4.609375 13.136719 4.609375 13.011719 4.636719 12.882812 C 4.789062 12.882812 4.914062 12.882812 5.035156 12.914062 C 5.035156 13.074219 5.035156 13.203125 5.035156 13.332031 C 5.035156 13.332031 5.035156 13.328125 5.035156 13.328125 Z M 5.035156 13.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 14.136719 13.328125 C 14.109375 13.179688 14.109375 13.027344 14.109375 12.839844 C 14.109375 12.808594 14.109375 12.808594 14.136719 12.808594 C 14.289062 12.808594 14.414062 12.808594 14.535156 12.808594 C 14.535156 12.808594 14.535156 12.808594 14.535156 12.839844 C 14.535156 13.027344 14.535156 13.175781 14.535156 13.328125 C 14.414062 13.328125 14.289062 13.328125 14.136719 13.328125 Z M 14.136719 13.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 5.0625 13.328125 C 5.035156 13.203125 5.035156 13.074219 5.035156 12.914062 C 5.035156 12.882812 5.035156 12.882812 5.0625 12.882812 C 5.496094 12.945312 5.554688 12.691406 5.558594 12.363281 C 5.710938 12.363281 5.832031 12.363281 5.957031 12.363281 C 5.957031 12.363281 5.953125 12.363281 5.953125 12.394531 C 5.878906 12.820312 6.117188 12.832031 6.378906 12.828125 C 6.378906 12.847656 6.378906 12.882812 6.378906 12.914062 C 6.378906 13.074219 6.378906 13.203125 6.378906 13.328125 C 6.257812 13.328125 6.136719 13.328125 5.984375 13.328125 C 5.953125 13.328125 5.957031 13.328125 5.957031 13.296875 C 5.945312 12.921875 5.808594 12.765625 5.636719 12.910156 C 5.546875 12.980469 5.5625 13.1875 5.53125 13.332031 C 5.53125 13.332031 5.53125 13.328125 5.53125 13.328125 C 5.386719 13.328125 5.242188 13.328125 5.0625 13.328125 Z M 5.0625 13.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 4.609375 12.882812 C 4.609375 13.011719 4.609375 13.136719 4.609375 13.296875 C 4.464844 13.328125 4.320312 13.328125 4.144531 13.328125 C 4.113281 13.328125 4.113281 13.328125 4.113281 13.296875 C 4.101562 12.921875 3.964844 12.765625 3.792969 12.910156 C 3.707031 12.980469 3.71875 13.1875 3.6875 13.332031 C 3.6875 13.332031 3.6875 13.328125 3.6875 13.328125 C 3.566406 13.328125 3.445312 13.328125 3.292969 13.328125 C 3.261719 13.203125 3.261719 13.074219 3.261719 12.914062 C 3.261719 12.882812 3.261719 12.847656 3.292969 12.828125 C 3.699219 12.886719 3.707031 12.640625 3.714844 12.363281 C 3.867188 12.363281 3.992188 12.363281 4.113281 12.390625 C 4.070312 12.824219 4.273438 12.933594 4.609375 12.882812 Z M 4.609375 12.882812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 3.714844 13.328125 C 3.71875 13.1875 3.707031 12.980469 3.792969 12.910156 C 3.964844 12.765625 4.101562 12.921875 4.113281 13.296875 C 3.992188 13.328125 3.867188 13.328125 3.714844 13.328125 Z M 3.714844 13.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 14.5625 13.328125 C 14.535156 13.175781 14.535156 13.027344 14.5625 12.839844 C 14.996094 12.746094 15.054688 13 15.03125 13.332031 C 15.03125 13.332031 15.03125 13.328125 15.03125 13.328125 C 14.886719 13.328125 14.742188 13.328125 14.5625 13.328125 Z M 14.5625 13.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 0.496094 13.363281 C 0.640625 13.328125 0.785156 13.328125 0.960938 13.328125 C 0.992188 13.457031 0.992188 13.585938 0.992188 13.742188 C 0.871094 13.777344 0.75 13.777344 0.597656 13.777344 C 0.566406 13.777344 0.53125 13.777344 0.515625 13.777344 C 0.496094 13.648438 0.496094 13.519531 0.496094 13.363281 Z M 0.496094 13.363281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 2.765625 13.363281 C 2.910156 13.328125 3.054688 13.328125 3.230469 13.328125 C 3.261719 13.457031 3.261719 13.585938 3.261719 13.746094 C 3.117188 13.777344 2.972656 13.777344 2.796875 13.777344 C 2.765625 13.648438 2.765625 13.519531 2.765625 13.363281 Z M 2.765625 13.363281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 15.058594 13.332031 C 15.054688 13 14.996094 12.746094 14.5625 12.808594 C 14.535156 12.808594 14.535156 12.808594 14.535156 12.777344 C 14.535156 12.617188 14.535156 12.488281 14.5625 12.363281 C 14.742188 12.363281 14.886719 12.363281 15.03125 12.394531 C 15.039062 12.769531 15.175781 12.925781 15.351562 12.78125 C 15.4375 12.710938 15.421875 12.503906 15.484375 12.363281 C 15.636719 12.363281 15.757812 12.363281 15.882812 12.394531 C 15.878906 12.554688 15.878906 12.679688 15.878906 12.828125 C 15.878906 12.84375 15.882812 12.882812 15.851562 12.882812 C 15.445312 12.804688 15.433594 13.050781 15.453125 13.332031 C 15.453125 13.332031 15.457031 13.328125 15.457031 13.328125 C 15.332031 13.328125 15.210938 13.328125 15.058594 13.332031 Z M 15.058594 13.332031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 13.1875 13.328125 C 13.066406 13.328125 12.945312 13.328125 12.792969 13.328125 C 12.761719 13.328125 12.761719 13.328125 12.761719 13.296875 C 12.761719 13.136719 12.761719 13.007812 12.792969 12.882812 C 13.199219 12.804688 13.210938 13.050781 13.1875 13.332031 C 13.1875 13.332031 13.1875 13.328125 13.1875 13.328125 Z M 13.1875 13.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 6.875 13.746094 C 6.730469 13.777344 6.585938 13.777344 6.410156 13.777344 C 6.378906 13.648438 6.378906 13.519531 6.378906 13.363281 C 6.378906 13.328125 6.378906 13.328125 6.410156 13.328125 C 6.5625 13.328125 6.683594 13.328125 6.824219 13.328125 C 6.851562 13.328125 6.867188 13.328125 6.878906 13.328125 C 6.878906 13.457031 6.875 13.585938 6.875 13.746094 Z M 6.875 13.746094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 6.90625 13.328125 C 6.867188 13.328125 6.851562 13.328125 6.824219 13.300781 C 6.828125 13.140625 6.851562 13.011719 6.875 12.882812 C 6.875 12.882812 6.875 12.882812 6.90625 12.882812 C 7.058594 12.882812 7.179688 12.882812 7.300781 12.882812 C 7.300781 13.011719 7.300781 13.136719 7.300781 13.296875 C 7.179688 13.328125 7.058594 13.328125 6.90625 13.328125 Z M 6.90625 13.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 5.558594 13.328125 C 5.5625 13.1875 5.546875 12.980469 5.636719 12.910156 C 5.808594 12.765625 5.945312 12.921875 5.957031 13.296875 C 5.832031 13.328125 5.710938 13.328125 5.558594 13.328125 Z M 5.558594 13.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 15.484375 13.328125 C 15.433594 13.050781 15.445312 12.804688 15.851562 12.914062 C 15.878906 13.074219 15.878906 13.203125 15.878906 13.328125 C 15.757812 13.328125 15.636719 13.328125 15.484375 13.328125 Z M 15.484375 13.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 13.214844 13.328125 C 13.210938 13.050781 13.199219 12.804688 12.792969 12.863281 C 12.761719 12.84375 12.761719 12.808594 12.761719 12.777344 C 12.761719 12.617188 12.761719 12.488281 12.792969 12.359375 C 12.945312 12.359375 13.066406 12.359375 13.1875 12.394531 C 13.195312 12.769531 13.332031 12.925781 13.507812 12.78125 C 13.59375 12.710938 13.578125 12.503906 13.640625 12.363281 C 13.820312 12.363281 13.964844 12.363281 14.109375 12.394531 C 14.109375 12.554688 14.109375 12.679688 14.109375 12.808594 C 13.773438 12.757812 13.570312 12.867188 13.613281 13.300781 C 13.492188 13.332031 13.367188 13.328125 13.214844 13.328125 Z M 13.214844 13.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 18.644531 4.820312 C 18.644531 4.964844 18.644531 5.09375 18.644531 5.253906 C 18.644531 5.289062 18.644531 5.289062 18.613281 5.289062 C 18.4375 5.289062 18.292969 5.289062 18.148438 5.253906 C 18.148438 5.09375 18.148438 4.964844 18.148438 4.820312 C 18.148438 4.800781 18.148438 4.765625 18.179688 4.765625 C 18.355469 4.765625 18.5 4.765625 18.644531 4.765625 C 18.644531 4.765625 18.644531 4.800781 18.644531 4.820312 Z M 18.644531 4.820312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 18.644531 4.734375 C 18.5 4.765625 18.355469 4.765625 18.179688 4.734375 C 18.148438 4.574219 18.148438 4.445312 18.179688 4.320312 C 18.355469 4.320312 18.5 4.320312 18.644531 4.320312 C 18.644531 4.445312 18.644531 4.574219 18.644531 4.734375 Z M 18.644531 4.734375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 0.496094 4.785156 C 0.496094 4.640625 0.496094 4.511719 0.496094 4.351562 C 0.496094 4.320312 0.496094 4.320312 0.527344 4.320312 C 0.703125 4.320312 0.847656 4.320312 0.992188 4.351562 C 0.992188 4.511719 0.992188 4.640625 0.992188 4.785156 C 0.992188 4.804688 0.992188 4.839844 0.960938 4.839844 C 0.785156 4.839844 0.640625 4.839844 0.496094 4.839844 C 0.496094 4.839844 0.496094 4.804688 0.496094 4.785156 Z M 0.496094 4.785156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 0.496094 4.871094 C 0.640625 4.839844 0.785156 4.839844 0.960938 4.871094 C 0.992188 5.03125 0.992188 5.160156 0.960938 5.289062 C 0.785156 5.289062 0.640625 5.285156 0.496094 5.285156 C 0.496094 5.285156 0.496094 5.289062 0.496094 5.289062 C 0.496094 5.160156 0.496094 5.03125 0.496094 4.871094 Z M 0.496094 4.871094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.725491%,93.725491%,93.725491%)",
      fillOpacity: 1
    },
    d: "M 0.496094 9.085938 C 0.496094 8.933594 0.496094 8.78125 0.496094 8.597656 C 0.496094 8.5625 0.496094 8.5625 0.527344 8.5625 C 0.703125 8.5625 0.847656 8.5625 0.992188 8.597656 C 0.992188 8.78125 0.992188 8.933594 0.960938 9.085938 C 0.785156 9.085938 0.640625 9.085938 0.496094 9.085938 Z M 0.496094 9.085938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,98.823529%,98.823529%)",
      fillOpacity: 1
    },
    d: "M 18.644531 8.5625 C 18.644531 8.714844 18.644531 8.867188 18.644531 9.050781 C 18.644531 9.085938 18.644531 9.085938 18.613281 9.085938 C 18.4375 9.085938 18.292969 9.085938 18.148438 9.050781 C 18.148438 8.867188 18.148438 8.714844 18.179688 8.5625 C 18.355469 8.5625 18.5 8.5625 18.644531 8.5625 Z M 18.644531 8.5625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 0.992188 10.5 C 0.847656 10.5 0.703125 10.5 0.527344 10.5 C 0.496094 10.347656 0.496094 10.195312 0.496094 10.011719 C 0.496094 9.980469 0.496094 9.980469 0.527344 9.980469 C 0.703125 9.980469 0.847656 9.980469 0.992188 10.011719 C 0.992188 10.195312 0.992188 10.347656 0.992188 10.5 Z M 0.992188 10.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.725491%,93.725491%,93.725491%)",
      fillOpacity: 1
    },
    d: "M 18.644531 9.980469 C 18.644531 10.128906 18.644531 10.28125 18.644531 10.46875 C 18.644531 10.5 18.644531 10.5 18.613281 10.5 C 18.4375 10.5 18.292969 10.5 18.148438 10.46875 C 18.148438 10.28125 18.148438 10.128906 18.179688 9.980469 C 18.355469 9.980469 18.5 9.980469 18.644531 9.980469 Z M 18.644531 9.980469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 18.644531 5.734375 C 18.644531 5.863281 18.644531 5.992188 18.644531 6.152344 C 18.644531 6.183594 18.644531 6.21875 18.613281 6.238281 C 18.4375 6.253906 18.292969 6.253906 18.148438 6.238281 C 18.148438 6.21875 18.148438 6.183594 18.148438 6.148438 C 18.148438 5.988281 18.148438 5.863281 18.179688 5.734375 C 18.355469 5.734375 18.5 5.734375 18.644531 5.734375 Z M 18.644531 5.734375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 18.148438 6.253906 C 18.292969 6.253906 18.4375 6.253906 18.613281 6.253906 C 18.644531 6.382812 18.644531 6.511719 18.644531 6.671875 C 18.644531 6.703125 18.644531 6.703125 18.613281 6.703125 C 18.4375 6.703125 18.292969 6.703125 18.148438 6.671875 C 18.148438 6.511719 18.148438 6.382812 18.148438 6.253906 Z M 18.148438 6.253906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 0.496094 7.179688 C 0.640625 7.148438 0.785156 7.148438 0.960938 7.148438 C 0.992188 7.148438 0.992188 7.148438 0.992188 7.179688 C 0.992188 7.367188 0.992188 7.519531 0.960938 7.671875 C 0.785156 7.671875 0.640625 7.671875 0.496094 7.671875 C 0.496094 7.519531 0.496094 7.367188 0.496094 7.179688 Z M 0.496094 7.179688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.725491%,93.725491%,93.725491%)",
      fillOpacity: 1
    },
    d: "M 18.644531 7.148438 C 18.644531 7.300781 18.644531 7.453125 18.644531 7.636719 C 18.644531 7.671875 18.644531 7.671875 18.613281 7.671875 C 18.4375 7.671875 18.292969 7.671875 18.148438 7.636719 C 18.148438 7.453125 18.148438 7.300781 18.179688 7.148438 C 18.355469 7.148438 18.5 7.148438 18.644531 7.148438 Z M 18.644531 7.148438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,98.823529%,98.823529%)",
      fillOpacity: 1
    },
    d: "M 0.992188 1.042969 C 0.847656 1.042969 0.703125 1.042969 0.527344 1.042969 C 0.496094 0.890625 0.496094 0.738281 0.496094 0.554688 C 0.640625 0.519531 0.785156 0.519531 0.960938 0.519531 C 0.992188 0.519531 0.992188 0.519531 0.992188 0.554688 C 0.992188 0.738281 0.992188 0.890625 0.992188 1.042969 Z M 0.992188 1.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 18.644531 1.9375 C 18.644531 2.089844 18.644531 2.242188 18.644531 2.425781 C 18.644531 2.457031 18.644531 2.457031 18.613281 2.457031 C 18.4375 2.457031 18.292969 2.457031 18.148438 2.425781 C 18.148438 2.242188 18.148438 2.089844 18.179688 1.9375 C 18.355469 1.9375 18.5 1.9375 18.644531 1.9375 Z M 18.644531 1.9375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 18.148438 12.882812 C 18.148438 12.882812 18.148438 12.847656 18.148438 12.796875 C 18.148438 12.617188 18.148438 12.488281 18.179688 12.363281 C 18.355469 12.363281 18.5 12.363281 18.644531 12.363281 C 18.644531 12.488281 18.644531 12.617188 18.644531 12.777344 C 18.644531 12.8125 18.644531 12.847656 18.613281 12.863281 C 18.4375 12.882812 18.292969 12.882812 18.148438 12.882812 Z M 18.148438 12.882812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 18.148438 12.914062 C 18.292969 12.882812 18.4375 12.882812 18.613281 12.882812 C 18.644531 13.011719 18.644531 13.136719 18.644531 13.296875 C 18.5 13.328125 18.355469 13.328125 18.179688 13.328125 C 18.148438 13.203125 18.148438 13.074219 18.148438 12.914062 Z M 18.148438 12.914062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.725491%,93.725491%,93.725491%)",
      fillOpacity: 1
    },
    d: "M 18.613281 0.519531 C 18.644531 0.671875 18.644531 0.824219 18.644531 1.011719 C 18.644531 1.042969 18.644531 1.042969 18.613281 1.042969 C 18.4375 1.042969 18.292969 1.042969 18.148438 1.011719 C 18.148438 0.824219 18.148438 0.671875 18.148438 0.519531 C 18.292969 0.519531 18.4375 0.519531 18.613281 0.519531 Z M 18.613281 0.519531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 16.800781 0.519531 C 16.925781 0.523438 17.046875 0.523438 17.199219 0.523438 C 17.230469 0.523438 17.265625 0.519531 17.28125 0.554688 C 17.296875 0.738281 17.296875 0.890625 17.28125 1.042969 C 17.265625 1.042969 17.230469 1.042969 17.199219 1.042969 C 17.046875 1.042969 16.925781 1.042969 16.800781 1.011719 C 16.800781 0.824219 16.800781 0.671875 16.800781 0.519531 Z M 16.800781 0.519531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 17.296875 1.042969 C 17.296875 0.890625 17.296875 0.738281 17.296875 0.554688 C 17.421875 0.519531 17.542969 0.523438 17.695312 0.523438 C 17.722656 0.523438 17.722656 0.519531 17.722656 0.554688 C 17.722656 0.738281 17.722656 0.890625 17.695312 1.042969 C 17.542969 1.042969 17.421875 1.042969 17.296875 1.042969 Z M 17.296875 1.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.725491%,93.725491%,93.725491%)",
      fillOpacity: 1
    },
    d: "M 6.378906 0.519531 C 6.523438 0.519531 6.671875 0.519531 6.847656 0.519531 C 6.878906 0.519531 6.875 0.519531 6.875 0.554688 C 6.875 0.738281 6.875 0.890625 6.875 1.042969 C 6.875 1.042969 6.875 1.042969 6.847656 1.042969 C 6.671875 1.042969 6.523438 1.042969 6.378906 1.011719 C 6.378906 0.824219 6.378906 0.671875 6.378906 0.519531 Z M 6.378906 0.519531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,98.823529%,98.823529%)",
      fillOpacity: 1
    },
    d: "M 12.265625 1.042969 C 12.265625 0.890625 12.265625 0.738281 12.265625 0.554688 C 12.410156 0.519531 12.554688 0.519531 12.730469 0.519531 C 12.761719 0.519531 12.761719 0.519531 12.761719 0.554688 C 12.761719 0.738281 12.761719 0.890625 12.730469 1.042969 C 12.554688 1.042969 12.410156 1.042969 12.265625 1.042969 Z M 12.265625 1.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.725491%,93.725491%,93.725491%)",
      fillOpacity: 1
    },
    d: "M 10.460938 0.519531 C 10.503906 0.765625 10.523438 1.011719 10.160156 1.011719 C 10.109375 1.035156 10.074219 1.039062 10.019531 1 C 9.996094 0.816406 9.996094 0.667969 9.996094 0.519531 C 10.140625 0.519531 10.285156 0.519531 10.460938 0.519531 Z M 10.460938 0.519531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,98.823529%,98.823529%)",
      fillOpacity: 1
    },
    d: "M 8.6875 1.089844 C 8.65625 0.921875 8.652344 0.757812 8.648438 0.554688 C 8.792969 0.519531 8.9375 0.519531 9.113281 0.519531 C 9.144531 0.519531 9.144531 0.519531 9.144531 0.550781 C 9.121094 0.738281 9.097656 0.894531 9.070312 1.050781 C 8.953125 1.0625 8.835938 1.078125 8.6875 1.089844 Z M 8.6875 1.089844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.725491%,93.725491%,93.725491%)",
      fillOpacity: 1
    },
    d: "M 2.765625 0.519531 C 2.910156 0.519531 3.054688 0.519531 3.230469 0.519531 C 3.261719 0.519531 3.261719 0.519531 3.261719 0.554688 C 3.261719 0.738281 3.261719 0.890625 3.230469 1.042969 C 3.054688 1.042969 2.910156 1.042969 2.765625 1.011719 C 2.765625 0.824219 2.765625 0.671875 2.765625 0.519531 Z M 2.765625 0.519531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.470588%,96.470588%,96.470588%)",
      fillOpacity: 1
    },
    d: "M 1.417969 0.519531 C 1.539062 0.519531 1.660156 0.519531 1.8125 0.519531 C 1.84375 0.519531 1.878906 0.519531 1.898438 0.554688 C 1.914062 0.738281 1.914062 0.890625 1.898438 1.042969 C 1.878906 1.042969 1.84375 1.042969 1.8125 1.042969 C 1.660156 1.042969 1.539062 1.042969 1.417969 1.042969 C 1.417969 1.042969 1.417969 1.042969 1.417969 1.011719 C 1.417969 0.824219 1.417969 0.671875 1.417969 0.519531 Z M 1.417969 0.519531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 1.914062 1.042969 C 1.914062 0.890625 1.914062 0.738281 1.914062 0.554688 C 2.035156 0.523438 2.15625 0.523438 2.308594 0.523438 C 2.339844 0.523438 2.339844 0.519531 2.339844 0.554688 C 2.339844 0.738281 2.339844 0.890625 2.308594 1.042969 C 2.15625 1.042969 2.035156 1.042969 1.914062 1.042969 Z M 1.914062 1.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 0.496094 3.371094 C 0.640625 3.351562 0.785156 3.351562 0.960938 3.371094 C 0.992188 3.386719 0.992188 3.421875 0.992188 3.457031 C 0.992188 3.617188 0.992188 3.746094 0.960938 3.871094 C 0.785156 3.871094 0.640625 3.871094 0.496094 3.871094 C 0.496094 3.746094 0.496094 3.617188 0.496094 3.457031 C 0.496094 3.421875 0.496094 3.386719 0.496094 3.371094 Z M 0.496094 3.371094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 13.1875 0.519531 C 13.308594 0.523438 13.429688 0.523438 13.582031 0.523438 C 13.613281 0.523438 13.648438 0.519531 13.664062 0.554688 C 13.683594 0.738281 13.683594 0.890625 13.664062 1.042969 C 13.648438 1.042969 13.613281 1.042969 13.582031 1.042969 C 13.429688 1.042969 13.308594 1.042969 13.1875 1.011719 C 13.1875 0.824219 13.1875 0.671875 13.1875 0.519531 Z M 13.1875 0.519531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 13.683594 1.042969 C 13.683594 0.890625 13.683594 0.738281 13.683594 0.554688 C 13.804688 0.519531 13.925781 0.519531 14.078125 0.523438 C 14.109375 0.523438 14.109375 0.519531 14.109375 0.554688 C 14.109375 0.738281 14.109375 0.890625 14.078125 1.042969 C 13.925781 1.042969 13.804688 1.042969 13.683594 1.042969 Z M 13.683594 1.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 18.644531 2.902344 C 18.644531 3.03125 18.644531 3.160156 18.644531 3.320312 C 18.644531 3.351562 18.644531 3.390625 18.613281 3.40625 C 18.4375 3.425781 18.292969 3.425781 18.148438 3.40625 C 18.148438 3.390625 18.148438 3.351562 18.148438 3.320312 C 18.148438 3.160156 18.148438 3.03125 18.179688 2.902344 C 18.355469 2.902344 18.5 2.90625 18.644531 2.90625 C 18.644531 2.90625 18.644531 2.902344 18.644531 2.902344 Z M 18.644531 2.902344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 18.148438 3.425781 C 18.292969 3.425781 18.4375 3.425781 18.613281 3.425781 C 18.644531 3.554688 18.644531 3.679688 18.644531 3.839844 C 18.644531 3.871094 18.644531 3.871094 18.613281 3.871094 C 18.4375 3.871094 18.292969 3.871094 18.148438 3.839844 C 18.148438 3.679688 18.148438 3.554688 18.148438 3.425781 Z M 18.148438 3.425781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,98.823529%,98.823529%)",
      fillOpacity: 1
    },
    d: "M 15.878906 0.519531 C 16.023438 0.519531 16.171875 0.519531 16.347656 0.519531 C 16.375 0.519531 16.375 0.519531 16.375 0.554688 C 16.375 0.738281 16.375 0.890625 16.347656 1.042969 C 16.171875 1.042969 16.023438 1.042969 15.878906 1.011719 C 15.878906 0.824219 15.878906 0.671875 15.878906 0.519531 Z M 15.878906 0.519531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 15.011719 0.519531 C 15.148438 0.523438 15.273438 0.519531 15.425781 0.519531 C 15.457031 0.519531 15.457031 0.519531 15.457031 0.554688 C 15.457031 0.738281 15.457031 0.890625 15.425781 1.042969 C 15.273438 1.042969 15.148438 1.042969 15.011719 1.042969 C 14.992188 1.042969 14.960938 1.042969 14.960938 1.011719 C 14.960938 0.824219 14.960938 0.671875 14.960938 0.519531 C 14.960938 0.519531 14.992188 0.519531 15.011719 0.519531 Z M 15.011719 0.519531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 14.929688 0.519531 C 14.960938 0.671875 14.960938 0.824219 14.929688 1.011719 C 14.777344 1.042969 14.65625 1.042969 14.535156 1.011719 C 14.535156 0.824219 14.535156 0.671875 14.535156 0.519531 C 14.65625 0.523438 14.777344 0.523438 14.929688 0.519531 Z M 14.929688 0.519531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 18.644531 10.945312 C 18.644531 11.074219 18.644531 11.203125 18.644531 11.363281 C 18.644531 11.394531 18.644531 11.394531 18.613281 11.394531 C 18.4375 11.394531 18.292969 11.394531 18.148438 11.363281 C 18.148438 11.203125 18.148438 11.074219 18.179688 10.945312 C 18.355469 10.945312 18.5 10.945312 18.644531 10.945312 Z M 18.644531 10.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 5.53125 0.523438 C 5.652344 0.523438 5.773438 0.523438 5.925781 0.523438 C 5.957031 0.523438 5.957031 0.519531 5.957031 0.554688 C 5.957031 0.738281 5.957031 0.890625 5.925781 1.042969 C 5.773438 1.042969 5.652344 1.042969 5.53125 1.011719 C 5.53125 0.824219 5.53125 0.671875 5.53125 0.519531 C 5.53125 0.519531 5.53125 0.519531 5.53125 0.523438 Z M 5.53125 0.523438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 4.082031 0.523438 C 4.113281 0.523438 4.148438 0.519531 4.152344 0.546875 C 4.144531 0.730469 4.128906 0.886719 4.082031 1.042969 C 3.929688 1.042969 3.808594 1.042969 3.6875 1.011719 C 3.6875 0.824219 3.6875 0.671875 3.6875 0.519531 C 3.808594 0.523438 3.929688 0.523438 4.082031 0.523438 Z M 4.082031 0.523438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 4.113281 1.042969 C 4.128906 0.886719 4.144531 0.730469 4.171875 0.546875 C 4.304688 0.519531 4.425781 0.519531 4.578125 0.523438 C 4.609375 0.523438 4.609375 0.519531 4.609375 0.554688 C 4.609375 0.738281 4.609375 0.890625 4.578125 1.042969 C 4.402344 1.042969 4.257812 1.042969 4.113281 1.042969 Z M 4.113281 1.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 5.5 0.519531 C 5.53125 0.671875 5.53125 0.824219 5.53125 1.011719 C 5.53125 1.042969 5.53125 1.042969 5.5 1.042969 C 5.324219 1.042969 5.179688 1.042969 5.035156 1.011719 C 5.035156 0.824219 5.035156 0.671875 5.035156 0.519531 C 5.179688 0.519531 5.324219 0.519531 5.5 0.519531 Z M 5.5 0.519531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 18.148438 11.394531 C 18.292969 11.394531 18.4375 11.394531 18.613281 11.394531 C 18.644531 11.546875 18.644531 11.699219 18.644531 11.882812 C 18.644531 11.914062 18.644531 11.914062 18.613281 11.914062 C 18.4375 11.914062 18.292969 11.914062 18.148438 11.882812 C 18.148438 11.722656 18.148438 11.59375 18.148438 11.449219 C 18.148438 11.429688 18.148438 11.394531 18.148438 11.394531 Z M 18.148438 11.394531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 18.148438 11.914062 C 18.292969 11.914062 18.4375 11.914062 18.613281 11.914062 C 18.644531 12.042969 18.644531 12.171875 18.644531 12.328125 C 18.5 12.363281 18.355469 12.363281 18.179688 12.363281 C 18.148438 12.363281 18.148438 12.363281 18.148438 12.332031 C 18.148438 12.171875 18.148438 12.042969 18.148438 11.914062 Z M 18.148438 11.914062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 0.496094 11.945312 C 0.640625 11.914062 0.785156 11.914062 0.960938 11.914062 C 0.992188 12.042969 0.992188 12.171875 0.992188 12.328125 C 0.847656 12.363281 0.703125 12.363281 0.527344 12.363281 C 0.496094 12.234375 0.496094 12.105469 0.496094 11.945312 Z M 0.496094 11.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,98.823529%,98.823529%)",
      fillOpacity: 1
    },
    d: "M 18.644531 10.914062 C 18.5 10.945312 18.355469 10.945312 18.179688 10.945312 C 18.148438 10.945312 18.148438 10.945312 18.148438 10.914062 C 18.148438 10.753906 18.148438 10.628906 18.148438 10.5 C 18.292969 10.5 18.4375 10.5 18.613281 10.5 C 18.644531 10.628906 18.644531 10.753906 18.644531 10.914062 Z M 18.644531 10.914062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 18.644531 2.871094 C 18.5 2.90625 18.355469 2.902344 18.179688 2.902344 C 18.148438 2.902344 18.148438 2.90625 18.148438 2.871094 C 18.148438 2.710938 18.148438 2.585938 18.148438 2.457031 C 18.292969 2.457031 18.4375 2.457031 18.613281 2.457031 C 18.644531 2.585938 18.644531 2.710938 18.644531 2.871094 Z M 18.644531 2.871094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 18.644531 1.90625 C 18.5 1.9375 18.355469 1.9375 18.179688 1.9375 C 18.148438 1.9375 18.148438 1.9375 18.148438 1.90625 C 18.148438 1.746094 18.148438 1.617188 18.179688 1.488281 C 18.355469 1.488281 18.5 1.488281 18.644531 1.488281 C 18.644531 1.617188 18.644531 1.746094 18.644531 1.90625 Z M 18.644531 1.90625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 0.496094 3.902344 C 0.640625 3.871094 0.785156 3.871094 0.960938 3.871094 C 0.992188 3.871094 0.992188 3.871094 0.992188 3.902344 C 0.992188 4.0625 0.992188 4.191406 0.992188 4.320312 C 0.847656 4.320312 0.703125 4.320312 0.527344 4.320312 C 0.496094 4.191406 0.496094 4.0625 0.496094 3.902344 Z M 0.496094 3.902344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 17.722656 1.042969 C 17.722656 0.890625 17.722656 0.738281 17.722656 0.554688 C 17.84375 0.519531 17.96875 0.519531 18.117188 0.519531 C 18.148438 0.671875 18.148438 0.824219 18.148438 1.011719 C 18.148438 1.042969 18.148438 1.042969 18.121094 1.042969 C 17.96875 1.042969 17.84375 1.042969 17.722656 1.042969 Z M 17.722656 1.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 16.378906 1.042969 C 16.375 0.890625 16.375 0.738281 16.375 0.554688 C 16.5 0.519531 16.621094 0.519531 16.773438 0.519531 C 16.800781 0.671875 16.800781 0.824219 16.800781 1.011719 C 16.800781 1.042969 16.800781 1.042969 16.773438 1.042969 C 16.621094 1.042969 16.5 1.042969 16.375 1.042969 C 16.375 1.042969 16.378906 1.042969 16.378906 1.042969 Z M 16.378906 1.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 15.457031 1.042969 C 15.457031 0.890625 15.457031 0.738281 15.457031 0.554688 C 15.578125 0.519531 15.699219 0.519531 15.851562 0.519531 C 15.878906 0.671875 15.878906 0.824219 15.878906 1.011719 C 15.878906 1.042969 15.882812 1.042969 15.851562 1.042969 C 15.699219 1.042969 15.578125 1.042969 15.453125 1.042969 C 15.457031 1.042969 15.457031 1.042969 15.457031 1.042969 Z M 15.457031 1.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 14.503906 0.519531 C 14.535156 0.671875 14.535156 0.824219 14.535156 1.011719 C 14.535156 1.042969 14.535156 1.042969 14.503906 1.042969 C 14.351562 1.042969 14.230469 1.042969 14.109375 1.042969 C 14.109375 0.890625 14.109375 0.738281 14.109375 0.554688 C 14.230469 0.519531 14.351562 0.519531 14.503906 0.519531 Z M 14.503906 0.519531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 13.15625 0.519531 C 13.1875 0.671875 13.1875 0.824219 13.1875 1.011719 C 13.1875 1.042969 13.1875 1.042969 13.15625 1.042969 C 13.003906 1.042969 12.882812 1.042969 12.761719 1.042969 C 12.761719 0.890625 12.761719 0.738281 12.761719 0.554688 C 12.882812 0.519531 13.003906 0.519531 13.15625 0.519531 Z M 13.15625 0.519531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 9.964844 0.519531 C 9.996094 0.667969 9.996094 0.816406 9.996094 0.996094 C 9.917969 1.03125 9.84375 1.03125 9.726562 1.015625 C 9.644531 0.835938 9.609375 0.679688 9.570312 0.519531 C 9.691406 0.519531 9.8125 0.519531 9.964844 0.519531 Z M 9.964844 0.519531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,89.411765%,90.196079%)",
      fillOpacity: 1
    },
    d: "M 9.539062 0.523438 C 9.609375 0.679688 9.644531 0.835938 9.695312 1.015625 C 9.507812 1.058594 9.304688 1.082031 9.085938 1.078125 C 9.097656 0.894531 9.121094 0.738281 9.144531 0.550781 C 9.265625 0.523438 9.390625 0.523438 9.539062 0.523438 Z M 9.539062 0.523438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 6.90625 1.042969 C 6.875 0.890625 6.875 0.738281 6.875 0.554688 C 7 0.519531 7.121094 0.519531 7.273438 0.519531 C 7.300781 0.671875 7.300781 0.824219 7.300781 1.011719 C 7.179688 1.042969 7.058594 1.042969 6.90625 1.042969 Z M 6.90625 1.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 5.957031 1.042969 C 5.957031 0.890625 5.957031 0.738281 5.953125 0.554688 C 6.078125 0.519531 6.199219 0.519531 6.351562 0.519531 C 6.378906 0.671875 6.378906 0.824219 6.378906 1.011719 C 6.378906 1.042969 6.378906 1.042969 6.351562 1.042969 C 6.199219 1.042969 6.078125 1.042969 5.957031 1.042969 Z M 5.957031 1.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 5.003906 0.519531 C 5.035156 0.671875 5.035156 0.824219 5.035156 1.011719 C 5.035156 1.042969 5.035156 1.042969 5.003906 1.042969 C 4.851562 1.042969 4.730469 1.042969 4.609375 1.042969 C 4.609375 0.890625 4.609375 0.738281 4.609375 0.554688 C 4.730469 0.519531 4.851562 0.519531 5.003906 0.519531 Z M 5.003906 0.519531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 3.65625 0.519531 C 3.6875 0.671875 3.6875 0.824219 3.6875 1.011719 C 3.6875 1.042969 3.6875 1.042969 3.65625 1.042969 C 3.503906 1.042969 3.382812 1.042969 3.261719 1.042969 C 3.261719 0.890625 3.261719 0.738281 3.261719 0.554688 C 3.382812 0.519531 3.503906 0.519531 3.65625 0.519531 Z M 3.65625 0.519531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 2.339844 1.042969 C 2.339844 0.890625 2.339844 0.738281 2.339844 0.554688 C 2.460938 0.519531 2.582031 0.519531 2.734375 0.519531 C 2.765625 0.671875 2.765625 0.824219 2.765625 1.011719 C 2.765625 1.042969 2.765625 1.042969 2.734375 1.042969 C 2.582031 1.042969 2.460938 1.042969 2.339844 1.042969 Z M 2.339844 1.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 1.386719 0.519531 C 1.417969 0.671875 1.417969 0.824219 1.386719 1.007812 C 1.234375 1.042969 1.113281 1.042969 0.992188 1.042969 C 0.992188 0.890625 0.992188 0.738281 0.992188 0.554688 C 1.113281 0.519531 1.234375 0.519531 1.386719 0.519531 Z M 1.386719 0.519531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 18.644531 1.457031 C 18.5 1.488281 18.355469 1.488281 18.179688 1.488281 C 18.148438 1.488281 18.148438 1.488281 18.148438 1.457031 C 18.148438 1.296875 18.148438 1.171875 18.148438 1.042969 C 18.292969 1.042969 18.4375 1.042969 18.613281 1.042969 C 18.644531 1.171875 18.644531 1.296875 18.644531 1.457031 Z M 18.644531 1.457031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 0.992188 8.5625 C 0.847656 8.5625 0.703125 8.5625 0.527344 8.5625 C 0.496094 8.4375 0.496094 8.308594 0.496094 8.148438 C 0.496094 8.117188 0.496094 8.117188 0.527344 8.117188 C 0.703125 8.117188 0.847656 8.117188 0.992188 8.148438 C 0.992188 8.308594 0.992188 8.4375 0.992188 8.5625 Z M 0.992188 8.5625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,98.823529%,98.823529%)",
      fillOpacity: 1
    },
    d: "M 18.148438 7.671875 C 18.292969 7.671875 18.4375 7.671875 18.613281 7.671875 C 18.644531 7.796875 18.644531 7.925781 18.644531 8.085938 C 18.644531 8.117188 18.644531 8.117188 18.613281 8.117188 C 18.4375 8.117188 18.292969 8.117188 18.148438 8.085938 C 18.148438 7.925781 18.148438 7.796875 18.148438 7.671875 Z M 18.148438 7.671875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 0.992188 8.117188 C 0.847656 8.117188 0.703125 8.117188 0.527344 8.117188 C 0.496094 7.988281 0.496094 7.863281 0.496094 7.703125 C 0.640625 7.671875 0.785156 7.671875 0.960938 7.671875 C 0.992188 7.671875 0.992188 7.667969 0.992188 7.703125 C 0.992188 7.863281 0.992188 7.988281 0.992188 8.117188 Z M 0.992188 8.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,98.823529%,98.823529%)",
      fillOpacity: 1
    },
    d: "M 18.644531 7.117188 C 18.5 7.148438 18.355469 7.148438 18.179688 7.148438 C 18.148438 7.148438 18.148438 7.148438 18.148438 7.117188 C 18.148438 6.957031 18.148438 6.828125 18.148438 6.703125 C 18.292969 6.703125 18.4375 6.703125 18.613281 6.703125 C 18.644531 6.828125 18.644531 6.957031 18.644531 7.117188 Z M 18.644531 7.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,98.823529%,98.823529%)",
      fillOpacity: 1
    },
    d: "M 18.644531 9.945312 C 18.5 9.980469 18.355469 9.980469 18.179688 9.980469 C 18.148438 9.980469 18.148438 9.980469 18.148438 9.945312 C 18.148438 9.789062 18.148438 9.660156 18.179688 9.53125 C 18.355469 9.53125 18.5 9.53125 18.644531 9.53125 C 18.644531 9.660156 18.644531 9.789062 18.644531 9.945312 Z M 18.644531 9.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 0.992188 9.976562 C 0.847656 9.980469 0.703125 9.980469 0.527344 9.980469 C 0.496094 9.851562 0.496094 9.722656 0.496094 9.5625 C 0.496094 9.53125 0.496094 9.53125 0.527344 9.53125 C 0.703125 9.53125 0.847656 9.53125 0.992188 9.5625 C 0.992188 9.722656 0.992188 9.851562 0.992188 9.980469 C 0.992188 9.980469 0.992188 9.976562 0.992188 9.976562 Z M 0.992188 9.976562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 18.644531 9.5 C 18.5 9.53125 18.355469 9.53125 18.179688 9.53125 C 18.148438 9.53125 18.148438 9.53125 18.148438 9.5 C 18.148438 9.339844 18.148438 9.210938 18.148438 9.085938 C 18.292969 9.085938 18.4375 9.085938 18.613281 9.085938 C 18.644531 9.210938 18.644531 9.339844 18.644531 9.5 Z M 18.644531 9.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 18.148438 3.871094 C 18.292969 3.871094 18.4375 3.871094 18.613281 3.871094 C 18.644531 4 18.644531 4.128906 18.644531 4.289062 C 18.5 4.320312 18.355469 4.320312 18.179688 4.320312 C 18.148438 4.320312 18.148438 4.320312 18.148438 4.289062 C 18.148438 4.128906 18.148438 4 18.148438 3.871094 Z M 18.148438 3.871094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 0.992188 9.53125 C 0.847656 9.53125 0.703125 9.53125 0.527344 9.53125 C 0.496094 9.40625 0.496094 9.277344 0.496094 9.117188 C 0.640625 9.085938 0.785156 9.085938 0.960938 9.085938 C 0.992188 9.085938 0.992188 9.085938 0.992188 9.117188 C 0.992188 9.277344 0.992188 9.40625 0.992188 9.53125 Z M 0.992188 9.53125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 18.148438 8.117188 C 18.292969 8.117188 18.4375 8.117188 18.613281 8.117188 C 18.644531 8.246094 18.644531 8.371094 18.644531 8.53125 C 18.5 8.5625 18.355469 8.5625 18.179688 8.5625 C 18.148438 8.5625 18.148438 8.5625 18.148438 8.53125 C 18.148438 8.371094 18.148438 8.246094 18.148438 8.117188 Z M 18.148438 8.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 18.644531 5.703125 C 18.5 5.734375 18.355469 5.734375 18.179688 5.734375 C 18.148438 5.734375 18.148438 5.734375 18.148438 5.703125 C 18.148438 5.542969 18.148438 5.414062 18.148438 5.285156 C 18.148438 5.289062 18.148438 5.289062 18.148438 5.289062 C 18.292969 5.289062 18.4375 5.289062 18.613281 5.285156 C 18.644531 5.414062 18.644531 5.542969 18.644531 5.703125 Z M 18.644531 5.703125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 0.496094 5.320312 C 0.640625 5.285156 0.785156 5.289062 0.960938 5.289062 C 0.992188 5.289062 0.992188 5.285156 0.992188 5.320312 C 0.992188 5.480469 0.992188 5.605469 0.992188 5.734375 C 0.847656 5.734375 0.703125 5.734375 0.527344 5.734375 C 0.496094 5.605469 0.496094 5.480469 0.496094 5.320312 Z M 0.496094 5.320312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 3.261719 12.363281 C 3.117188 12.363281 2.972656 12.363281 2.796875 12.363281 C 2.765625 12.363281 2.765625 12.363281 2.765625 12.328125 C 2.765625 12.171875 2.765625 12.042969 2.796875 11.914062 C 2.972656 11.914062 3.117188 11.914062 3.261719 11.945312 C 3.261719 12.105469 3.261719 12.234375 3.261719 12.363281 Z M 3.261719 12.363281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 3.6875 12.359375 C 3.707031 12.640625 3.699219 12.886719 3.292969 12.808594 C 3.261719 12.683594 3.261719 12.554688 3.261719 12.394531 C 3.261719 12.363281 3.261719 12.363281 3.292969 12.363281 C 3.445312 12.363281 3.566406 12.363281 3.6875 12.363281 C 3.6875 12.363281 3.6875 12.359375 3.6875 12.359375 Z M 3.6875 12.359375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.470588%,96.470588%,96.470588%)",
      fillOpacity: 1
    },
    d: "M 1.417969 11.410156 C 1.417969 11.265625 1.417969 11.136719 1.417969 10.980469 C 1.417969 10.945312 1.417969 10.945312 1.449219 10.945312 C 1.601562 10.945312 1.722656 10.945312 1.859375 10.945312 C 1.890625 10.945312 1.902344 10.945312 1.914062 10.980469 C 1.914062 11.140625 1.914062 11.265625 1.90625 11.410156 C 1.886719 11.445312 1.867188 11.460938 1.84375 11.46875 C 1.722656 11.46875 1.601562 11.46875 1.449219 11.46875 C 1.417969 11.457031 1.417969 11.441406 1.417969 11.410156 Z M 1.417969 11.410156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 1.847656 11.496094 C 1.867188 11.460938 1.886719 11.445312 1.9375 11.410156 C 2.097656 11.394531 2.21875 11.394531 2.339844 11.414062 C 2.339844 11.429688 2.339844 11.46875 2.339844 11.5 C 2.339844 11.660156 2.339844 11.789062 2.339844 11.914062 C 2.21875 11.914062 2.097656 11.914062 1.945312 11.914062 C 1.890625 11.785156 1.871094 11.65625 1.847656 11.496094 Z M 1.847656 11.496094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 2.765625 11.914062 C 2.765625 12.042969 2.765625 12.171875 2.765625 12.332031 C 2.644531 12.363281 2.523438 12.363281 2.371094 12.363281 C 2.339844 12.234375 2.339844 12.105469 2.339844 11.945312 C 2.339844 11.914062 2.339844 11.914062 2.371094 11.914062 C 2.523438 11.914062 2.644531 11.914062 2.765625 11.914062 Z M 2.765625 11.914062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 0.992188 3.421875 C 0.992188 3.421875 0.992188 3.386719 0.992188 3.371094 C 0.992188 3.222656 0.992188 3.097656 0.992188 2.9375 C 1.113281 2.902344 1.234375 2.902344 1.386719 2.9375 C 1.433594 3.136719 1.347656 3.386719 1.644531 3.339844 C 1.71875 3.328125 1.824219 3.199219 1.832031 3.117188 C 1.859375 2.824219 1.632812 2.925781 1.488281 2.90625 C 1.464844 2.902344 1.441406 2.90625 1.417969 2.90625 C 1.417969 2.777344 1.417969 2.648438 1.417969 2.488281 C 1.539062 2.457031 1.660156 2.457031 1.832031 2.457031 C 1.878906 2.457031 1.914062 2.457031 1.914062 2.488281 C 1.839844 2.914062 2.074219 2.929688 2.339844 2.9375 C 2.265625 3.363281 2.5 3.375 2.765625 3.371094 C 2.765625 3.390625 2.765625 3.425781 2.765625 3.457031 C 2.765625 3.617188 2.765625 3.746094 2.734375 3.871094 C 2.582031 3.871094 2.460938 3.871094 2.339844 3.839844 C 2.324219 3.640625 2.410156 3.390625 2.113281 3.4375 C 2.039062 3.449219 1.929688 3.578125 1.921875 3.660156 C 1.898438 3.953125 2.125 3.851562 2.269531 3.871094 C 2.292969 3.875 2.316406 3.871094 2.339844 3.902344 C 2.339844 4.0625 2.339844 4.191406 2.308594 4.320312 C 2.121094 4.335938 1.878906 4.246094 1.925781 4.558594 C 1.933594 4.636719 2.058594 4.746094 2.136719 4.757812 C 2.414062 4.785156 2.316406 4.542969 2.339844 4.394531 C 2.34375 4.367188 2.339844 4.34375 2.371094 4.320312 C 2.523438 4.320312 2.644531 4.320312 2.765625 4.351562 C 2.765625 4.511719 2.765625 4.636719 2.765625 4.785156 C 2.765625 4.800781 2.765625 4.839844 2.734375 4.839844 C 2.328125 4.761719 2.316406 5.007812 2.308594 5.289062 C 1.90625 5.210938 1.886719 5.449219 1.882812 5.734375 C 1.707031 5.734375 1.5625 5.734375 1.417969 5.734375 C 1.417969 5.734375 1.417969 5.734375 1.417969 5.703125 C 1.417969 5.542969 1.417969 5.414062 1.449219 5.285156 C 1.636719 5.269531 1.875 5.359375 1.832031 5.046875 C 1.820312 4.96875 1.699219 4.859375 1.621094 4.851562 C 1.34375 4.824219 1.4375 5.0625 1.417969 5.214844 C 1.414062 5.238281 1.417969 5.261719 1.386719 5.289062 C 1.234375 5.289062 1.113281 5.285156 0.992188 5.285156 C 0.992188 5.285156 0.992188 5.289062 0.992188 5.289062 C 0.992188 5.160156 0.992188 5.03125 0.992188 4.871094 C 0.992188 4.839844 0.992188 4.804688 1.023438 4.785156 C 1.429688 4.847656 1.441406 4.597656 1.417969 4.320312 C 1.417969 4.320312 1.417969 4.320312 1.449219 4.320312 C 1.804688 4.308594 1.953125 4.164062 1.816406 3.984375 C 1.75 3.890625 1.554688 3.90625 1.417969 3.871094 C 1.417969 3.871094 1.417969 3.871094 1.417969 3.839844 C 1.492188 3.414062 1.257812 3.402344 0.992188 3.421875 Z M 0.992188 3.421875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 1.898438 1.042969 C 2.035156 1.042969 2.15625 1.042969 2.308594 1.042969 C 2.339844 1.042969 2.339844 1.042969 2.339844 1.074219 C 2.339844 1.234375 2.339844 1.363281 2.308594 1.488281 C 1.902344 1.410156 1.894531 1.660156 1.894531 1.9375 C 1.878906 1.9375 1.84375 1.9375 1.84375 1.9375 C 1.722656 1.9375 1.601562 1.9375 1.449219 1.9375 C 1.417969 1.808594 1.417969 1.679688 1.417969 1.519531 C 1.417969 1.488281 1.417969 1.488281 1.449219 1.488281 C 1.851562 1.566406 1.871094 1.324219 1.84375 1.042969 C 1.84375 1.042969 1.878906 1.042969 1.898438 1.042969 Z M 1.898438 1.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 1.84375 1.96875 C 1.84375 1.9375 1.878906 1.9375 1.925781 1.9375 C 2.09375 1.9375 2.21875 1.9375 2.339844 1.96875 C 2.339844 2.152344 2.339844 2.304688 2.308594 2.457031 C 2.15625 2.457031 2.035156 2.457031 1.914062 2.457031 C 1.914062 2.457031 1.878906 2.457031 1.859375 2.457031 C 1.84375 2.304688 1.84375 2.152344 1.84375 1.96875 Z M 1.84375 1.96875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 0.992188 1.074219 C 1.113281 1.042969 1.234375 1.042969 1.386719 1.042969 C 1.417969 1.042969 1.417969 1.042969 1.417969 1.074219 C 1.417969 1.234375 1.417969 1.363281 1.417969 1.488281 C 1.296875 1.488281 1.175781 1.488281 1.023438 1.488281 C 0.992188 1.363281 0.992188 1.234375 0.992188 1.074219 Z M 0.992188 1.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.725491%,93.725491%,93.725491%)",
      fillOpacity: 1
    },
    d: "M 5.34375 2.914062 C 5.328125 2.941406 5.316406 2.96875 5.277344 3.019531 C 5.253906 3.042969 5.226562 3.054688 5.214844 3.074219 C 5.308594 3.132812 5.417969 3.199219 5.527344 3.199219 C 8.226562 3.203125 10.921875 3.203125 13.617188 3.199219 C 13.753906 3.199219 13.894531 3.15625 14.039062 3.152344 C 14.09375 3.230469 14.136719 3.292969 14.183594 3.378906 C 14.304688 3.4375 14.417969 3.46875 14.554688 3.519531 C 14.582031 3.648438 14.59375 3.757812 14.585938 3.886719 C 14.578125 4.21875 14.726562 4.363281 15.03125 4.351562 C 15.03125 4.535156 15.03125 4.6875 15.03125 4.867188 C 15.027344 4.929688 15.027344 4.964844 15.007812 4.996094 C 14.980469 4.996094 14.96875 4.996094 14.925781 4.992188 C 11.394531 4.980469 7.894531 4.980469 4.394531 4.980469 C 4.324219 4.980469 4.253906 4.992188 4.167969 4.996094 C 4.152344 4.992188 4.117188 5 4.113281 4.972656 C 4.113281 4.882812 4.113281 4.824219 4.136719 4.761719 C 4.242188 4.640625 4.320312 4.523438 4.433594 4.355469 C 4.28125 4.339844 4.195312 4.328125 4.113281 4.289062 C 4.113281 4.128906 4.113281 4 4.144531 3.871094 C 4.609375 3.871094 4.609375 3.871094 4.636719 3.351562 C 5.042969 3.429688 5.058594 3.1875 5.0625 2.902344 C 5.179688 2.90625 5.261719 2.910156 5.34375 2.914062 Z M 5.34375 2.914062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 14.179688 3.351562 C 14.136719 3.292969 14.09375 3.230469 14.039062 3.136719 C 14.003906 3.082031 13.980469 3.066406 13.933594 3.042969 C 13.890625 3.035156 13.875 3.035156 13.859375 3.035156 C 13.71875 2.867188 13.582031 2.699219 13.417969 2.5 C 13.347656 2.4375 13.304688 2.410156 13.261719 2.382812 C 13.234375 2.382812 13.214844 2.375 13.191406 2.304688 C 13.183594 2.148438 13.1875 2.042969 13.214844 1.9375 C 13.320312 1.9375 13.394531 1.9375 13.46875 1.953125 C 13.46875 1.972656 13.46875 2.007812 13.472656 2.03125 C 13.519531 2.089844 13.566406 2.125 13.613281 2.191406 C 13.632812 2.636719 13.941406 2.382812 14.109375 2.488281 C 14.035156 2.914062 14.265625 2.929688 14.535156 2.9375 C 14.535156 3.09375 14.535156 3.222656 14.535156 3.351562 C 14.535156 3.351562 14.535156 3.351562 14.503906 3.351562 C 14.375 3.351562 14.277344 3.351562 14.179688 3.351562 Z M 14.179688 3.351562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(75.686276%,1.568628%,13.333334%)",
      fillOpacity: 1
    },
    d: "M 13.824219 3.039062 C 13.875 3.035156 13.890625 3.035156 13.910156 3.070312 C 13.851562 3.109375 13.792969 3.125 13.738281 3.125 C 10.984375 3.128906 8.230469 3.128906 5.472656 3.125 C 5.390625 3.125 5.308594 3.078125 5.226562 3.054688 C 5.226562 3.054688 5.253906 3.042969 5.269531 3.039062 C 5.953125 3.039062 6.628906 3.050781 7.300781 3.050781 C 9.464844 3.050781 11.625 3.046875 13.824219 3.039062 Z M 13.824219 3.039062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.431373%,97.254902%,97.254902%)",
      fillOpacity: 1
    },
    d: "M 11.859375 1.5 C 11.839844 1.359375 11.839844 1.230469 11.839844 1.074219 C 11.960938 1.042969 12.082031 1.042969 12.234375 1.042969 C 12.265625 1.042969 12.265625 1.042969 12.265625 1.074219 C 12.1875 1.585938 12.511719 1.480469 12.761719 1.488281 C 12.761719 1.488281 12.761719 1.488281 12.761719 1.519531 C 12.761719 1.679688 12.761719 1.808594 12.75 1.949219 C 12.738281 1.964844 12.722656 1.996094 12.722656 1.996094 C 12.441406 1.835938 12.160156 1.679688 11.859375 1.5 Z M 11.859375 1.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,98.823529%,98.823529%)",
      fillOpacity: 1
    },
    d: "M 5.957031 2.320312 C 5.898438 2.378906 5.835938 2.441406 5.738281 2.492188 C 5.621094 2.472656 5.539062 2.464844 5.457031 2.457031 C 5.457031 2.457031 5.460938 2.457031 5.460938 2.425781 C 5.460938 2.242188 5.460938 2.089844 5.476562 1.9375 C 5.492188 1.9375 5.527344 1.9375 5.558594 1.9375 C 5.710938 1.9375 5.832031 1.9375 5.957031 1.9375 C 5.957031 1.9375 5.957031 1.9375 5.957031 1.96875 C 5.957031 2.105469 5.957031 2.210938 5.957031 2.320312 Z M 5.957031 2.320312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 5.363281 2.90625 C 5.261719 2.910156 5.179688 2.90625 5.0625 2.902344 C 5.035156 2.902344 5.035156 2.90625 5.035156 2.871094 C 5.035156 2.710938 5.035156 2.585938 5.0625 2.457031 C 5.214844 2.457031 5.335938 2.457031 5.460938 2.457031 C 5.460938 2.457031 5.457031 2.457031 5.460938 2.484375 C 5.492188 2.570312 5.519531 2.632812 5.550781 2.691406 C 5.496094 2.757812 5.4375 2.828125 5.363281 2.90625 Z M 5.363281 2.90625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.470588%,96.470588%,96.470588%)",
      fillOpacity: 1
    },
    d: "M 5.980469 2.308594 C 5.957031 2.210938 5.957031 2.105469 5.984375 1.96875 C 6.132812 1.933594 6.25 1.929688 6.367188 1.925781 C 6.367188 1.925781 6.375 1.933594 6.382812 1.9375 C 6.257812 2.0625 6.132812 2.183594 5.980469 2.308594 Z M 5.980469 2.308594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.431373%,97.254902%,97.254902%)",
      fillOpacity: 1
    },
    d: "M 13.1875 1.9375 C 13.1875 2.042969 13.183594 2.148438 13.183594 2.289062 C 13.039062 2.226562 12.894531 2.128906 12.738281 2.011719 C 12.722656 1.996094 12.738281 1.964844 12.78125 1.949219 C 12.945312 1.9375 13.066406 1.9375 13.1875 1.9375 Z M 13.1875 1.9375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.470588%,96.470588%,96.470588%)",
      fillOpacity: 1
    },
    d: "M 5.570312 2.683594 C 5.519531 2.632812 5.492188 2.570312 5.460938 2.484375 C 5.539062 2.464844 5.621094 2.472656 5.71875 2.496094 C 5.6875 2.566406 5.640625 2.621094 5.570312 2.683594 Z M 5.570312 2.683594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 13.269531 2.402344 C 13.304688 2.410156 13.347656 2.4375 13.394531 2.488281 C 13.359375 2.480469 13.316406 2.449219 13.269531 2.402344 Z M 13.269531 2.402344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 6.378906 1.042969 C 6.523438 1.042969 6.671875 1.042969 6.847656 1.042969 C 6.945312 1.417969 6.785156 1.550781 6.410156 1.488281 C 6.378906 1.488281 6.378906 1.488281 6.378906 1.457031 C 6.378906 1.296875 6.378906 1.171875 6.378906 1.042969 Z M 6.378906 1.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 6.371094 1.894531 C 6.25 1.929688 6.132812 1.933594 5.984375 1.9375 C 5.957031 1.9375 5.957031 1.9375 5.957031 1.90625 C 5.957031 1.746094 5.957031 1.617188 5.957031 1.488281 C 5.957031 1.488281 5.953125 1.488281 5.984375 1.488281 C 6.136719 1.488281 6.257812 1.488281 6.378906 1.488281 C 6.378906 1.613281 6.378906 1.738281 6.371094 1.894531 Z M 6.371094 1.894531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.725491%,93.725491%,93.725491%)",
      fillOpacity: 1
    },
    d: "M 13.746094 11.300781 C 13.777344 11.25 13.808594 11.203125 13.863281 11.132812 C 13.886719 11.105469 13.914062 11.097656 13.925781 11.074219 C 13.832031 11.019531 13.722656 10.953125 13.617188 10.953125 C 10.914062 10.945312 8.214844 10.945312 5.515625 10.949219 C 5.378906 10.949219 5.242188 11 5.089844 11.015625 C 5.0625 10.988281 5.046875 10.964844 5.03125 10.921875 C 4.886719 10.761719 4.75 10.632812 4.609375 10.46875 C 4.652344 10.039062 4.449219 9.929688 4.113281 9.949219 C 4.140625 9.792969 4.160156 9.660156 4.199219 9.519531 C 4.207031 9.398438 4.199219 9.289062 4.1875 9.175781 C 4.183594 9.164062 4.179688 9.148438 4.214844 9.15625 C 7.746094 9.167969 11.246094 9.167969 14.746094 9.167969 C 14.816406 9.167969 14.886719 9.15625 14.972656 9.152344 C 14.992188 9.15625 15.023438 9.148438 15.027344 9.179688 C 15.027344 9.320312 15.03125 9.425781 15.003906 9.535156 C 14.691406 9.882812 14.6875 9.964844 14.960938 10.085938 C 14.960938 10.246094 14.960938 10.371094 14.929688 10.5 C 14.527344 10.421875 14.507812 10.664062 14.503906 10.945312 C 14.097656 10.871094 14.082031 11.113281 14.078125 11.394531 C 13.949219 11.363281 13.847656 11.332031 13.746094 11.300781 Z M 13.746094 11.300781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.431373%,90.588236%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 5.105469 11.023438 C 5.242188 11 5.378906 10.949219 5.515625 10.949219 C 8.214844 10.945312 10.914062 10.945312 13.617188 10.953125 C 13.722656 10.953125 13.832031 11.019531 13.910156 11.046875 C 13.847656 11.03125 13.816406 11.023438 13.78125 11.023438 C 11.003906 11.023438 8.226562 11.019531 5.453125 11.023438 C 5.386719 11.023438 5.324219 11.074219 5.257812 11.101562 C 5.257812 11.117188 5.257812 11.136719 5.234375 11.167969 C 5.199219 11.179688 5.183594 11.171875 5.15625 11.15625 C 5.128906 11.105469 5.117188 11.0625 5.105469 11.023438 Z M 5.105469 11.023438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(75.686276%,1.568628%,13.333334%)",
      fillOpacity: 1
    },
    d: "M 5.289062 11.097656 C 5.324219 11.074219 5.386719 11.023438 5.453125 11.023438 C 8.226562 11.019531 11.003906 11.023438 13.78125 11.023438 C 13.816406 11.023438 13.847656 11.03125 13.898438 11.066406 C 13.914062 11.097656 13.886719 11.105469 13.875 11.109375 C 13.199219 11.109375 12.539062 11.097656 11.875 11.097656 C 9.691406 11.09375 7.507812 11.097656 5.289062 11.097656 Z M 5.289062 11.097656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,98.823529%,98.823529%)",
      fillOpacity: 1
    },
    d: "M 6.378906 12.882812 C 6.378906 12.882812 6.378906 12.847656 6.378906 12.796875 C 6.457031 12.351562 6.21875 12.339844 5.953125 12.363281 C 5.953125 12.363281 5.957031 12.363281 5.957031 12.328125 C 5.953125 12.171875 5.953125 12.042969 5.972656 11.914062 C 6.015625 11.914062 6.042969 11.917969 6.066406 11.917969 C 6.355469 12.097656 6.640625 12.28125 6.921875 12.5 C 6.902344 12.652344 6.890625 12.769531 6.875 12.882812 C 6.875 12.882812 6.875 12.882812 6.847656 12.882812 C 6.671875 12.882812 6.523438 12.882812 6.378906 12.882812 Z M 6.378906 12.882812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,89.411765%,90.196079%)",
      fillOpacity: 1
    },
    d: "M 13.1875 12.359375 C 13.066406 12.359375 12.945312 12.359375 12.792969 12.359375 C 12.761719 12.363281 12.761719 12.359375 12.757812 12.335938 C 12.730469 12.277344 12.703125 12.238281 12.671875 12.203125 C 12.96875 11.957031 13.261719 11.710938 13.582031 11.488281 C 13.609375 11.644531 13.609375 11.78125 13.613281 11.914062 C 13.613281 11.914062 13.613281 11.914062 13.582031 11.914062 C 13.175781 11.835938 13.164062 12.082031 13.1875 12.363281 C 13.1875 12.363281 13.1875 12.359375 13.1875 12.359375 Z M 13.1875 12.359375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 13.613281 11.914062 C 13.609375 11.78125 13.609375 11.644531 13.605469 11.476562 C 13.636719 11.402344 13.671875 11.359375 13.726562 11.308594 C 13.847656 11.332031 13.949219 11.363281 14.078125 11.414062 C 14.109375 11.429688 14.109375 11.46875 14.109375 11.5 C 14.109375 11.660156 14.109375 11.789062 14.078125 11.914062 C 13.902344 11.914062 13.757812 11.914062 13.613281 11.914062 Z M 13.613281 11.914062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.470588%,96.470588%,96.470588%)",
      fillOpacity: 1
    },
    d: "M 6.054688 11.894531 C 6.042969 11.917969 6.015625 11.914062 5.941406 11.914062 C 5.773438 11.914062 5.652344 11.914062 5.511719 11.914062 C 5.484375 11.914062 5.46875 11.914062 5.457031 11.882812 C 5.53125 11.460938 5.300781 11.441406 5.035156 11.449219 C 5.035156 11.429688 5.03125 11.394531 5.050781 11.378906 C 5.117188 11.320312 5.160156 11.277344 5.21875 11.222656 C 5.230469 11.210938 5.253906 11.195312 5.253906 11.195312 C 5.515625 11.421875 5.78125 11.648438 6.054688 11.894531 Z M 6.054688 11.894531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.470588%,96.470588%,96.470588%)",
      fillOpacity: 1
    },
    d: "M 6.90625 12.882812 C 6.890625 12.769531 6.902344 12.652344 6.9375 12.523438 C 7.199219 12.605469 7.441406 12.707031 7.695312 12.832031 C 7.59375 12.863281 7.480469 12.875 7.335938 12.882812 C 7.179688 12.882812 7.058594 12.882812 6.90625 12.882812 Z M 6.90625 12.882812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 12.761719 12.359375 C 12.761719 12.488281 12.761719 12.617188 12.730469 12.777344 C 12.578125 12.808594 12.457031 12.808594 12.335938 12.808594 C 12.335938 12.699219 12.335938 12.59375 12.332031 12.453125 C 12.355469 12.398438 12.382812 12.375 12.457031 12.355469 C 12.59375 12.359375 12.675781 12.359375 12.761719 12.359375 C 12.761719 12.359375 12.761719 12.363281 12.761719 12.359375 Z M 12.761719 12.359375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.078432%,96.078432%,96.470588%)",
      fillOpacity: 1
    },
    d: "M 12.757812 12.335938 C 12.675781 12.359375 12.59375 12.359375 12.476562 12.355469 C 12.503906 12.304688 12.566406 12.253906 12.648438 12.207031 C 12.703125 12.238281 12.730469 12.277344 12.757812 12.335938 Z M 12.757812 12.335938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,89.411765%,90.196079%)",
      fillOpacity: 1
    },
    d: "M 8.859375 13.15625 C 8.800781 13.152344 8.730469 13.128906 8.652344 13.078125 C 8.714844 13.082031 8.78125 13.109375 8.859375 13.15625 Z M 8.859375 13.15625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,89.411765%,90.196079%)",
      fillOpacity: 1
    },
    d: "M 9.191406 13.117188 C 9.179688 13.144531 9.144531 13.160156 9.089844 13.179688 C 9.101562 13.15625 9.136719 13.132812 9.191406 13.117188 Z M 9.191406 13.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(75.686276%,1.568628%,13.333334%)",
      fillOpacity: 1
    },
    d: "M 5.253906 11.199219 C 5.253906 11.195312 5.230469 11.210938 5.214844 11.203125 C 5.191406 11.183594 5.179688 11.175781 5.171875 11.167969 C 5.183594 11.171875 5.199219 11.179688 5.234375 11.195312 C 5.253906 11.207031 5.253906 11.203125 5.253906 11.199219 Z M 5.253906 11.199219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 12.324219 12.835938 C 12.457031 12.808594 12.578125 12.808594 12.730469 12.808594 C 12.761719 12.808594 12.761719 12.84375 12.761719 12.863281 C 12.761719 13.007812 12.761719 13.136719 12.761719 13.296875 C 12.617188 13.328125 12.472656 13.328125 12.296875 13.328125 C 12.28125 13.175781 12.296875 13.019531 12.324219 12.835938 Z M 12.324219 12.835938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.470588%,96.470588%,96.470588%)",
      fillOpacity: 1
    },
    d: "M 1.417969 6.703125 C 1.417969 6.574219 1.417969 6.445312 1.417969 6.289062 C 1.417969 6.242188 1.417969 6.230469 1.449219 6.199219 C 1.601562 6.179688 1.722656 6.179688 1.859375 6.1875 C 1.894531 6.210938 1.90625 6.230469 1.914062 6.285156 C 1.914062 6.445312 1.914062 6.574219 1.898438 6.703125 C 1.867188 6.703125 1.855469 6.703125 1.8125 6.703125 C 1.660156 6.703125 1.539062 6.703125 1.417969 6.703125 Z M 1.417969 6.703125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 1.84375 6.179688 C 1.722656 6.179688 1.601562 6.179688 1.449219 6.179688 C 1.417969 6.054688 1.417969 5.925781 1.417969 5.765625 C 1.5625 5.734375 1.707031 5.734375 1.882812 5.734375 C 1.914062 5.734375 1.914062 5.734375 1.914062 5.761719 C 1.890625 5.921875 1.867188 6.050781 1.84375 6.179688 Z M 1.84375 6.179688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 1.417969 5.285156 C 1.417969 5.414062 1.417969 5.542969 1.417969 5.703125 C 1.296875 5.734375 1.175781 5.734375 1.023438 5.734375 C 0.992188 5.605469 0.992188 5.480469 0.992188 5.320312 C 1.113281 5.285156 1.234375 5.289062 1.386719 5.289062 C 1.417969 5.289062 1.417969 5.285156 1.417969 5.285156 Z M 1.417969 5.285156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 0.992188 6.734375 C 1.113281 6.703125 1.234375 6.703125 1.386719 6.703125 C 1.417969 6.703125 1.417969 6.703125 1.417969 6.734375 C 1.417969 6.894531 1.417969 7.023438 1.386719 7.148438 C 1.234375 7.148438 1.113281 7.148438 0.992188 7.148438 C 0.992188 7.019531 0.992188 6.894531 0.992188 6.734375 Z M 0.992188 6.734375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 1.417969 10.945312 C 1.296875 10.945312 1.175781 10.945312 1.023438 10.945312 C 0.992188 10.820312 0.992188 10.691406 0.992188 10.53125 C 0.992188 10.5 0.992188 10.5 1.023438 10.5 C 1.175781 10.5 1.296875 10.5 1.417969 10.53125 C 1.417969 10.691406 1.417969 10.820312 1.417969 10.945312 Z M 1.417969 10.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 15.910156 13.328125 C 15.878906 13.203125 15.878906 13.074219 15.882812 12.914062 C 15.882812 12.882812 15.878906 12.84375 15.910156 12.828125 C 16.085938 12.808594 16.230469 12.808594 16.378906 12.808594 C 16.378906 12.808594 16.375 12.84375 16.375 12.863281 C 16.375 13.007812 16.375 13.136719 16.378906 13.296875 C 16.230469 13.328125 16.085938 13.328125 15.910156 13.328125 Z M 15.910156 13.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 16.375 12.777344 C 16.230469 12.808594 16.085938 12.808594 15.910156 12.808594 C 15.878906 12.679688 15.878906 12.554688 15.878906 12.394531 C 15.878906 12.363281 15.878906 12.363281 15.910156 12.363281 C 16.085938 12.363281 16.230469 12.363281 16.378906 12.363281 C 16.375 12.363281 16.375 12.359375 16.375 12.359375 C 16.375 12.488281 16.375 12.617188 16.375 12.777344 Z M 16.375 12.777344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 17.300781 11.914062 C 17.152344 11.914062 17.007812 11.914062 16.832031 11.914062 C 16.800781 11.914062 16.800781 11.914062 16.800781 11.882812 C 16.726562 11.457031 16.964844 11.445312 17.238281 11.492188 C 17.265625 11.652344 17.28125 11.78125 17.296875 11.914062 C 17.296875 11.914062 17.300781 11.914062 17.300781 11.914062 Z M 17.300781 11.914062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 16.800781 12.359375 C 16.679688 12.363281 16.558594 12.363281 16.40625 12.363281 C 16.375 12.359375 16.375 12.363281 16.375 12.328125 C 16.375 12.171875 16.375 12.042969 16.40625 11.914062 C 16.558594 11.914062 16.679688 11.914062 16.800781 11.914062 C 16.800781 12.042969 16.800781 12.171875 16.800781 12.328125 C 16.800781 12.363281 16.800781 12.359375 16.800781 12.359375 Z M 16.800781 12.359375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 17.722656 12.359375 C 17.457031 12.386719 17.222656 12.371094 17.296875 11.945312 C 17.300781 11.914062 17.296875 11.914062 17.328125 11.914062 C 17.480469 11.914062 17.601562 11.914062 17.722656 11.914062 C 17.722656 11.914062 17.722656 11.914062 17.722656 11.945312 C 17.722656 12.105469 17.722656 12.234375 17.722656 12.363281 C 17.722656 12.363281 17.722656 12.359375 17.722656 12.359375 Z M 17.722656 12.359375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 17.722656 13.328125 C 17.699219 13.328125 17.675781 13.332031 17.652344 13.328125 C 17.507812 13.308594 17.28125 13.410156 17.308594 13.117188 C 17.316406 13.035156 17.421875 12.90625 17.496094 12.894531 C 17.792969 12.847656 17.707031 13.097656 17.722656 13.296875 C 17.722656 13.332031 17.722656 13.328125 17.722656 13.328125 Z M 17.722656 13.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 18.148438 12.363281 C 18.148438 12.488281 18.148438 12.617188 18.148438 12.777344 C 17.886719 12.832031 17.648438 12.820312 17.722656 12.394531 C 17.722656 12.359375 17.722656 12.363281 17.753906 12.363281 C 17.90625 12.363281 18.027344 12.363281 18.148438 12.363281 Z M 18.148438 12.363281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 16.800781 12.363281 C 16.824219 12.363281 16.847656 12.359375 16.871094 12.363281 C 17.015625 12.382812 17.246094 12.28125 17.21875 12.574219 C 17.210938 12.65625 17.105469 12.785156 17.03125 12.796875 C 16.730469 12.84375 16.820312 12.59375 16.800781 12.394531 C 16.800781 12.359375 16.800781 12.363281 16.800781 12.363281 Z M 16.800781 12.363281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 5.035156 12.882812 C 4.914062 12.882812 4.789062 12.882812 4.636719 12.882812 C 4.609375 12.882812 4.609375 12.882812 4.609375 12.851562 C 4.609375 12.664062 4.609375 12.511719 4.636719 12.363281 C 4.789062 12.363281 4.914062 12.363281 5.035156 12.363281 C 5.035156 12.363281 5.035156 12.363281 5.035156 12.394531 C 5.035156 12.578125 5.035156 12.730469 5.035156 12.882812 Z M 5.035156 12.882812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 14.136719 12.808594 C 14.109375 12.679688 14.109375 12.554688 14.109375 12.394531 C 14.109375 12.363281 14.109375 12.363281 14.136719 12.363281 C 14.289062 12.363281 14.414062 12.363281 14.535156 12.363281 C 14.535156 12.488281 14.535156 12.617188 14.535156 12.777344 C 14.414062 12.808594 14.289062 12.808594 14.136719 12.808594 Z M 14.136719 12.808594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 5.0625 12.882812 C 5.035156 12.730469 5.035156 12.578125 5.066406 12.394531 C 5.242188 12.363281 5.386719 12.363281 5.53125 12.363281 C 5.53125 12.363281 5.53125 12.359375 5.53125 12.359375 C 5.554688 12.691406 5.496094 12.945312 5.0625 12.882812 Z M 5.0625 12.882812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 6.378906 12.914062 C 6.523438 12.882812 6.671875 12.882812 6.847656 12.882812 C 6.851562 13.011719 6.828125 13.140625 6.804688 13.300781 C 6.683594 13.328125 6.5625 13.328125 6.410156 13.328125 C 6.378906 13.203125 6.378906 13.074219 6.378906 12.914062 Z M 6.378906 12.914062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 5.953125 12.394531 C 6.21875 12.339844 6.457031 12.351562 6.378906 12.777344 C 6.117188 12.832031 5.878906 12.820312 5.953125 12.394531 Z M 5.953125 12.394531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 5.53125 11.914062 C 5.652344 11.914062 5.773438 11.914062 5.925781 11.914062 C 5.953125 12.042969 5.953125 12.171875 5.957031 12.332031 C 5.832031 12.363281 5.710938 12.363281 5.558594 12.363281 C 5.53125 12.359375 5.53125 12.363281 5.53125 12.328125 C 5.53125 12.171875 5.53125 12.042969 5.53125 11.914062 Z M 5.53125 11.914062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 4.609375 12.359375 C 4.609375 12.511719 4.609375 12.664062 4.609375 12.851562 C 4.273438 12.933594 4.070312 12.824219 4.113281 12.390625 C 4.113281 12.363281 4.113281 12.363281 4.144531 12.363281 C 4.320312 12.363281 4.464844 12.363281 4.609375 12.363281 C 4.609375 12.363281 4.609375 12.359375 4.609375 12.359375 Z M 4.609375 12.359375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 4.113281 12.363281 C 3.992188 12.363281 3.867188 12.363281 3.714844 12.363281 C 3.6875 12.359375 3.6875 12.363281 3.6875 12.328125 C 3.6875 12.171875 3.6875 12.042969 3.714844 11.914062 C 3.867188 11.914062 3.992188 11.914062 4.113281 11.945312 C 4.113281 12.105469 4.113281 12.234375 4.113281 12.363281 Z M 4.113281 12.363281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 15.03125 12.359375 C 14.886719 12.363281 14.742188 12.363281 14.5625 12.363281 C 14.535156 12.363281 14.535156 12.363281 14.535156 12.328125 C 14.535156 12.171875 14.535156 12.042969 14.535156 11.914062 C 14.535156 11.914062 14.535156 11.914062 14.5625 11.914062 C 14.742188 11.914062 14.886719 11.914062 15.03125 11.945312 C 15.03125 12.105469 15.03125 12.234375 15.03125 12.363281 C 15.03125 12.363281 15.03125 12.359375 15.03125 12.359375 Z M 15.03125 12.359375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 15.878906 12.363281 C 15.757812 12.363281 15.636719 12.363281 15.484375 12.363281 C 15.457031 12.363281 15.457031 12.363281 15.457031 12.332031 C 15.457031 12.171875 15.453125 12.042969 15.484375 11.914062 C 15.636719 11.914062 15.757812 11.914062 15.878906 11.945312 C 15.878906 12.105469 15.878906 12.234375 15.878906 12.363281 Z M 15.878906 12.363281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 15.453125 12.363281 C 15.421875 12.503906 15.4375 12.710938 15.351562 12.78125 C 15.175781 12.925781 15.039062 12.769531 15.03125 12.394531 C 15.03125 12.359375 15.03125 12.363281 15.058594 12.363281 C 15.210938 12.363281 15.332031 12.363281 15.457031 12.363281 C 15.457031 12.363281 15.457031 12.363281 15.453125 12.363281 Z M 15.453125 12.363281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 13.613281 11.914062 C 13.757812 11.914062 13.902344 11.914062 14.078125 11.914062 C 14.109375 11.914062 14.109375 11.914062 14.109375 11.945312 C 14.109375 12.105469 14.109375 12.234375 14.109375 12.363281 C 13.964844 12.363281 13.820312 12.363281 13.644531 12.363281 C 13.613281 12.363281 13.613281 12.363281 13.613281 12.332031 C 13.613281 12.171875 13.613281 12.042969 13.613281 11.914062 Z M 13.613281 11.914062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 13.613281 12.363281 C 13.578125 12.503906 13.59375 12.710938 13.507812 12.78125 C 13.332031 12.925781 13.195312 12.769531 13.1875 12.394531 C 13.1875 12.359375 13.1875 12.363281 13.214844 12.363281 C 13.367188 12.363281 13.492188 12.363281 13.613281 12.363281 Z M 13.613281 12.363281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 18.148438 4.320312 C 18.148438 4.445312 18.148438 4.574219 18.148438 4.734375 C 18.148438 4.765625 18.148438 4.800781 18.117188 4.820312 C 17.710938 4.761719 17.703125 5.007812 17.722656 5.289062 C 17.722656 5.289062 17.722656 5.285156 17.695312 5.285156 C 17.292969 5.210938 17.269531 5.449219 17.269531 5.734375 C 17.09375 5.734375 16.945312 5.734375 16.800781 5.703125 C 16.800781 5.542969 16.800781 5.414062 16.832031 5.285156 C 17.023438 5.269531 17.261719 5.359375 17.21875 5.046875 C 17.207031 4.96875 17.082031 4.859375 17.003906 4.851562 C 16.726562 4.824219 16.824219 5.0625 16.804688 5.214844 C 16.800781 5.238281 16.800781 5.261719 16.773438 5.289062 C 16.621094 5.289062 16.5 5.289062 16.375 5.253906 C 16.375 5.097656 16.375 4.96875 16.375 4.820312 C 16.375 4.804688 16.375 4.769531 16.40625 4.765625 C 16.8125 4.84375 16.824219 4.597656 16.832031 4.320312 C 17.234375 4.394531 17.253906 4.15625 17.226562 3.871094 C 17.226562 3.871094 17.226562 3.871094 17.257812 3.871094 C 17.433594 3.871094 17.578125 3.871094 17.722656 3.871094 C 17.722656 3.871094 17.722656 3.871094 17.722656 3.902344 C 17.722656 4.0625 17.722656 4.191406 17.695312 4.320312 C 17.503906 4.335938 17.265625 4.246094 17.308594 4.558594 C 17.320312 4.636719 17.441406 4.746094 17.519531 4.753906 C 17.800781 4.785156 17.703125 4.542969 17.722656 4.394531 C 17.726562 4.367188 17.722656 4.34375 17.753906 4.320312 C 17.90625 4.320312 18.027344 4.320312 18.148438 4.320312 Z M 18.148438 4.320312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 17.722656 5.289062 C 17.703125 5.007812 17.710938 4.761719 18.117188 4.839844 C 18.148438 4.964844 18.148438 5.09375 18.148438 5.253906 C 18.148438 5.289062 18.148438 5.289062 18.117188 5.289062 C 17.96875 5.289062 17.84375 5.289062 17.722656 5.289062 Z M 17.722656 5.289062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 1.417969 4.320312 C 1.441406 4.597656 1.429688 4.847656 1.023438 4.765625 C 0.992188 4.640625 0.992188 4.511719 0.992188 4.351562 C 0.992188 4.320312 0.992188 4.320312 1.023438 4.320312 C 1.175781 4.320312 1.296875 4.320312 1.417969 4.320312 Z M 1.417969 4.320312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 0.992188 9.085938 C 0.992188 8.933594 0.992188 8.78125 0.992188 8.597656 C 0.992188 8.5625 0.992188 8.5625 1.023438 8.5625 C 1.175781 8.5625 1.296875 8.5625 1.417969 8.597656 C 1.417969 8.78125 1.417969 8.933594 1.386719 9.085938 C 1.234375 9.085938 1.113281 9.085938 0.992188 9.085938 Z M 0.992188 9.085938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 18.148438 8.5625 C 18.148438 8.714844 18.148438 8.867188 18.148438 9.050781 C 18.148438 9.085938 18.148438 9.085938 18.117188 9.085938 C 17.96875 9.085938 17.84375 9.085938 17.722656 9.050781 C 17.722656 8.867188 17.722656 8.714844 17.753906 8.5625 C 17.90625 8.5625 18.027344 8.5625 18.148438 8.5625 Z M 18.148438 8.5625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 1.417969 10.5 C 1.296875 10.5 1.175781 10.5 1.023438 10.5 C 0.992188 10.347656 0.992188 10.195312 0.992188 10.011719 C 0.992188 9.976562 0.992188 9.980469 1.023438 9.980469 C 1.175781 9.980469 1.296875 9.980469 1.417969 10.011719 C 1.417969 10.195312 1.417969 10.347656 1.417969 10.5 Z M 1.417969 10.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 18.148438 9.980469 C 18.148438 10.128906 18.148438 10.28125 18.148438 10.46875 C 18.148438 10.5 18.148438 10.5 18.117188 10.5 C 17.96875 10.5 17.84375 10.5 17.722656 10.5 C 17.722656 10.5 17.722656 10.5 17.722656 10.46875 C 17.722656 10.28125 17.722656 10.128906 17.753906 9.980469 C 17.90625 9.980469 18.027344 9.980469 18.148438 9.980469 Z M 18.148438 9.980469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 18.148438 6.238281 C 18.148438 6.382812 18.148438 6.511719 18.148438 6.671875 C 18.148438 6.703125 18.148438 6.703125 18.117188 6.703125 C 17.96875 6.703125 17.84375 6.703125 17.722656 6.671875 C 17.722656 6.511719 17.722656 6.382812 17.722656 6.234375 C 17.722656 6.21875 17.722656 6.183594 17.753906 6.183594 C 17.90625 6.183594 18.027344 6.183594 18.148438 6.183594 C 18.148438 6.183594 18.148438 6.21875 18.148438 6.238281 Z M 18.148438 6.238281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 18.148438 6.148438 C 18.027344 6.183594 17.90625 6.183594 17.753906 6.148438 C 17.722656 5.988281 17.722656 5.863281 17.722656 5.734375 C 17.722656 5.734375 17.722656 5.734375 17.753906 5.734375 C 17.90625 5.734375 18.027344 5.734375 18.148438 5.734375 C 18.148438 5.863281 18.148438 5.988281 18.148438 6.148438 Z M 18.148438 6.148438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 0.992188 7.179688 C 1.113281 7.148438 1.234375 7.148438 1.386719 7.148438 C 1.417969 7.148438 1.417969 7.148438 1.417969 7.179688 C 1.417969 7.367188 1.417969 7.519531 1.386719 7.671875 C 1.234375 7.667969 1.113281 7.667969 0.992188 7.667969 C 0.992188 7.667969 0.992188 7.671875 0.992188 7.671875 C 0.992188 7.519531 0.992188 7.367188 0.992188 7.179688 Z M 0.992188 7.179688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 18.148438 7.148438 C 18.148438 7.300781 18.148438 7.453125 18.148438 7.636719 C 18.148438 7.671875 18.148438 7.671875 18.117188 7.671875 C 17.96875 7.671875 17.84375 7.671875 17.722656 7.636719 C 17.722656 7.453125 17.722656 7.300781 17.753906 7.148438 C 17.90625 7.148438 18.027344 7.148438 18.148438 7.148438 Z M 18.148438 7.148438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 18.148438 1.9375 C 18.148438 2.089844 18.148438 2.242188 18.148438 2.425781 C 18.148438 2.457031 18.148438 2.457031 18.117188 2.457031 C 17.96875 2.457031 17.84375 2.457031 17.722656 2.425781 C 17.722656 2.242188 17.722656 2.089844 17.753906 1.9375 C 17.90625 1.9375 18.027344 1.9375 18.148438 1.9375 Z M 18.148438 1.9375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 17.28125 1.042969 C 17.421875 1.042969 17.542969 1.042969 17.695312 1.042969 C 17.722656 1.042969 17.722656 1.042969 17.722656 1.074219 C 17.722656 1.234375 17.722656 1.363281 17.722656 1.488281 C 17.722656 1.488281 17.722656 1.488281 17.695312 1.488281 C 17.289062 1.410156 17.277344 1.660156 17.277344 1.9375 C 17.261719 1.9375 17.226562 1.9375 17.199219 1.9375 C 17.046875 1.9375 16.921875 1.9375 16.800781 1.90625 C 16.800781 1.746094 16.800781 1.617188 16.800781 1.488281 C 16.800781 1.488281 16.800781 1.488281 16.832031 1.488281 C 17.238281 1.570312 17.25 1.320312 17.230469 1.042969 C 17.230469 1.042969 17.265625 1.042969 17.28125 1.042969 Z M 17.28125 1.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 17.199219 1.042969 C 17.25 1.320312 17.238281 1.570312 16.832031 1.457031 C 16.800781 1.296875 16.800781 1.171875 16.800781 1.042969 C 16.925781 1.042969 17.046875 1.042969 17.199219 1.042969 Z M 17.199219 1.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 12.761719 1.488281 C 12.511719 1.480469 12.1875 1.585938 12.265625 1.074219 C 12.410156 1.042969 12.554688 1.042969 12.730469 1.042969 C 12.761719 1.042969 12.761719 1.042969 12.761719 1.074219 C 12.761719 1.234375 12.761719 1.363281 12.761719 1.488281 Z M 12.761719 1.488281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 2.765625 1.042969 C 2.910156 1.042969 3.054688 1.042969 3.230469 1.042969 C 3.261719 1.042969 3.261719 1.042969 3.261719 1.074219 C 3.261719 1.234375 3.261719 1.363281 3.230469 1.488281 C 3.054688 1.488281 2.910156 1.488281 2.765625 1.457031 C 2.765625 1.296875 2.765625 1.171875 2.765625 1.042969 Z M 2.765625 1.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 1.449219 1.488281 C 1.417969 1.363281 1.417969 1.234375 1.417969 1.074219 C 1.539062 1.042969 1.660156 1.042969 1.8125 1.042969 C 1.871094 1.324219 1.851562 1.566406 1.449219 1.488281 Z M 1.449219 1.488281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 0.992188 3.457031 C 1.257812 3.402344 1.492188 3.414062 1.386719 3.839844 C 1.234375 3.871094 1.113281 3.871094 0.992188 3.871094 C 0.992188 3.746094 0.992188 3.617188 0.992188 3.457031 Z M 0.992188 3.457031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 13.46875 1.9375 C 13.394531 1.9375 13.320312 1.9375 13.214844 1.9375 C 13.1875 1.9375 13.1875 1.9375 13.1875 1.902344 C 13.1875 1.746094 13.1875 1.617188 13.1875 1.488281 C 13.1875 1.488281 13.1875 1.488281 13.214844 1.488281 C 13.621094 1.570312 13.632812 1.320312 13.613281 1.042969 C 13.613281 1.042969 13.648438 1.042969 13.664062 1.042969 C 13.804688 1.042969 13.925781 1.042969 14.078125 1.042969 C 14.109375 1.042969 14.109375 1.042969 14.109375 1.074219 C 14.109375 1.234375 14.109375 1.363281 14.078125 1.488281 C 13.710938 1.429688 13.617188 1.636719 13.589844 1.9375 C 13.53125 1.9375 13.5 1.9375 13.46875 1.9375 Z M 13.46875 1.9375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 13.582031 1.042969 C 13.632812 1.320312 13.621094 1.570312 13.21875 1.457031 C 13.1875 1.296875 13.1875 1.171875 13.1875 1.042969 C 13.308594 1.042969 13.429688 1.042969 13.582031 1.042969 Z M 13.582031 1.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 18.148438 3.40625 C 18.148438 3.554688 18.148438 3.679688 18.148438 3.839844 C 18.148438 3.871094 18.148438 3.871094 18.117188 3.871094 C 17.96875 3.871094 17.84375 3.871094 17.722656 3.871094 C 17.722656 3.871094 17.722656 3.871094 17.722656 3.839844 C 17.695312 3.664062 17.808594 3.414062 17.539062 3.4375 C 17.429688 3.449219 17.328125 3.59375 17.238281 3.695312 C 17.207031 3.726562 17.230469 3.8125 17.226562 3.871094 C 17.226562 3.871094 17.226562 3.871094 17.199219 3.871094 C 17.046875 3.871094 16.921875 3.871094 16.800781 3.839844 C 16.875 3.417969 16.644531 3.398438 16.375 3.40625 C 16.375 3.386719 16.378906 3.351562 16.375 3.320312 C 16.375 3.160156 16.375 3.03125 16.40625 2.902344 C 16.558594 2.902344 16.679688 2.902344 16.800781 2.9375 C 16.820312 3.136719 16.730469 3.386719 17.03125 3.339844 C 17.105469 3.328125 17.210938 3.199219 17.21875 3.117188 C 17.246094 2.824219 17.015625 2.925781 16.871094 2.90625 C 16.847656 2.902344 16.824219 2.90625 16.800781 2.871094 C 16.800781 2.710938 16.800781 2.585938 16.832031 2.457031 C 16.984375 2.457031 17.105469 2.457031 17.246094 2.457031 C 17.261719 2.457031 17.296875 2.457031 17.296875 2.488281 C 17.222656 2.917969 17.460938 2.925781 17.722656 2.90625 C 17.722656 2.902344 17.722656 2.902344 17.722656 2.9375 C 17.648438 3.363281 17.886719 3.375 18.148438 3.351562 C 18.148438 3.351562 18.148438 3.390625 18.148438 3.40625 Z M 18.148438 3.40625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 18.148438 3.320312 C 17.886719 3.375 17.648438 3.363281 17.753906 2.9375 C 17.90625 2.90625 18.027344 2.90625 18.148438 2.90625 C 18.148438 2.90625 18.148438 2.902344 18.148438 2.902344 C 18.148438 3.03125 18.148438 3.160156 18.148438 3.320312 Z M 18.148438 3.320312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 15.878906 1.042969 C 16.023438 1.042969 16.171875 1.042969 16.347656 1.042969 C 16.378906 1.042969 16.375 1.042969 16.375 1.074219 C 16.375 1.234375 16.375 1.363281 16.375 1.488281 C 16.375 1.488281 16.378906 1.488281 16.347656 1.488281 C 16.171875 1.488281 16.023438 1.488281 15.878906 1.457031 C 15.878906 1.296875 15.882812 1.171875 15.882812 1.042969 C 15.882812 1.042969 15.878906 1.042969 15.878906 1.042969 Z M 15.878906 1.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 14.535156 1.042969 C 14.65625 1.042969 14.777344 1.042969 14.929688 1.042969 C 14.960938 1.042969 14.992188 1.042969 15.011719 1.074219 C 14.953125 1.5 15.191406 1.511719 15.457031 1.488281 C 15.457031 1.488281 15.453125 1.488281 15.453125 1.519531 C 15.457031 1.679688 15.457031 1.808594 15.425781 1.9375 C 15.273438 1.9375 15.152344 1.9375 15.027344 1.90625 C 15.019531 1.527344 14.824219 1.441406 14.535156 1.457031 C 14.535156 1.296875 14.535156 1.171875 14.535156 1.042969 Z M 14.535156 1.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 15.457031 1.488281 C 15.191406 1.511719 14.953125 1.5 15.027344 1.074219 C 15.148438 1.042969 15.273438 1.042969 15.425781 1.042969 C 15.457031 1.042969 15.457031 1.042969 15.457031 1.074219 C 15.457031 1.234375 15.457031 1.363281 15.457031 1.488281 Z M 15.457031 1.488281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 18.148438 11.363281 C 18.148438 11.394531 18.148438 11.429688 18.117188 11.449219 C 17.96875 11.46875 17.84375 11.46875 17.722656 11.449219 C 17.722656 11.429688 17.722656 11.394531 17.722656 11.363281 C 17.722656 11.203125 17.722656 11.074219 17.722656 10.945312 C 17.722656 10.945312 17.722656 10.945312 17.753906 10.945312 C 17.90625 10.945312 18.027344 10.945312 18.148438 10.945312 C 18.148438 11.074219 18.148438 11.203125 18.148438 11.363281 Z M 18.148438 11.363281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 5.527344 1.9375 C 5.527344 1.9375 5.492188 1.9375 5.445312 1.9375 C 5.277344 1.9375 5.15625 1.9375 5.035156 1.90625 C 5.035156 1.746094 5.035156 1.617188 5.035156 1.488281 C 5.035156 1.488281 5.035156 1.488281 5.0625 1.488281 C 5.433594 1.550781 5.523438 1.34375 5.53125 1.042969 C 5.652344 1.042969 5.773438 1.042969 5.925781 1.042969 C 5.957031 1.042969 5.957031 1.042969 5.957031 1.074219 C 5.953125 1.234375 5.953125 1.363281 5.953125 1.488281 C 5.953125 1.488281 5.957031 1.488281 5.925781 1.488281 C 5.519531 1.410156 5.507812 1.660156 5.527344 1.9375 Z M 5.527344 1.9375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 3.6875 1.042969 C 3.808594 1.042969 3.929688 1.042969 4.082031 1.042969 C 4.113281 1.042969 4.113281 1.042969 4.113281 1.074219 C 4.113281 1.234375 4.113281 1.363281 4.082031 1.488281 C 3.929688 1.488281 3.808594 1.488281 3.6875 1.457031 C 3.6875 1.296875 3.6875 1.171875 3.6875 1.042969 Z M 3.6875 1.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 4.113281 1.488281 C 4.113281 1.363281 4.113281 1.234375 4.113281 1.074219 C 4.257812 1.042969 4.402344 1.042969 4.578125 1.042969 C 4.609375 1.042969 4.609375 1.042969 4.609375 1.074219 C 4.609375 1.234375 4.609375 1.363281 4.609375 1.488281 C 4.609375 1.488281 4.609375 1.488281 4.578125 1.488281 C 4.402344 1.488281 4.257812 1.488281 4.113281 1.488281 Z M 4.113281 1.488281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 5.5 1.042969 C 5.523438 1.34375 5.433594 1.550781 5.0625 1.457031 C 5.035156 1.296875 5.035156 1.171875 5.035156 1.042969 C 5.179688 1.042969 5.324219 1.042969 5.5 1.042969 Z M 5.5 1.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 17.722656 11.46875 C 17.84375 11.46875 17.96875 11.46875 18.117188 11.46875 C 18.148438 11.59375 18.148438 11.722656 18.148438 11.882812 C 18.148438 11.914062 18.148438 11.914062 18.117188 11.914062 C 17.96875 11.914062 17.84375 11.914062 17.722656 11.914062 C 17.722656 11.914062 17.722656 11.914062 17.722656 11.882812 C 17.722656 11.722656 17.722656 11.59375 17.722656 11.46875 Z M 17.722656 11.46875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 17.722656 11.945312 C 17.84375 11.914062 17.96875 11.914062 18.121094 11.914062 C 18.148438 12.042969 18.148438 12.171875 18.148438 12.332031 C 18.027344 12.363281 17.90625 12.363281 17.753906 12.363281 C 17.722656 12.234375 17.722656 12.105469 17.722656 11.945312 Z M 17.722656 11.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 18.148438 10.914062 C 18.027344 10.945312 17.90625 10.945312 17.753906 10.914062 C 17.722656 10.753906 17.722656 10.628906 17.722656 10.5 C 17.84375 10.5 17.96875 10.5 18.117188 10.5 C 18.148438 10.628906 18.148438 10.753906 18.148438 10.914062 Z M 18.148438 10.914062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 18.148438 2.871094 C 18.027344 2.90625 17.90625 2.90625 17.753906 2.902344 C 17.722656 2.902344 17.722656 2.902344 17.722656 2.871094 C 17.722656 2.710938 17.722656 2.585938 17.722656 2.457031 C 17.84375 2.457031 17.96875 2.457031 18.121094 2.457031 C 18.148438 2.585938 18.148438 2.710938 18.148438 2.871094 Z M 18.148438 2.871094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 18.148438 1.90625 C 18.027344 1.9375 17.90625 1.9375 17.753906 1.9375 C 17.722656 1.9375 17.722656 1.9375 17.722656 1.90625 C 17.722656 1.746094 17.722656 1.617188 17.722656 1.488281 C 17.722656 1.488281 17.722656 1.488281 17.753906 1.488281 C 17.90625 1.488281 18.027344 1.488281 18.148438 1.488281 C 18.148438 1.617188 18.148438 1.746094 18.148438 1.90625 Z M 18.148438 1.90625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 0.992188 3.902344 C 1.113281 3.871094 1.234375 3.871094 1.386719 3.871094 C 1.417969 3.871094 1.417969 3.871094 1.417969 3.902344 C 1.417969 4.0625 1.417969 4.191406 1.417969 4.320312 C 1.296875 4.320312 1.175781 4.320312 1.023438 4.320312 C 0.992188 4.191406 0.992188 4.0625 0.992188 3.902344 Z M 0.992188 3.902344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 18.148438 1.457031 C 18.027344 1.488281 17.90625 1.488281 17.753906 1.488281 C 17.722656 1.363281 17.722656 1.234375 17.722656 1.074219 C 17.84375 1.042969 17.96875 1.042969 18.121094 1.042969 C 18.148438 1.171875 18.148438 1.296875 18.148438 1.457031 Z M 18.148438 1.457031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 16.375 1.488281 C 16.375 1.363281 16.375 1.234375 16.375 1.074219 C 16.5 1.042969 16.621094 1.042969 16.773438 1.042969 C 16.800781 1.171875 16.800781 1.296875 16.800781 1.457031 C 16.800781 1.488281 16.800781 1.488281 16.773438 1.488281 C 16.621094 1.488281 16.5 1.488281 16.375 1.488281 Z M 16.375 1.488281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 15.457031 1.488281 C 15.457031 1.363281 15.457031 1.234375 15.453125 1.074219 C 15.578125 1.042969 15.699219 1.042969 15.851562 1.042969 C 15.882812 1.171875 15.878906 1.296875 15.878906 1.457031 C 15.878906 1.488281 15.878906 1.488281 15.851562 1.488281 C 15.699219 1.488281 15.578125 1.488281 15.453125 1.488281 C 15.453125 1.488281 15.457031 1.488281 15.457031 1.488281 Z M 15.457031 1.488281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 14.503906 1.042969 C 14.535156 1.171875 14.535156 1.296875 14.535156 1.457031 C 14.535156 1.488281 14.535156 1.488281 14.503906 1.488281 C 14.351562 1.488281 14.230469 1.488281 14.109375 1.488281 C 14.109375 1.363281 14.109375 1.234375 14.109375 1.074219 C 14.230469 1.042969 14.351562 1.042969 14.503906 1.042969 Z M 14.503906 1.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 13.15625 1.042969 C 13.1875 1.171875 13.1875 1.296875 13.1875 1.457031 C 13.1875 1.488281 13.1875 1.488281 13.15625 1.488281 C 13.003906 1.488281 12.882812 1.488281 12.761719 1.488281 C 12.761719 1.363281 12.761719 1.234375 12.761719 1.074219 C 12.882812 1.042969 13.003906 1.042969 13.15625 1.042969 Z M 13.15625 1.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 5.984375 1.488281 C 5.953125 1.363281 5.953125 1.234375 5.953125 1.074219 C 6.078125 1.042969 6.199219 1.042969 6.351562 1.042969 C 6.378906 1.171875 6.378906 1.296875 6.378906 1.457031 C 6.257812 1.488281 6.136719 1.488281 5.984375 1.488281 Z M 5.984375 1.488281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 5.003906 1.042969 C 5.035156 1.171875 5.035156 1.296875 5.035156 1.457031 C 5.035156 1.488281 5.035156 1.488281 5.003906 1.488281 C 4.851562 1.488281 4.730469 1.488281 4.609375 1.488281 C 4.609375 1.363281 4.609375 1.234375 4.609375 1.074219 C 4.730469 1.042969 4.851562 1.042969 5.003906 1.042969 Z M 5.003906 1.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 3.65625 1.042969 C 3.6875 1.171875 3.6875 1.296875 3.6875 1.457031 C 3.6875 1.488281 3.6875 1.488281 3.65625 1.488281 C 3.503906 1.488281 3.382812 1.488281 3.261719 1.488281 C 3.261719 1.363281 3.261719 1.234375 3.261719 1.074219 C 3.382812 1.042969 3.503906 1.042969 3.65625 1.042969 Z M 3.65625 1.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 2.734375 1.042969 C 2.765625 1.171875 2.765625 1.296875 2.765625 1.457031 C 2.765625 1.488281 2.765625 1.488281 2.734375 1.488281 C 2.582031 1.488281 2.460938 1.488281 2.339844 1.488281 C 2.339844 1.363281 2.339844 1.234375 2.339844 1.074219 C 2.460938 1.042969 2.582031 1.042969 2.734375 1.042969 Z M 2.734375 1.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 1.417969 8.5625 C 1.296875 8.5625 1.175781 8.5625 1.023438 8.5625 C 0.992188 8.4375 0.992188 8.308594 0.992188 8.148438 C 0.992188 8.117188 0.992188 8.117188 1.023438 8.117188 C 1.175781 8.117188 1.296875 8.117188 1.417969 8.148438 C 1.417969 8.308594 1.417969 8.4375 1.417969 8.5625 Z M 1.417969 8.5625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 17.722656 7.671875 C 17.84375 7.671875 17.96875 7.671875 18.117188 7.667969 C 18.148438 7.796875 18.148438 7.925781 18.148438 8.085938 C 18.148438 8.117188 18.148438 8.117188 18.117188 8.117188 C 17.96875 8.117188 17.84375 8.117188 17.722656 8.085938 C 17.722656 7.925781 17.722656 7.796875 17.722656 7.671875 Z M 17.722656 7.671875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 1.417969 8.117188 C 1.296875 8.117188 1.175781 8.117188 1.023438 8.117188 C 0.992188 7.988281 0.992188 7.863281 0.992188 7.703125 C 1.113281 7.667969 1.234375 7.667969 1.386719 7.671875 C 1.417969 7.671875 1.417969 7.667969 1.417969 7.703125 C 1.417969 7.863281 1.417969 7.988281 1.417969 8.117188 Z M 1.417969 8.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 18.148438 7.117188 C 18.027344 7.148438 17.90625 7.148438 17.753906 7.148438 C 17.722656 7.148438 17.722656 7.148438 17.722656 7.117188 C 17.722656 6.957031 17.722656 6.828125 17.722656 6.703125 C 17.84375 6.703125 17.96875 6.703125 18.117188 6.703125 C 18.148438 6.828125 18.148438 6.957031 18.148438 7.117188 Z M 18.148438 7.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 18.148438 9.945312 C 18.027344 9.980469 17.90625 9.980469 17.753906 9.980469 C 17.722656 9.980469 17.722656 9.980469 17.722656 9.945312 C 17.722656 9.789062 17.722656 9.660156 17.753906 9.53125 C 17.90625 9.53125 18.027344 9.53125 18.148438 9.53125 C 18.148438 9.660156 18.148438 9.789062 18.148438 9.945312 Z M 18.148438 9.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 1.417969 9.976562 C 1.296875 9.980469 1.175781 9.980469 1.023438 9.980469 C 0.992188 9.851562 0.992188 9.722656 0.992188 9.5625 C 0.992188 9.53125 0.992188 9.53125 1.023438 9.53125 C 1.175781 9.53125 1.296875 9.53125 1.417969 9.5625 C 1.417969 9.722656 1.417969 9.851562 1.417969 9.980469 C 1.417969 9.980469 1.417969 9.976562 1.417969 9.976562 Z M 1.417969 9.976562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 18.148438 9.5 C 18.027344 9.53125 17.90625 9.53125 17.753906 9.53125 C 17.722656 9.53125 17.722656 9.53125 17.722656 9.5 C 17.722656 9.339844 17.722656 9.210938 17.722656 9.085938 C 17.84375 9.085938 17.96875 9.085938 18.121094 9.085938 C 18.148438 9.210938 18.148438 9.339844 18.148438 9.5 Z M 18.148438 9.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 17.722656 3.902344 C 17.84375 3.871094 17.96875 3.871094 18.117188 3.871094 C 18.148438 4 18.148438 4.128906 18.148438 4.289062 C 18.027344 4.320312 17.90625 4.320312 17.753906 4.320312 C 17.722656 4.320312 17.722656 4.320312 17.722656 4.320312 C 17.722656 4.191406 17.722656 4.0625 17.722656 3.902344 Z M 17.722656 3.902344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 1.417969 9.53125 C 1.296875 9.53125 1.175781 9.53125 1.023438 9.53125 C 0.992188 9.40625 0.992188 9.277344 0.992188 9.117188 C 1.113281 9.085938 1.234375 9.085938 1.386719 9.085938 C 1.417969 9.085938 1.417969 9.085938 1.417969 9.117188 C 1.417969 9.277344 1.417969 9.40625 1.417969 9.53125 Z M 1.417969 9.53125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 17.722656 8.117188 C 17.84375 8.117188 17.96875 8.117188 18.117188 8.117188 C 18.148438 8.246094 18.148438 8.371094 18.148438 8.53125 C 18.027344 8.5625 17.90625 8.5625 17.753906 8.5625 C 17.722656 8.5625 17.722656 8.5625 17.722656 8.53125 C 17.722656 8.371094 17.722656 8.246094 17.722656 8.117188 Z M 17.722656 8.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 18.148438 5.703125 C 18.027344 5.734375 17.90625 5.734375 17.753906 5.703125 C 17.722656 5.542969 17.722656 5.414062 17.722656 5.285156 C 17.722656 5.285156 17.722656 5.289062 17.722656 5.289062 C 17.84375 5.289062 17.96875 5.289062 18.117188 5.285156 C 18.148438 5.414062 18.148438 5.542969 18.148438 5.703125 Z M 18.148438 5.703125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 3.261719 11.914062 C 3.117188 11.914062 2.972656 11.914062 2.796875 11.914062 C 2.765625 11.914062 2.765625 11.914062 2.765625 11.882812 C 2.765625 11.722656 2.765625 11.59375 2.765625 11.449219 C 2.765625 11.429688 2.765625 11.394531 2.796875 11.394531 C 2.972656 11.394531 3.117188 11.394531 3.261719 11.425781 C 3.261719 11.609375 3.261719 11.761719 3.261719 11.914062 Z M 3.261719 11.914062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 3.6875 11.914062 C 3.6875 12.042969 3.6875 12.171875 3.6875 12.332031 C 3.566406 12.363281 3.445312 12.363281 3.292969 12.363281 C 3.261719 12.234375 3.261719 12.105469 3.261719 11.945312 C 3.261719 11.914062 3.261719 11.914062 3.292969 11.914062 C 3.445312 11.914062 3.566406 11.914062 3.6875 11.914062 Z M 3.6875 11.914062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 1.914062 10.945312 C 1.902344 10.945312 1.890625 10.945312 1.859375 10.914062 C 1.84375 10.753906 1.84375 10.628906 1.863281 10.5 C 1.878906 10.5 1.914062 10.5 1.945312 10.5 C 2.097656 10.5 2.21875 10.5 2.339844 10.53125 C 2.339844 10.691406 2.339844 10.820312 2.339844 10.945312 C 2.339844 10.945312 2.339844 10.945312 2.308594 10.945312 C 2.15625 10.945312 2.035156 10.945312 1.914062 10.945312 Z M 1.914062 10.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 1.84375 10.5 C 1.84375 10.628906 1.84375 10.753906 1.84375 10.914062 C 1.722656 10.945312 1.601562 10.945312 1.449219 10.945312 C 1.417969 10.820312 1.417969 10.691406 1.417969 10.53125 C 1.417969 10.5 1.417969 10.5 1.449219 10.5 C 1.601562 10.5 1.722656 10.5 1.84375 10.5 Z M 1.84375 10.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 1.914062 10.980469 C 2.035156 10.945312 2.15625 10.945312 2.308594 10.980469 C 2.339844 11.136719 2.339844 11.265625 2.339844 11.394531 C 2.21875 11.394531 2.097656 11.394531 1.945312 11.394531 C 1.914062 11.265625 1.914062 11.140625 1.914062 10.980469 Z M 1.914062 10.980469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 2.339844 11.414062 C 2.339844 11.265625 2.339844 11.136719 2.339844 10.976562 C 2.339844 10.945312 2.339844 10.945312 2.371094 10.945312 C 2.523438 10.945312 2.644531 10.945312 2.765625 10.976562 C 2.765625 11.136719 2.765625 11.265625 2.765625 11.394531 C 2.765625 11.394531 2.765625 11.429688 2.734375 11.449219 C 2.582031 11.46875 2.460938 11.46875 2.339844 11.46875 C 2.339844 11.46875 2.339844 11.429688 2.339844 11.414062 Z M 2.339844 11.414062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 2.339844 11.5 C 2.460938 11.46875 2.582031 11.46875 2.734375 11.464844 C 2.765625 11.59375 2.765625 11.722656 2.765625 11.882812 C 2.644531 11.914062 2.523438 11.914062 2.371094 11.914062 C 2.339844 11.789062 2.339844 11.660156 2.339844 11.5 Z M 2.339844 11.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 2.765625 3.425781 C 2.765625 3.425781 2.765625 3.390625 2.765625 3.339844 C 2.765625 3.160156 2.765625 3.03125 2.796875 2.902344 C 2.972656 2.902344 3.117188 2.902344 3.261719 2.9375 C 3.261719 3.097656 3.261719 3.222656 3.261719 3.371094 C 3.261719 3.390625 3.261719 3.425781 3.230469 3.425781 C 3.054688 3.425781 2.910156 3.425781 2.765625 3.425781 Z M 2.765625 3.425781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 2.765625 4.839844 C 2.765625 4.839844 2.765625 4.800781 2.796875 4.785156 C 2.972656 4.765625 3.117188 4.765625 3.261719 4.785156 C 3.261719 4.800781 3.261719 4.839844 3.261719 4.871094 C 3.261719 5.03125 3.261719 5.160156 3.230469 5.289062 C 3.054688 5.289062 2.910156 5.289062 2.765625 5.253906 C 2.765625 5.09375 2.765625 4.964844 2.765625 4.839844 Z M 2.765625 4.839844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 3.261719 4.765625 C 3.117188 4.765625 2.972656 4.765625 2.796875 4.765625 C 2.765625 4.636719 2.765625 4.511719 2.765625 4.351562 C 2.765625 4.320312 2.765625 4.320312 2.796875 4.320312 C 2.972656 4.320312 3.117188 4.320312 3.261719 4.351562 C 3.261719 4.511719 3.261719 4.636719 3.261719 4.765625 Z M 3.261719 4.765625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 2.765625 3.457031 C 2.910156 3.425781 3.054688 3.425781 3.230469 3.457031 C 3.261719 3.617188 3.261719 3.746094 3.230469 3.871094 C 3.054688 3.871094 2.910156 3.871094 2.765625 3.871094 C 2.765625 3.746094 2.765625 3.617188 2.765625 3.457031 Z M 2.765625 3.457031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 1.417969 2.90625 C 1.441406 2.90625 1.464844 2.902344 1.488281 2.90625 C 1.632812 2.925781 1.859375 2.824219 1.832031 3.117188 C 1.824219 3.199219 1.71875 3.328125 1.644531 3.339844 C 1.347656 3.386719 1.433594 3.136719 1.417969 2.9375 C 1.417969 2.902344 1.417969 2.902344 1.417969 2.90625 Z M 1.417969 2.90625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 2.765625 2.902344 C 2.765625 3.03125 2.765625 3.160156 2.765625 3.320312 C 2.5 3.375 2.265625 3.363281 2.339844 2.9375 C 2.339844 2.902344 2.339844 2.90625 2.371094 2.90625 C 2.523438 2.90625 2.644531 2.90625 2.765625 2.90625 C 2.765625 2.902344 2.765625 2.902344 2.765625 2.902344 Z M 2.765625 2.902344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 1.914062 2.488281 C 2.035156 2.457031 2.15625 2.457031 2.308594 2.457031 C 2.339844 2.457031 2.339844 2.457031 2.339844 2.488281 C 2.339844 2.648438 2.339844 2.777344 2.339844 2.90625 C 2.339844 2.90625 2.339844 2.902344 2.339844 2.902344 C 2.074219 2.929688 1.839844 2.914062 1.914062 2.488281 Z M 1.914062 2.488281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 2.765625 4.320312 C 2.644531 4.320312 2.523438 4.320312 2.371094 4.320312 C 2.339844 4.320312 2.339844 4.320312 2.339844 4.320312 C 2.339844 4.191406 2.339844 4.0625 2.339844 3.902344 C 2.339844 3.871094 2.339844 3.871094 2.339844 3.871094 C 2.460938 3.871094 2.582031 3.871094 2.734375 3.871094 C 2.765625 3.871094 2.765625 3.871094 2.765625 3.902344 C 2.765625 4.0625 2.765625 4.191406 2.765625 4.320312 Z M 2.765625 4.320312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 1.449219 4.320312 C 1.417969 4.191406 1.417969 4.0625 1.417969 3.902344 C 1.554688 3.90625 1.75 3.890625 1.816406 3.984375 C 1.953125 4.164062 1.804688 4.308594 1.449219 4.320312 Z M 1.449219 4.320312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 2.339844 3.871094 C 2.316406 3.871094 2.292969 3.875 2.269531 3.871094 C 2.125 3.851562 1.898438 3.953125 1.921875 3.660156 C 1.929688 3.578125 2.039062 3.449219 2.113281 3.4375 C 2.410156 3.390625 2.324219 3.640625 2.339844 3.839844 C 2.339844 3.871094 2.339844 3.871094 2.339844 3.871094 Z M 2.339844 3.871094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 1.914062 5.734375 C 1.886719 5.449219 1.90625 5.210938 2.308594 5.289062 C 2.339844 5.289062 2.339844 5.285156 2.339844 5.320312 C 2.339844 5.480469 2.339844 5.605469 2.308594 5.734375 C 2.15625 5.734375 2.035156 5.734375 1.914062 5.734375 Z M 1.914062 5.734375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 2.734375 4.839844 C 2.765625 4.964844 2.765625 5.09375 2.765625 5.253906 C 2.765625 5.289062 2.765625 5.285156 2.734375 5.285156 C 2.582031 5.285156 2.460938 5.285156 2.339844 5.285156 C 2.339844 5.285156 2.339844 5.289062 2.339844 5.289062 C 2.316406 5.007812 2.328125 4.761719 2.734375 4.839844 Z M 2.734375 4.839844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 1.417969 5.289062 C 1.417969 5.261719 1.414062 5.238281 1.417969 5.214844 C 1.4375 5.0625 1.34375 4.824219 1.621094 4.851562 C 1.699219 4.859375 1.820312 4.96875 1.832031 5.046875 C 1.875 5.359375 1.636719 5.269531 1.449219 5.285156 C 1.417969 5.285156 1.417969 5.289062 1.417969 5.289062 Z M 1.417969 5.289062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 2.339844 4.320312 C 2.339844 4.34375 2.34375 4.367188 2.339844 4.394531 C 2.316406 4.542969 2.414062 4.785156 2.136719 4.757812 C 2.058594 4.746094 1.933594 4.636719 1.925781 4.558594 C 1.878906 4.246094 2.121094 4.335938 2.308594 4.320312 C 2.339844 4.320312 2.339844 4.320312 2.339844 4.320312 Z M 2.339844 4.320312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 2.339844 1.9375 C 2.21875 1.9375 2.09375 1.9375 1.941406 1.9375 C 1.894531 1.660156 1.902344 1.410156 2.308594 1.488281 C 2.339844 1.488281 2.339844 1.488281 2.339844 1.519531 C 2.339844 1.679688 2.339844 1.808594 2.339844 1.9375 Z M 2.339844 1.9375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 2.339844 2.457031 C 2.339844 2.304688 2.339844 2.152344 2.339844 1.96875 C 2.339844 1.9375 2.339844 1.9375 2.371094 1.9375 C 2.523438 1.9375 2.644531 1.9375 2.765625 1.9375 C 2.765625 1.9375 2.765625 1.9375 2.765625 1.96875 C 2.765625 2.152344 2.765625 2.304688 2.765625 2.457031 C 2.765625 2.457031 2.765625 2.457031 2.734375 2.457031 C 2.582031 2.457031 2.460938 2.457031 2.339844 2.457031 Z M 2.339844 2.457031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0.784314%,31.764707%,70.588237%)",
      fillOpacity: 1
    },
    d: "M 15.023438 9.148438 C 15.023438 9.148438 14.992188 9.15625 14.953125 9.132812 C 14.84375 9.101562 14.773438 9.085938 14.703125 9.085938 C 11.296875 9.085938 7.890625 9.085938 4.484375 9.085938 C 4.382812 9.085938 4.28125 9.128906 4.179688 9.148438 C 4.179688 9.148438 4.183594 9.164062 4.167969 9.164062 C 4.132812 9.132812 4.113281 9.109375 4.097656 9.058594 C 4.046875 8.875 4 8.71875 3.949219 8.535156 C 3.910156 8.328125 3.867188 8.152344 3.828125 7.9375 C 3.8125 7.5 3.789062 7.097656 3.78125 6.667969 C 3.796875 6.539062 3.800781 6.441406 3.816406 6.324219 C 3.800781 6.21875 3.773438 6.132812 3.753906 6.015625 C 3.808594 5.910156 3.859375 5.832031 3.910156 5.761719 C 3.910156 5.765625 3.902344 5.761719 3.914062 5.734375 C 3.9375 5.664062 3.945312 5.625 3.960938 5.566406 C 3.964844 5.535156 3.964844 5.519531 3.96875 5.503906 C 3.972656 5.5 3.964844 5.492188 3.972656 5.488281 C 3.980469 5.484375 3.96875 5.476562 3.984375 5.445312 C 4.011719 5.375 4.019531 5.328125 4.039062 5.265625 C 4.074219 5.160156 4.09375 5.082031 4.117188 5 C 4.117188 5 4.152344 4.992188 4.191406 5.015625 C 4.300781 5.046875 4.371094 5.0625 4.4375 5.0625 C 7.84375 5.0625 11.25 5.0625 14.65625 5.0625 C 14.757812 5.0625 14.855469 5.019531 14.957031 5 C 14.96875 4.996094 14.980469 4.996094 15.011719 5.019531 C 15.054688 5.128906 15.082031 5.207031 15.105469 5.308594 C 15.121094 5.351562 15.140625 5.371094 15.179688 5.402344 C 15.234375 5.46875 15.273438 5.523438 15.292969 5.582031 C 15.265625 5.613281 15.257812 5.636719 15.242188 5.683594 C 15.253906 5.820312 15.273438 5.929688 15.292969 6.070312 C 15.320312 6.304688 15.347656 6.503906 15.367188 6.738281 C 15.371094 6.894531 15.375 7.023438 15.371094 7.175781 C 15.351562 7.382812 15.34375 7.5625 15.328125 7.777344 C 15.226562 8.234375 15.136719 8.660156 15.035156 9.101562 C 15.027344 9.117188 15.023438 9.148438 15.023438 9.148438 Z M 15.023438 9.148438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,26.274511%,66.274512%)",
      fillOpacity: 1
    },
    d: "M 14.925781 4.992188 C 14.855469 5.019531 14.757812 5.0625 14.65625 5.0625 C 11.25 5.0625 7.84375 5.0625 4.4375 5.0625 C 4.371094 5.0625 4.300781 5.046875 4.207031 5.019531 C 4.253906 4.992188 4.324219 4.980469 4.394531 4.980469 C 7.894531 4.980469 11.394531 4.980469 14.925781 4.992188 Z M 14.925781 4.992188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 3.261719 3.871094 C 3.261719 3.746094 3.261719 3.617188 3.261719 3.457031 C 3.261719 3.425781 3.261719 3.390625 3.292969 3.371094 C 3.699219 3.429688 3.710938 3.183594 3.714844 2.902344 C 3.867188 2.902344 3.992188 2.902344 4.113281 2.933594 C 4.058594 3.410156 4.347656 3.355469 4.609375 3.351562 C 4.609375 3.871094 4.609375 3.871094 4.144531 3.871094 C 4.113281 3.871094 4.113281 3.871094 4.113281 3.839844 C 4.101562 3.464844 3.964844 3.308594 3.792969 3.453125 C 3.707031 3.523438 3.71875 3.726562 3.6875 3.871094 C 3.6875 3.871094 3.6875 3.871094 3.65625 3.871094 C 3.503906 3.871094 3.382812 3.871094 3.261719 3.871094 Z M 3.261719 3.871094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.431373%,90.588236%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 5.214844 3.074219 C 5.308594 3.078125 5.390625 3.125 5.472656 3.125 C 8.230469 3.128906 10.984375 3.128906 13.738281 3.125 C 13.792969 3.125 13.851562 3.109375 13.933594 3.074219 C 13.980469 3.066406 14.003906 3.082031 14.027344 3.117188 C 13.894531 3.15625 13.753906 3.199219 13.617188 3.199219 C 10.921875 3.203125 8.226562 3.203125 5.527344 3.199219 C 5.417969 3.199219 5.308594 3.132812 5.214844 3.074219 Z M 5.214844 3.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 15.105469 5.285156 C 15.082031 5.207031 15.054688 5.128906 15.027344 5.023438 C 15.027344 4.964844 15.027344 4.929688 15.058594 4.867188 C 15.203125 4.847656 15.316406 4.855469 15.425781 4.863281 C 15.449219 5.015625 15.46875 5.132812 15.492188 5.289062 C 15.628906 5.289062 15.753906 5.289062 15.878906 5.289062 C 15.878906 5.289062 15.878906 5.285156 15.878906 5.320312 C 15.878906 5.480469 15.878906 5.605469 15.851562 5.734375 C 15.449219 5.65625 15.429688 5.898438 15.4375 6.167969 C 15.378906 6.117188 15.335938 6.078125 15.292969 6.039062 C 15.273438 5.929688 15.253906 5.820312 15.253906 5.675781 C 15.296875 5.621094 15.304688 5.601562 15.3125 5.578125 C 15.273438 5.523438 15.234375 5.46875 15.175781 5.382812 C 15.140625 5.328125 15.125 5.308594 15.105469 5.285156 Z M 15.105469 5.285156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 15.882812 5.289062 C 15.753906 5.289062 15.628906 5.289062 15.492188 5.289062 C 15.46875 5.132812 15.449219 5.015625 15.425781 4.863281 C 15.316406 4.855469 15.203125 4.847656 15.058594 4.839844 C 15.03125 4.6875 15.03125 4.535156 15.03125 4.351562 C 15.03125 4.320312 15.03125 4.320312 15.058594 4.320312 C 15.210938 4.320312 15.332031 4.320312 15.457031 4.351562 C 15.378906 4.777344 15.617188 4.789062 15.878906 4.785156 C 15.878906 4.804688 15.878906 4.839844 15.878906 4.871094 C 15.882812 5.03125 15.882812 5.160156 15.882812 5.289062 Z M 15.882812 5.289062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,98.823529%,98.823529%)",
      fillOpacity: 1
    },
    d: "M 4.113281 4.972656 C 4.09375 5.082031 4.074219 5.160156 4.011719 5.265625 C 3.875 5.285156 3.78125 5.289062 3.6875 5.253906 C 3.6875 5.09375 3.6875 4.96875 3.6875 4.820312 C 3.6875 4.804688 3.6875 4.765625 3.714844 4.765625 C 3.867188 4.765625 3.992188 4.765625 4.113281 4.765625 C 4.113281 4.824219 4.113281 4.882812 4.113281 4.972656 Z M 4.113281 4.972656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 14.605469 3.871094 C 14.59375 3.757812 14.582031 3.648438 14.554688 3.492188 C 14.535156 3.417969 14.535156 3.382812 14.535156 3.351562 C 14.535156 3.351562 14.535156 3.351562 14.5625 3.351562 C 14.933594 3.34375 15.085938 3.511719 15 3.871094 C 14.847656 3.871094 14.726562 3.871094 14.605469 3.871094 Z M 14.605469 3.871094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 14.585938 3.886719 C 14.726562 3.871094 14.847656 3.871094 15 3.871094 C 15.03125 3.871094 15.03125 3.871094 15.03125 3.902344 C 15.03125 4.0625 15.03125 4.191406 15.03125 4.320312 C 14.726562 4.363281 14.578125 4.21875 14.585938 3.886719 Z M 14.585938 3.886719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 4.113281 3.871094 C 4.113281 4 4.113281 4.128906 4.113281 4.289062 C 4.113281 4.320312 4.113281 4.320312 4.082031 4.320312 C 3.929688 4.320312 3.808594 4.320312 3.6875 4.320312 C 3.6875 4.320312 3.6875 4.320312 3.6875 4.289062 C 3.6875 4.128906 3.6875 4 3.6875 3.871094 C 3.6875 3.871094 3.6875 3.871094 3.71875 3.871094 C 3.867188 3.871094 3.992188 3.871094 4.113281 3.871094 Z M 4.113281 3.871094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 5.035156 2.902344 C 5.058594 3.1875 5.042969 3.429688 4.636719 3.351562 C 4.609375 3.351562 4.609375 3.351562 4.609375 3.320312 C 4.609375 3.160156 4.609375 3.03125 4.636719 2.902344 C 4.789062 2.902344 4.914062 2.90625 5.035156 2.90625 C 5.035156 2.90625 5.035156 2.902344 5.035156 2.902344 Z M 5.035156 2.902344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.470588%,96.470588%,96.470588%)",
      fillOpacity: 1
    },
    d: "M 4.113281 4.320312 C 4.195312 4.328125 4.28125 4.339844 4.433594 4.355469 C 4.320312 4.523438 4.242188 4.640625 4.136719 4.761719 C 4.113281 4.765625 4.113281 4.765625 4.113281 4.734375 C 4.113281 4.574219 4.113281 4.445312 4.113281 4.320312 Z M 4.113281 4.320312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.078432%,96.078432%,96.470588%)",
      fillOpacity: 1
    },
    d: "M 14.503906 3.351562 C 14.535156 3.382812 14.535156 3.417969 14.535156 3.476562 C 14.417969 3.46875 14.304688 3.4375 14.183594 3.378906 C 14.277344 3.351562 14.375 3.351562 14.503906 3.351562 Z M 14.503906 3.351562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 15.03125 3.871094 C 15.085938 3.511719 14.933594 3.34375 14.5625 3.351562 C 14.535156 3.222656 14.535156 3.09375 14.535156 2.9375 C 14.535156 2.902344 14.535156 2.90625 14.5625 2.90625 C 14.929688 2.960938 15.054688 2.789062 15.058594 2.457031 C 15.210938 2.457031 15.332031 2.457031 15.457031 2.488281 C 15.457031 2.648438 15.457031 2.777344 15.425781 2.90625 C 15.234375 2.921875 14.996094 2.832031 15.039062 3.144531 C 15.050781 3.222656 15.171875 3.332031 15.253906 3.339844 C 15.53125 3.367188 15.433594 3.128906 15.453125 2.976562 C 15.457031 2.953125 15.453125 2.929688 15.484375 2.902344 C 15.636719 2.902344 15.757812 2.902344 15.882812 2.9375 C 15.878906 3.09375 15.878906 3.222656 15.878906 3.371094 C 15.878906 3.386719 15.882812 3.421875 15.851562 3.425781 C 15.445312 3.347656 15.433594 3.59375 15.425781 3.871094 C 15.273438 3.871094 15.152344 3.871094 15.03125 3.871094 Z M 15.03125 3.871094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 13.46875 1.953125 C 13.5 1.9375 13.53125 1.9375 13.617188 1.9375 C 13.820312 1.9375 13.964844 1.9375 14.109375 1.9375 C 14.109375 1.9375 14.109375 1.9375 14.109375 1.96875 C 14.109375 2.152344 14.109375 2.304688 14.109375 2.457031 C 13.941406 2.382812 13.632812 2.636719 13.609375 2.167969 C 13.5625 2.078125 13.515625 2.042969 13.46875 2.007812 C 13.46875 2.007812 13.46875 1.972656 13.46875 1.953125 Z M 13.46875 1.953125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 14.535156 2.902344 C 14.265625 2.929688 14.035156 2.914062 14.109375 2.488281 C 14.109375 2.457031 14.109375 2.457031 14.136719 2.457031 C 14.289062 2.457031 14.414062 2.457031 14.535156 2.488281 C 14.535156 2.648438 14.535156 2.777344 14.535156 2.90625 C 14.535156 2.90625 14.535156 2.902344 14.535156 2.902344 Z M 14.535156 2.902344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 13.472656 2.03125 C 13.515625 2.042969 13.5625 2.078125 13.609375 2.136719 C 13.566406 2.125 13.519531 2.089844 13.472656 2.03125 Z M 13.472656 2.03125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 12.761719 1.519531 C 12.882812 1.488281 13.003906 1.488281 13.15625 1.488281 C 13.1875 1.617188 13.1875 1.746094 13.1875 1.90625 C 13.066406 1.9375 12.945312 1.9375 12.792969 1.933594 C 12.761719 1.808594 12.761719 1.679688 12.761719 1.519531 Z M 12.761719 1.519531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 5.03125 1.9375 C 5.15625 1.9375 5.277344 1.9375 5.429688 1.9375 C 5.460938 2.089844 5.460938 2.242188 5.460938 2.425781 C 5.335938 2.457031 5.214844 2.457031 5.0625 2.457031 C 5.035156 2.457031 5.035156 2.457031 5.035156 2.425781 C 5.035156 2.242188 5.035156 2.089844 5.035156 1.9375 C 5.035156 1.9375 5.03125 1.9375 5.03125 1.9375 Z M 5.03125 1.9375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 5.558594 1.9375 C 5.507812 1.660156 5.519531 1.410156 5.925781 1.488281 C 5.957031 1.617188 5.957031 1.746094 5.957031 1.90625 C 5.832031 1.9375 5.710938 1.9375 5.558594 1.9375 Z M 5.558594 1.9375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 5.035156 2.871094 C 4.914062 2.90625 4.789062 2.902344 4.636719 2.902344 C 4.609375 2.902344 4.609375 2.90625 4.609375 2.871094 C 4.609375 2.710938 4.609375 2.585938 4.636719 2.457031 C 4.789062 2.457031 4.914062 2.457031 5.035156 2.457031 C 5.035156 2.585938 5.035156 2.710938 5.035156 2.871094 Z M 5.035156 2.871094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,26.274511%,66.274512%)",
      fillOpacity: 1
    },
    d: "M 4.214844 9.15625 C 4.28125 9.128906 4.382812 9.085938 4.484375 9.085938 C 7.890625 9.085938 11.296875 9.085938 14.703125 9.085938 C 14.773438 9.085938 14.84375 9.101562 14.933594 9.128906 C 14.886719 9.15625 14.816406 9.167969 14.746094 9.167969 C 11.246094 9.167969 7.746094 9.167969 4.214844 9.15625 Z M 4.214844 9.15625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 15.878906 11.914062 C 15.757812 11.914062 15.636719 11.914062 15.484375 11.914062 C 15.457031 11.914062 15.457031 11.914062 15.457031 11.882812 C 15.53125 11.457031 15.292969 11.445312 15.023438 11.449219 C 15 11.414062 14.984375 11.402344 14.960938 11.363281 C 15.035156 10.933594 14.796875 10.925781 14.535156 10.945312 C 14.507812 10.664062 14.527344 10.421875 14.945312 10.5 C 14.992188 10.5 15.027344 10.5 15.027344 10.53125 C 14.953125 10.957031 15.191406 10.96875 15.457031 10.976562 C 15.378906 11.40625 15.617188 11.417969 15.878906 11.414062 C 15.878906 11.433594 15.878906 11.46875 15.878906 11.5 C 15.878906 11.660156 15.878906 11.789062 15.878906 11.914062 Z M 15.878906 11.914062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 15.027344 10.5 C 15.027344 10.5 14.992188 10.5 14.976562 10.5 C 14.960938 10.371094 14.960938 10.246094 14.976562 10.078125 C 15.011719 10.023438 15.023438 10.003906 15.058594 9.980469 C 15.210938 9.980469 15.332031 9.980469 15.457031 10.011719 C 15.457031 10.195312 15.457031 10.347656 15.425781 10.5 C 15.273438 10.5 15.148438 10.5 15.027344 10.5 Z M 15.027344 10.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 4.113281 9.980469 C 4.449219 9.929688 4.652344 10.039062 4.609375 10.46875 C 4.609375 10.5 4.609375 10.5 4.578125 10.5 C 4.402344 10.5 4.257812 10.5 4.113281 10.46875 C 4.113281 10.28125 4.113281 10.128906 4.113281 9.980469 Z M 4.113281 9.980469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.470588%,96.470588%,96.470588%)",
      fillOpacity: 1
    },
    d: "M 4.09375 9.085938 C 4.113281 9.109375 4.132812 9.132812 4.167969 9.171875 C 4.199219 9.289062 4.207031 9.398438 4.167969 9.519531 C 3.976562 9.53125 3.832031 9.53125 3.6875 9.5 C 3.6875 9.339844 3.6875 9.210938 3.714844 9.085938 C 3.863281 9.085938 3.976562 9.085938 4.09375 9.085938 Z M 4.09375 9.085938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 14.109375 11.46875 C 14.109375 11.46875 14.109375 11.429688 14.109375 11.414062 C 14.082031 11.113281 14.097656 10.871094 14.503906 10.945312 C 14.535156 10.945312 14.535156 10.945312 14.535156 10.980469 C 14.535156 11.136719 14.535156 11.265625 14.535156 11.414062 C 14.535156 11.429688 14.535156 11.46875 14.503906 11.46875 C 14.351562 11.46875 14.230469 11.46875 14.109375 11.46875 Z M 14.109375 11.46875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 5.15625 11.15625 C 5.179688 11.175781 5.191406 11.183594 5.203125 11.210938 C 5.160156 11.277344 5.117188 11.320312 5.023438 11.378906 C 4.851562 11.394531 4.730469 11.394531 4.609375 11.363281 C 4.609375 11.203125 4.609375 11.074219 4.609375 10.945312 C 4.609375 10.945312 4.609375 10.945312 4.636719 10.945312 C 4.789062 10.945312 4.910156 10.945312 5.035156 10.945312 C 5.046875 10.964844 5.0625 10.988281 5.089844 11.015625 C 5.117188 11.0625 5.128906 11.105469 5.15625 11.15625 Z M 5.15625 11.15625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 3.6875 9.53125 C 3.832031 9.53125 3.976562 9.53125 4.152344 9.53125 C 4.160156 9.660156 4.140625 9.792969 4.113281 9.949219 C 4.113281 9.980469 4.113281 9.980469 4.082031 9.980469 C 3.929688 9.980469 3.808594 9.980469 3.6875 9.945312 C 3.6875 9.789062 3.6875 9.660156 3.6875 9.53125 Z M 3.6875 9.53125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 15.027344 9.179688 C 15.023438 9.148438 15.027344 9.117188 15.066406 9.101562 C 15.21875 9.085938 15.335938 9.085938 15.457031 9.117188 C 15.457031 9.277344 15.457031 9.40625 15.425781 9.53125 C 15.273438 9.53125 15.152344 9.53125 15.03125 9.53125 C 15.03125 9.425781 15.027344 9.320312 15.027344 9.179688 Z M 15.027344 9.179688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 5.03125 10.921875 C 4.910156 10.945312 4.789062 10.945312 4.636719 10.914062 C 4.609375 10.753906 4.609375 10.628906 4.609375 10.5 C 4.75 10.632812 4.886719 10.761719 5.03125 10.921875 Z M 5.03125 10.921875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.078432%,96.078432%,96.470588%)",
      fillOpacity: 1
    },
    d: "M 15.03125 9.980469 C 15.023438 10.003906 15.011719 10.023438 14.976562 10.046875 C 14.6875 9.964844 14.691406 9.882812 15.003906 9.535156 C 15.03125 9.53125 15.03125 9.53125 15.03125 9.5625 C 15.03125 9.722656 15.03125 9.851562 15.03125 9.980469 Z M 15.03125 9.980469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 13.613281 12.332031 C 13.492188 12.363281 13.367188 12.363281 13.214844 12.363281 C 13.164062 12.082031 13.175781 11.835938 13.582031 11.914062 C 13.613281 12.042969 13.613281 12.171875 13.613281 12.332031 Z M 13.613281 12.332031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 14.109375 11.5 C 14.230469 11.46875 14.351562 11.46875 14.503906 11.5 C 14.535156 11.660156 14.535156 11.789062 14.535156 11.914062 C 14.535156 11.914062 14.535156 11.914062 14.503906 11.914062 C 14.351562 11.914062 14.230469 11.914062 14.109375 11.914062 C 14.109375 11.789062 14.109375 11.660156 14.109375 11.5 Z M 14.109375 11.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 4.609375 11.394531 C 4.730469 11.394531 4.851562 11.394531 5.003906 11.394531 C 5.03125 11.394531 5.035156 11.429688 5.035156 11.480469 C 5.035156 11.660156 5.035156 11.789062 5.035156 11.914062 C 5.035156 11.914062 5.035156 11.914062 5.003906 11.914062 C 4.851562 11.914062 4.730469 11.914062 4.609375 11.914062 C 4.609375 11.914062 4.609375 11.914062 4.609375 11.882812 C 4.609375 11.699219 4.609375 11.546875 4.609375 11.394531 Z M 4.609375 11.394531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 5.511719 11.914062 C 5.53125 12.042969 5.53125 12.171875 5.53125 12.328125 C 5.386719 12.363281 5.242188 12.363281 5.0625 12.363281 C 5.035156 12.363281 5.035156 12.363281 5.035156 12.328125 C 5.035156 12.171875 5.035156 12.042969 5.035156 11.914062 C 5.035156 11.914062 5.035156 11.914062 5.0625 11.914062 C 5.214844 11.914062 5.335938 11.914062 5.457031 11.914062 C 5.46875 11.914062 5.484375 11.914062 5.511719 11.914062 Z M 5.511719 11.914062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 5.457031 11.882812 C 5.335938 11.914062 5.214844 11.914062 5.0625 11.914062 C 5.035156 11.789062 5.035156 11.660156 5.035156 11.5 C 5.300781 11.441406 5.53125 11.460938 5.457031 11.882812 Z M 5.457031 11.882812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 1.914062 5.761719 C 2.035156 5.734375 2.15625 5.734375 2.308594 5.734375 C 2.339844 5.734375 2.339844 5.734375 2.339844 5.765625 C 2.339844 5.925781 2.339844 6.054688 2.339844 6.199219 C 2.339844 6.21875 2.339844 6.253906 2.308594 6.253906 C 2.15625 6.253906 2.035156 6.253906 1.914062 6.253906 C 1.90625 6.230469 1.894531 6.210938 1.859375 6.1875 C 1.867188 6.050781 1.890625 5.921875 1.914062 5.761719 Z M 1.914062 5.761719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 1.84375 6.703125 C 1.855469 6.703125 1.867188 6.703125 1.925781 6.703125 C 2.097656 6.703125 2.21875 6.703125 2.339844 6.703125 C 2.339844 6.703125 2.339844 6.703125 2.339844 6.734375 C 2.339844 6.894531 2.339844 7.019531 2.308594 7.148438 C 2.15625 7.148438 2.035156 7.148438 1.894531 7.148438 C 1.878906 7.148438 1.84375 7.148438 1.84375 7.117188 C 1.84375 6.957031 1.84375 6.828125 1.84375 6.703125 Z M 1.84375 6.703125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 1.8125 6.703125 C 1.84375 6.828125 1.84375 6.957031 1.8125 7.117188 C 1.660156 7.148438 1.539062 7.148438 1.417969 7.148438 C 1.417969 7.023438 1.417969 6.894531 1.417969 6.734375 C 1.539062 6.703125 1.660156 6.703125 1.8125 6.703125 Z M 1.8125 6.703125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 2.339844 6.703125 C 2.21875 6.703125 2.097656 6.703125 1.945312 6.703125 C 1.914062 6.574219 1.914062 6.445312 1.914062 6.285156 C 2.035156 6.253906 2.15625 6.253906 2.308594 6.285156 C 2.339844 6.445312 2.339844 6.574219 2.339844 6.703125 Z M 2.339844 6.703125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 15.910156 12.363281 C 15.878906 12.234375 15.878906 12.105469 15.878906 11.945312 C 15.878906 11.914062 15.878906 11.914062 15.910156 11.914062 C 16.085938 11.914062 16.230469 11.914062 16.378906 11.914062 C 16.375 11.914062 16.375 11.914062 16.375 11.914062 C 16.375 12.042969 16.375 12.171875 16.378906 12.328125 C 16.230469 12.363281 16.085938 12.363281 15.910156 12.363281 Z M 15.910156 12.363281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 17.722656 10.5 C 17.722656 10.628906 17.722656 10.753906 17.722656 10.914062 C 17.722656 10.945312 17.722656 10.945312 17.695312 10.945312 C 17.289062 10.867188 17.277344 11.117188 17.28125 11.402344 C 17.246094 11.425781 17.234375 11.441406 17.226562 11.464844 C 16.964844 11.445312 16.726562 11.457031 16.800781 11.882812 C 16.679688 11.914062 16.558594 11.914062 16.40625 11.914062 C 16.375 11.914062 16.375 11.914062 16.375 11.882812 C 16.375 11.722656 16.375 11.59375 16.375 11.449219 C 16.375 11.429688 16.375 11.394531 16.40625 11.394531 C 16.8125 11.472656 16.824219 11.226562 16.832031 10.945312 C 17.238281 11.027344 17.25 10.777344 17.246094 10.5 C 17.265625 10.5 17.296875 10.5 17.328125 10.5 C 17.480469 10.5 17.601562 10.5 17.722656 10.5 Z M 17.722656 10.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 17.238281 11.492188 C 17.234375 11.441406 17.246094 11.425781 17.3125 11.402344 C 17.480469 11.394531 17.601562 11.394531 17.722656 11.394531 C 17.722656 11.394531 17.722656 11.429688 17.722656 11.449219 C 17.722656 11.59375 17.722656 11.722656 17.722656 11.882812 C 17.601562 11.914062 17.480469 11.914062 17.328125 11.914062 C 17.28125 11.78125 17.265625 11.652344 17.238281 11.492188 Z M 17.238281 11.492188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 5.003906 11.914062 C 5.035156 12.042969 5.035156 12.171875 5.035156 12.328125 C 4.914062 12.363281 4.789062 12.363281 4.636719 12.363281 C 4.609375 12.359375 4.609375 12.363281 4.609375 12.328125 C 4.609375 12.171875 4.609375 12.042969 4.609375 11.914062 C 4.730469 11.914062 4.851562 11.914062 5.003906 11.914062 Z M 5.003906 11.914062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 14.109375 11.945312 C 14.230469 11.914062 14.351562 11.914062 14.503906 11.914062 C 14.535156 12.042969 14.535156 12.171875 14.535156 12.332031 C 14.414062 12.363281 14.289062 12.363281 14.136719 12.363281 C 14.109375 12.234375 14.109375 12.105469 14.109375 11.945312 Z M 14.109375 11.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 4.609375 11.914062 C 4.609375 12.042969 4.609375 12.171875 4.609375 12.328125 C 4.464844 12.363281 4.320312 12.363281 4.144531 12.363281 C 4.113281 12.234375 4.113281 12.105469 4.113281 11.945312 C 4.113281 11.914062 4.113281 11.914062 4.144531 11.914062 C 4.320312 11.914062 4.464844 11.914062 4.609375 11.914062 Z M 4.609375 11.914062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 4.113281 11.914062 C 3.992188 11.914062 3.867188 11.914062 3.714844 11.914062 C 3.6875 11.914062 3.6875 11.914062 3.6875 11.882812 C 3.6875 11.722656 3.6875 11.59375 3.6875 11.449219 C 3.6875 11.429688 3.6875 11.394531 3.714844 11.394531 C 3.867188 11.394531 3.992188 11.394531 4.113281 11.414062 C 4.113281 11.433594 4.113281 11.46875 4.113281 11.5 C 4.113281 11.660156 4.113281 11.789062 4.113281 11.914062 Z M 4.113281 11.914062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 14.5625 11.914062 C 14.535156 11.789062 14.535156 11.660156 14.535156 11.5 C 14.535156 11.46875 14.535156 11.429688 14.5625 11.414062 C 14.714844 11.394531 14.839844 11.394531 14.960938 11.394531 C 14.984375 11.402344 15 11.414062 15.023438 11.480469 C 15.03125 11.660156 15.03125 11.785156 15.03125 11.914062 C 14.886719 11.914062 14.742188 11.914062 14.5625 11.914062 Z M 14.5625 11.914062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 15.457031 12.332031 C 15.332031 12.363281 15.210938 12.363281 15.058594 12.363281 C 15.03125 12.234375 15.03125 12.105469 15.03125 11.945312 C 15.03125 11.914062 15.03125 11.914062 15.058594 11.914062 C 15.210938 11.914062 15.332031 11.914062 15.457031 11.914062 C 15.457031 11.914062 15.457031 11.914062 15.453125 11.914062 C 15.453125 12.042969 15.457031 12.171875 15.457031 12.332031 Z M 15.457031 12.332031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 15.878906 4.839844 C 15.878906 4.839844 15.878906 4.804688 15.878906 4.753906 C 15.878906 4.574219 15.878906 4.449219 15.910156 4.320312 C 16.085938 4.320312 16.230469 4.320312 16.378906 4.351562 C 16.375 4.511719 16.375 4.640625 16.375 4.769531 C 16.375 4.769531 16.375 4.804688 16.347656 4.820312 C 16.171875 4.839844 16.023438 4.839844 15.878906 4.839844 Z M 15.878906 4.839844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 15.878906 4.871094 C 16.023438 4.839844 16.171875 4.839844 16.347656 4.839844 C 16.375 4.96875 16.375 5.097656 16.375 5.253906 C 16.375 5.289062 16.378906 5.285156 16.347656 5.285156 C 16.171875 5.285156 16.023438 5.285156 15.878906 5.285156 C 15.878906 5.285156 15.878906 5.289062 15.878906 5.289062 C 15.882812 5.160156 15.882812 5.03125 15.878906 4.871094 Z M 15.878906 4.871094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 16.800781 5.734375 C 16.945312 5.734375 17.09375 5.734375 17.269531 5.734375 C 17.296875 5.734375 17.296875 5.734375 17.296875 5.761719 C 17.273438 5.921875 17.25 6.054688 17.199219 6.183594 C 16.792969 6.261719 16.78125 6.011719 16.800781 5.734375 Z M 16.800781 5.734375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 17.257812 3.871094 C 17.230469 3.8125 17.207031 3.726562 17.238281 3.695312 C 17.328125 3.59375 17.429688 3.449219 17.539062 3.4375 C 17.808594 3.414062 17.695312 3.664062 17.722656 3.839844 C 17.578125 3.871094 17.433594 3.871094 17.257812 3.871094 Z M 17.257812 3.871094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 16.800781 3.871094 C 16.921875 3.871094 17.046875 3.871094 17.199219 3.871094 C 17.253906 4.15625 17.234375 4.394531 16.832031 4.320312 C 16.800781 4.320312 16.800781 4.320312 16.800781 4.289062 C 16.800781 4.128906 16.800781 4 16.800781 3.871094 Z M 16.800781 3.871094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 16.800781 5.289062 C 16.800781 5.261719 16.800781 5.238281 16.804688 5.214844 C 16.824219 5.0625 16.726562 4.824219 17.003906 4.851562 C 17.082031 4.859375 17.207031 4.96875 17.21875 5.046875 C 17.261719 5.359375 17.023438 5.269531 16.832031 5.289062 C 16.800781 5.289062 16.800781 5.289062 16.800781 5.289062 Z M 16.800781 5.289062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 17.695312 5.285156 C 17.722656 5.414062 17.722656 5.542969 17.722656 5.703125 C 17.722656 5.734375 17.722656 5.734375 17.695312 5.734375 C 17.542969 5.734375 17.417969 5.734375 17.296875 5.734375 C 17.269531 5.449219 17.292969 5.210938 17.695312 5.285156 Z M 17.695312 5.285156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 16.375 5.289062 C 16.5 5.289062 16.621094 5.289062 16.773438 5.289062 C 16.800781 5.289062 16.800781 5.289062 16.800781 5.285156 C 16.800781 5.414062 16.800781 5.542969 16.800781 5.703125 C 16.800781 5.734375 16.800781 5.734375 16.773438 5.734375 C 16.621094 5.734375 16.5 5.734375 16.375 5.703125 C 16.375 5.542969 16.378906 5.414062 16.378906 5.285156 C 16.378906 5.285156 16.375 5.289062 16.375 5.289062 Z M 16.375 5.289062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 17.722656 4.320312 C 17.722656 4.34375 17.726562 4.367188 17.722656 4.394531 C 17.703125 4.542969 17.800781 4.785156 17.519531 4.753906 C 17.441406 4.746094 17.320312 4.636719 17.308594 4.558594 C 17.265625 4.246094 17.503906 4.335938 17.695312 4.320312 C 17.722656 4.320312 17.722656 4.320312 17.722656 4.320312 Z M 17.722656 4.320312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 16.40625 4.765625 C 16.375 4.640625 16.375 4.511719 16.375 4.351562 C 16.375 4.320312 16.375 4.320312 16.40625 4.320312 C 16.558594 4.320312 16.679688 4.320312 16.800781 4.320312 C 16.824219 4.597656 16.8125 4.84375 16.40625 4.765625 Z M 16.40625 4.765625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 1.417969 9.085938 C 1.417969 8.933594 1.417969 8.78125 1.417969 8.597656 C 1.417969 8.5625 1.417969 8.5625 1.449219 8.5625 C 1.601562 8.5625 1.722656 8.5625 1.84375 8.597656 C 1.84375 8.78125 1.84375 8.933594 1.8125 9.085938 C 1.660156 9.085938 1.539062 9.085938 1.417969 9.085938 Z M 1.417969 9.085938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.078432%,96.078432%,96.470588%)",
      fillOpacity: 1
    },
    d: "M 17.722656 8.5625 C 17.722656 8.714844 17.722656 8.867188 17.722656 9.050781 C 17.722656 9.085938 17.722656 9.085938 17.695312 9.085938 C 17.542969 9.085938 17.417969 9.085938 17.28125 9.085938 C 17.261719 9.085938 17.226562 9.085938 17.226562 9.050781 C 17.226562 8.867188 17.226562 8.714844 17.246094 8.5625 C 17.261719 8.5625 17.296875 8.5625 17.328125 8.5625 C 17.480469 8.5625 17.601562 8.5625 17.722656 8.5625 Z M 17.722656 8.5625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 1.863281 10.5 C 1.722656 10.5 1.601562 10.5 1.449219 10.5 C 1.417969 10.347656 1.417969 10.195312 1.417969 10.011719 C 1.417969 9.976562 1.417969 9.980469 1.449219 9.980469 C 1.601562 9.980469 1.722656 9.980469 1.863281 9.980469 C 1.878906 9.980469 1.914062 9.980469 1.914062 10.011719 C 1.914062 10.195312 1.914062 10.347656 1.914062 10.5 C 1.914062 10.5 1.878906 10.5 1.863281 10.5 Z M 1.863281 10.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 17.722656 10.46875 C 17.601562 10.5 17.480469 10.5 17.328125 10.46875 C 17.296875 10.28125 17.296875 10.128906 17.328125 9.980469 C 17.480469 9.980469 17.601562 9.980469 17.722656 9.980469 C 17.722656 10.128906 17.722656 10.28125 17.722656 10.46875 Z M 17.722656 10.46875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 17.296875 5.761719 C 17.417969 5.734375 17.542969 5.734375 17.695312 5.734375 C 17.722656 5.863281 17.722656 5.988281 17.722656 6.148438 C 17.722656 6.183594 17.722656 6.21875 17.695312 6.238281 C 17.539062 6.253906 17.417969 6.253906 17.28125 6.246094 C 17.246094 6.226562 17.234375 6.207031 17.230469 6.183594 C 17.25 6.054688 17.273438 5.921875 17.296875 5.761719 Z M 17.296875 5.761719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 17.296875 6.253906 C 17.417969 6.253906 17.539062 6.253906 17.695312 6.253906 C 17.722656 6.382812 17.722656 6.511719 17.722656 6.671875 C 17.722656 6.703125 17.722656 6.703125 17.695312 6.703125 C 17.289062 6.78125 17.277344 6.53125 17.296875 6.253906 Z M 17.296875 6.253906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 1.417969 7.179688 C 1.539062 7.148438 1.660156 7.148438 1.8125 7.148438 C 1.84375 7.148438 1.878906 7.148438 1.894531 7.179688 C 1.914062 7.367188 1.914062 7.519531 1.898438 7.671875 C 1.878906 7.671875 1.847656 7.667969 1.816406 7.667969 C 1.664062 7.667969 1.539062 7.667969 1.417969 7.667969 C 1.417969 7.667969 1.417969 7.671875 1.417969 7.671875 C 1.417969 7.519531 1.417969 7.367188 1.417969 7.179688 Z M 1.417969 7.179688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 17.722656 7.148438 C 17.722656 7.300781 17.722656 7.453125 17.722656 7.636719 C 17.722656 7.671875 17.722656 7.671875 17.695312 7.671875 C 17.542969 7.671875 17.421875 7.671875 17.296875 7.636719 C 17.296875 7.453125 17.296875 7.300781 17.328125 7.148438 C 17.480469 7.148438 17.601562 7.148438 17.722656 7.148438 Z M 17.722656 7.148438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 17.296875 2.457031 C 17.296875 2.457031 17.261719 2.457031 17.246094 2.425781 C 17.226562 2.242188 17.226562 2.089844 17.226562 1.9375 C 17.226562 1.9375 17.261719 1.9375 17.308594 1.9375 C 17.480469 1.9375 17.601562 1.9375 17.722656 1.9375 C 17.722656 2.089844 17.722656 2.242188 17.722656 2.425781 C 17.722656 2.457031 17.722656 2.457031 17.695312 2.457031 C 17.542969 2.457031 17.417969 2.457031 17.296875 2.457031 Z M 17.296875 2.457031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 17.199219 1.9375 C 17.226562 2.089844 17.226562 2.242188 17.226562 2.425781 C 17.105469 2.457031 16.984375 2.457031 16.832031 2.457031 C 16.800781 2.457031 16.800781 2.457031 16.800781 2.425781 C 16.800781 2.242188 16.800781 2.089844 16.800781 1.9375 C 16.921875 1.9375 17.046875 1.9375 17.199219 1.9375 Z M 17.199219 1.9375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 17.722656 1.90625 C 17.601562 1.9375 17.480469 1.9375 17.328125 1.9375 C 17.277344 1.660156 17.289062 1.410156 17.695312 1.488281 C 17.722656 1.617188 17.722656 1.746094 17.722656 1.90625 Z M 17.722656 1.90625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 16.375 1.488281 C 16.5 1.488281 16.621094 1.488281 16.773438 1.488281 C 16.800781 1.617188 16.800781 1.746094 16.800781 1.90625 C 16.800781 1.9375 16.800781 1.9375 16.773438 1.9375 C 16.621094 1.9375 16.5 1.9375 16.375 1.90625 C 16.375 1.746094 16.378906 1.617188 16.378906 1.488281 C 16.378906 1.488281 16.375 1.488281 16.375 1.488281 Z M 16.375 1.488281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 2.765625 1.488281 C 2.910156 1.488281 3.054688 1.488281 3.230469 1.488281 C 3.261719 1.488281 3.261719 1.488281 3.261719 1.519531 C 3.261719 1.679688 3.261719 1.808594 3.230469 1.9375 C 3.054688 1.9375 2.910156 1.9375 2.765625 1.9375 C 2.765625 1.9375 2.765625 1.9375 2.765625 1.90625 C 2.765625 1.746094 2.765625 1.617188 2.765625 1.488281 Z M 2.765625 1.488281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 14.109375 1.9375 C 13.964844 1.9375 13.820312 1.9375 13.644531 1.9375 C 13.617188 1.636719 13.710938 1.429688 14.078125 1.488281 C 14.109375 1.488281 14.109375 1.488281 14.109375 1.519531 C 14.109375 1.679688 14.109375 1.808594 14.109375 1.9375 Z M 14.109375 1.9375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 15.882812 3.421875 C 15.882812 3.421875 15.878906 3.386719 15.910156 3.371094 C 16.085938 3.351562 16.230469 3.351562 16.378906 3.351562 C 16.378906 3.351562 16.375 3.386719 16.375 3.4375 C 16.375 3.617188 16.375 3.746094 16.347656 3.871094 C 16.171875 3.871094 16.023438 3.871094 15.878906 3.839844 C 15.878906 3.679688 15.882812 3.550781 15.882812 3.421875 Z M 15.882812 3.421875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 16.375 3.320312 C 16.230469 3.351562 16.085938 3.351562 15.910156 3.351562 C 15.878906 3.222656 15.878906 3.09375 15.878906 2.9375 C 15.878906 2.902344 15.878906 2.90625 15.910156 2.90625 C 16.085938 2.90625 16.230469 2.90625 16.378906 2.90625 C 16.375 2.902344 16.375 2.902344 16.375 2.902344 C 16.375 3.03125 16.375 3.160156 16.375 3.320312 Z M 16.375 3.320312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 17.296875 2.488281 C 17.417969 2.457031 17.542969 2.457031 17.695312 2.457031 C 17.722656 2.585938 17.722656 2.710938 17.722656 2.871094 C 17.460938 2.925781 17.222656 2.917969 17.296875 2.488281 Z M 17.296875 2.488281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 16.800781 2.457031 C 16.800781 2.585938 16.800781 2.710938 16.800781 2.871094 C 16.800781 2.902344 16.800781 2.902344 16.800781 2.902344 C 16.679688 2.902344 16.558594 2.902344 16.40625 2.902344 C 16.375 2.902344 16.375 2.902344 16.375 2.871094 C 16.375 2.710938 16.375 2.585938 16.40625 2.457031 C 16.558594 2.457031 16.679688 2.457031 16.800781 2.457031 Z M 16.800781 2.457031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 16.378906 3.871094 C 16.375 3.746094 16.375 3.617188 16.375 3.457031 C 16.644531 3.398438 16.875 3.417969 16.800781 3.839844 C 16.800781 3.871094 16.800781 3.871094 16.773438 3.871094 C 16.621094 3.871094 16.5 3.871094 16.375 3.871094 C 16.375 3.871094 16.378906 3.871094 16.378906 3.871094 Z M 16.378906 3.871094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 16.800781 2.90625 C 16.824219 2.90625 16.847656 2.902344 16.871094 2.90625 C 17.015625 2.925781 17.246094 2.824219 17.21875 3.117188 C 17.210938 3.199219 17.105469 3.328125 17.03125 3.339844 C 16.730469 3.386719 16.820312 3.136719 16.800781 2.9375 C 16.800781 2.902344 16.800781 2.902344 16.800781 2.90625 Z M 16.800781 2.90625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 16.347656 1.488281 C 16.378906 1.617188 16.375 1.746094 16.375 1.90625 C 16.375 1.9375 16.378906 1.9375 16.347656 1.9375 C 16.171875 1.9375 16.023438 1.9375 15.878906 1.90625 C 15.878906 1.746094 15.878906 1.617188 15.878906 1.488281 C 16.023438 1.488281 16.171875 1.488281 16.347656 1.488281 Z M 16.347656 1.488281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 15.457031 2.457031 C 15.332031 2.457031 15.210938 2.457031 15.058594 2.457031 C 15.03125 2.457031 15.03125 2.457031 15.03125 2.425781 C 15.03125 2.242188 15.03125 2.089844 15.03125 1.9375 C 15.152344 1.9375 15.273438 1.9375 15.425781 1.9375 C 15.457031 1.9375 15.453125 1.9375 15.453125 1.96875 C 15.457031 2.152344 15.453125 2.304688 15.453125 2.457031 C 15.457031 2.457031 15.457031 2.457031 15.457031 2.457031 Z M 15.457031 2.457031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 14.535156 1.488281 C 14.824219 1.441406 15.019531 1.527344 15.027344 1.90625 C 15.03125 1.9375 15.03125 1.9375 15 1.9375 C 14.824219 1.9375 14.679688 1.9375 14.535156 1.9375 C 14.535156 1.9375 14.535156 1.9375 14.535156 1.90625 C 14.535156 1.746094 14.535156 1.617188 14.535156 1.488281 Z M 14.535156 1.488281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 15.851562 1.488281 C 15.878906 1.617188 15.878906 1.746094 15.878906 1.902344 C 15.878906 1.9375 15.878906 1.9375 15.851562 1.9375 C 15.699219 1.9375 15.578125 1.9375 15.453125 1.9375 C 15.453125 1.9375 15.457031 1.9375 15.457031 1.9375 C 15.457031 1.808594 15.457031 1.679688 15.453125 1.519531 C 15.578125 1.488281 15.699219 1.488281 15.851562 1.488281 Z M 15.851562 1.488281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 17.722656 11.363281 C 17.601562 11.394531 17.480469 11.394531 17.328125 11.394531 C 17.277344 11.117188 17.289062 10.867188 17.695312 10.945312 C 17.722656 11.074219 17.722656 11.203125 17.722656 11.363281 Z M 17.722656 11.363281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 4.609375 1.488281 C 4.730469 1.488281 4.851562 1.488281 5.003906 1.488281 C 5.035156 1.617188 5.035156 1.746094 5.035156 1.90625 C 5.03125 1.9375 5.035156 1.9375 5.003906 1.9375 C 4.851562 1.9375 4.730469 1.9375 4.609375 1.90625 C 4.609375 1.746094 4.609375 1.617188 4.609375 1.488281 Z M 4.609375 1.488281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 3.6875 1.488281 C 3.808594 1.488281 3.929688 1.488281 4.082031 1.488281 C 4.113281 1.488281 4.113281 1.488281 4.113281 1.519531 C 4.113281 1.679688 4.113281 1.808594 4.082031 1.9375 C 3.929688 1.9375 3.808594 1.9375 3.6875 1.90625 C 3.6875 1.746094 3.6875 1.617188 3.6875 1.488281 Z M 3.6875 1.488281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 4.113281 1.9375 C 4.113281 1.808594 4.113281 1.679688 4.113281 1.519531 C 4.257812 1.488281 4.402344 1.488281 4.578125 1.488281 C 4.609375 1.617188 4.609375 1.746094 4.609375 1.90625 C 4.609375 1.9375 4.609375 1.9375 4.578125 1.9375 C 4.425781 1.9375 4.304688 1.9375 4.164062 1.9375 C 4.148438 1.9375 4.113281 1.9375 4.113281 1.9375 Z M 4.113281 1.9375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 14.503906 1.488281 C 14.535156 1.617188 14.535156 1.746094 14.503906 1.90625 C 14.351562 1.9375 14.230469 1.9375 14.109375 1.9375 C 14.109375 1.808594 14.109375 1.679688 14.109375 1.519531 C 14.230469 1.488281 14.351562 1.488281 14.503906 1.488281 Z M 14.503906 1.488281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 3.65625 1.488281 C 3.6875 1.617188 3.6875 1.746094 3.6875 1.90625 C 3.6875 1.9375 3.6875 1.9375 3.65625 1.9375 C 3.503906 1.9375 3.382812 1.9375 3.261719 1.9375 C 3.261719 1.808594 3.261719 1.679688 3.261719 1.519531 C 3.382812 1.488281 3.503906 1.488281 3.65625 1.488281 Z M 3.65625 1.488281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 2.734375 1.488281 C 2.765625 1.617188 2.765625 1.746094 2.765625 1.90625 C 2.644531 1.9375 2.523438 1.9375 2.371094 1.9375 C 2.339844 1.808594 2.339844 1.679688 2.339844 1.519531 C 2.460938 1.488281 2.582031 1.488281 2.734375 1.488281 Z M 2.734375 1.488281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 1.847656 7.667969 C 1.847656 7.667969 1.878906 7.671875 1.925781 7.671875 C 2.097656 7.667969 2.21875 7.667969 2.339844 7.703125 C 2.339844 7.863281 2.339844 7.988281 2.308594 8.117188 C 1.902344 8.039062 1.890625 8.285156 1.894531 8.5625 C 1.878906 8.5625 1.84375 8.5625 1.84375 8.5625 C 1.722656 8.5625 1.601562 8.5625 1.449219 8.5625 C 1.417969 8.4375 1.417969 8.308594 1.417969 8.148438 C 1.417969 8.117188 1.417969 8.117188 1.449219 8.117188 C 1.855469 8.195312 1.863281 7.945312 1.847656 7.667969 Z M 1.847656 7.667969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 17.296875 7.671875 C 17.421875 7.671875 17.542969 7.671875 17.695312 7.667969 C 17.722656 7.796875 17.722656 7.925781 17.722656 8.085938 C 17.722656 8.117188 17.722656 8.117188 17.695312 8.117188 C 17.292969 8.039062 17.269531 8.28125 17.296875 8.5625 C 17.296875 8.5625 17.261719 8.5625 17.214844 8.5625 C 17.042969 8.5625 16.921875 8.5625 16.800781 8.53125 C 16.800781 8.371094 16.800781 8.246094 16.832031 8.117188 C 17.238281 8.195312 17.25 7.945312 17.246094 7.671875 C 17.265625 7.671875 17.296875 7.671875 17.296875 7.671875 Z M 17.296875 7.671875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 1.816406 7.667969 C 1.863281 7.945312 1.855469 8.195312 1.449219 8.117188 C 1.417969 7.988281 1.417969 7.863281 1.417969 7.703125 C 1.539062 7.667969 1.664062 7.667969 1.816406 7.667969 Z M 1.816406 7.667969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 17.722656 7.117188 C 17.601562 7.148438 17.480469 7.148438 17.3125 7.148438 C 17.265625 7.148438 17.230469 7.148438 17.230469 7.117188 C 17.304688 6.691406 17.066406 6.679688 16.800781 6.671875 C 16.878906 6.246094 16.640625 6.230469 16.375 6.234375 C 16.375 6.21875 16.378906 6.179688 16.375 6.148438 C 16.375 5.988281 16.378906 5.863281 16.378906 5.734375 C 16.375 5.734375 16.375 5.734375 16.375 5.734375 C 16.5 5.734375 16.621094 5.734375 16.773438 5.734375 C 16.78125 6.011719 16.792969 6.261719 17.199219 6.183594 C 17.234375 6.207031 17.246094 6.226562 17.28125 6.246094 C 17.277344 6.53125 17.289062 6.78125 17.695312 6.703125 C 17.722656 6.828125 17.722656 6.957031 17.722656 7.117188 Z M 17.722656 7.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 17.722656 9.945312 C 17.601562 9.980469 17.480469 9.980469 17.3125 9.980469 C 17.265625 9.980469 17.230469 9.980469 17.230469 9.945312 C 17.304688 9.519531 17.066406 9.507812 16.800781 9.5 C 16.800781 9.339844 16.800781 9.210938 16.832031 9.085938 C 16.984375 9.085938 17.105469 9.085938 17.226562 9.085938 C 17.226562 9.085938 17.261719 9.085938 17.28125 9.117188 C 17.222656 9.542969 17.457031 9.558594 17.722656 9.53125 C 17.722656 9.660156 17.722656 9.789062 17.722656 9.945312 Z M 17.722656 9.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 1.847656 9.980469 C 1.722656 9.980469 1.601562 9.980469 1.449219 9.980469 C 1.417969 9.851562 1.417969 9.722656 1.417969 9.5625 C 1.417969 9.53125 1.417969 9.53125 1.449219 9.53125 C 1.855469 9.453125 1.863281 9.703125 1.847656 9.980469 Z M 1.847656 9.980469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 17.722656 9.5 C 17.457031 9.558594 17.222656 9.542969 17.296875 9.117188 C 17.417969 9.085938 17.542969 9.085938 17.691406 9.085938 C 17.722656 9.210938 17.722656 9.339844 17.722656 9.5 Z M 17.722656 9.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 1.863281 9.980469 C 1.863281 9.703125 1.855469 9.453125 1.449219 9.53125 C 1.417969 9.40625 1.417969 9.277344 1.417969 9.117188 C 1.539062 9.085938 1.660156 9.085938 1.832031 9.085938 C 1.878906 9.085938 1.914062 9.085938 1.914062 9.117188 C 1.839844 9.542969 2.074219 9.554688 2.339844 9.5625 C 2.339844 9.722656 2.339844 9.851562 2.308594 9.980469 C 2.15625 9.980469 2.035156 9.980469 1.914062 9.980469 C 1.914062 9.980469 1.878906 9.980469 1.863281 9.980469 Z M 1.863281 9.980469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 17.328125 8.5625 C 17.269531 8.28125 17.292969 8.039062 17.695312 8.117188 C 17.722656 8.246094 17.722656 8.371094 17.722656 8.53125 C 17.601562 8.5625 17.480469 8.5625 17.328125 8.5625 Z M 17.328125 8.5625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 2.796875 11.394531 C 2.765625 11.265625 2.765625 11.136719 2.765625 10.980469 C 2.765625 10.945312 2.765625 10.945312 2.796875 10.945312 C 2.972656 10.945312 3.117188 10.945312 3.261719 10.980469 C 3.261719 11.136719 3.261719 11.265625 3.261719 11.394531 C 3.117188 11.394531 2.972656 11.394531 2.796875 11.394531 Z M 2.796875 11.394531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 3.6875 11.46875 C 3.6875 11.59375 3.6875 11.722656 3.6875 11.882812 C 3.566406 11.914062 3.445312 11.914062 3.292969 11.914062 C 3.261719 11.761719 3.261719 11.609375 3.261719 11.425781 C 3.261719 11.394531 3.261719 11.394531 3.289062 11.394531 C 3.4375 11.417969 3.5625 11.441406 3.6875 11.46875 Z M 3.6875 11.46875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 1.914062 10.011719 C 2.035156 9.980469 2.15625 9.980469 2.308594 9.980469 C 2.339844 9.980469 2.339844 9.976562 2.339844 10.011719 C 2.339844 10.195312 2.339844 10.347656 2.339844 10.5 C 2.21875 10.5 2.097656 10.5 1.945312 10.5 C 1.914062 10.347656 1.914062 10.195312 1.914062 10.011719 Z M 1.914062 10.011719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 2.765625 10.945312 C 2.644531 10.945312 2.523438 10.945312 2.371094 10.945312 C 2.339844 10.820312 2.339844 10.691406 2.339844 10.53125 C 2.339844 10.5 2.339844 10.5 2.371094 10.5 C 2.523438 10.5 2.644531 10.5 2.765625 10.53125 C 2.765625 10.691406 2.765625 10.820312 2.765625 10.945312 Z M 2.765625 10.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 3.261719 2.902344 C 3.117188 2.902344 2.972656 2.902344 2.796875 2.902344 C 2.765625 2.902344 2.765625 2.902344 2.765625 2.871094 C 2.765625 2.710938 2.765625 2.585938 2.765625 2.457031 C 2.765625 2.457031 2.765625 2.457031 2.796875 2.457031 C 2.972656 2.457031 3.117188 2.457031 3.261719 2.457031 C 3.261719 2.457031 3.261719 2.457031 3.261719 2.488281 C 3.261719 2.648438 3.261719 2.777344 3.261719 2.90625 C 3.261719 2.902344 3.261719 2.902344 3.261719 2.902344 Z M 3.261719 2.902344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 3.6875 2.902344 C 3.710938 3.183594 3.699219 3.429688 3.292969 3.351562 C 3.261719 3.222656 3.261719 3.097656 3.261719 2.9375 C 3.261719 2.902344 3.261719 2.902344 3.292969 2.90625 C 3.445312 2.90625 3.566406 2.90625 3.6875 2.90625 C 3.6875 2.902344 3.6875 2.902344 3.6875 2.902344 Z M 3.6875 2.902344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 2.765625 5.289062 C 2.910156 5.289062 3.054688 5.289062 3.230469 5.289062 C 3.261719 5.289062 3.261719 5.285156 3.261719 5.320312 C 3.261719 5.480469 3.261719 5.605469 3.261719 5.734375 C 3.261719 5.734375 3.261719 5.734375 3.230469 5.734375 C 3.054688 5.734375 2.910156 5.734375 2.765625 5.734375 C 2.765625 5.734375 2.765625 5.734375 2.765625 5.703125 C 2.765625 5.542969 2.765625 5.414062 2.765625 5.285156 C 2.765625 5.285156 2.765625 5.289062 2.765625 5.289062 Z M 2.765625 5.289062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 3.6875 4.765625 C 3.6875 4.765625 3.6875 4.804688 3.65625 4.820312 C 3.503906 4.839844 3.382812 4.839844 3.261719 4.839844 C 3.261719 4.839844 3.261719 4.800781 3.261719 4.785156 C 3.261719 4.636719 3.261719 4.511719 3.261719 4.351562 C 3.261719 4.320312 3.261719 4.320312 3.292969 4.320312 C 3.445312 4.320312 3.566406 4.320312 3.6875 4.320312 C 3.6875 4.320312 3.6875 4.320312 3.6875 4.351562 C 3.6875 4.511719 3.6875 4.640625 3.6875 4.765625 Z M 3.6875 4.765625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 3.261719 4.871094 C 3.382812 4.839844 3.503906 4.839844 3.65625 4.839844 C 3.6875 4.96875 3.6875 5.09375 3.6875 5.253906 C 3.6875 5.289062 3.6875 5.285156 3.65625 5.285156 C 3.503906 5.285156 3.382812 5.285156 3.261719 5.285156 C 3.261719 5.285156 3.261719 5.289062 3.261719 5.289062 C 3.261719 5.160156 3.261719 5.03125 3.261719 4.871094 Z M 3.261719 4.871094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 2.796875 4.320312 C 2.765625 4.191406 2.765625 4.0625 2.765625 3.902344 C 2.910156 3.871094 3.054688 3.871094 3.230469 3.871094 C 3.261719 3.871094 3.261719 3.871094 3.261719 3.902344 C 3.261719 4.0625 3.261719 4.191406 3.261719 4.320312 C 3.117188 4.320312 2.972656 4.320312 2.796875 4.320312 Z M 2.796875 4.320312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 2.734375 2.457031 C 2.765625 2.585938 2.765625 2.710938 2.765625 2.871094 C 2.644531 2.90625 2.523438 2.90625 2.371094 2.90625 C 2.339844 2.777344 2.339844 2.648438 2.339844 2.488281 C 2.460938 2.457031 2.582031 2.457031 2.734375 2.457031 Z M 2.734375 2.457031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 2.734375 5.285156 C 2.765625 5.414062 2.765625 5.542969 2.734375 5.703125 C 2.582031 5.734375 2.460938 5.734375 2.339844 5.734375 C 2.339844 5.605469 2.339844 5.480469 2.339844 5.320312 C 2.460938 5.285156 2.582031 5.285156 2.734375 5.285156 Z M 2.734375 5.285156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,98.823529%,98.823529%)",
      fillOpacity: 1
    },
    d: "M 3.261719 2.457031 C 3.117188 2.457031 2.972656 2.457031 2.796875 2.457031 C 2.765625 2.304688 2.765625 2.152344 2.765625 1.96875 C 2.910156 1.9375 3.054688 1.9375 3.230469 1.9375 C 3.261719 1.9375 3.261719 1.9375 3.261719 1.96875 C 3.261719 2.152344 3.261719 2.304688 3.261719 2.457031 Z M 3.261719 2.457031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 15.457031 9.085938 C 15.335938 9.085938 15.21875 9.085938 15.074219 9.085938 C 15.136719 8.660156 15.226562 8.234375 15.347656 7.777344 C 15.402344 7.742188 15.429688 7.746094 15.453125 7.777344 C 15.40625 8.203125 15.679688 8.105469 15.878906 8.148438 C 15.878906 8.308594 15.878906 8.4375 15.851562 8.5625 C 15.363281 8.480469 15.460938 8.824219 15.453125 9.085938 C 15.457031 9.085938 15.457031 9.085938 15.457031 9.085938 Z M 15.457031 9.085938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.431373%,97.254902%,97.254902%)",
      fillOpacity: 1
    },
    d: "M 3.769531 6.695312 C 3.789062 7.097656 3.8125 7.5 3.824219 7.960938 C 3.777344 8.050781 3.730469 8.085938 3.6875 8.085938 C 3.757812 7.660156 3.527344 7.644531 3.242188 7.671875 C 3.226562 7.671875 3.191406 7.671875 3.191406 7.640625 C 3.21875 7.457031 3.238281 7.304688 3.292969 7.148438 C 3.695312 7.226562 3.710938 6.984375 3.707031 6.699219 C 3.742188 6.699219 3.757812 6.699219 3.769531 6.695312 Z M 3.769531 6.695312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.078432%,96.078432%,96.470588%)",
      fillOpacity: 1
    },
    d: "M 3.6875 8.117188 C 3.730469 8.085938 3.777344 8.050781 3.824219 7.996094 C 3.867188 8.152344 3.910156 8.328125 3.925781 8.535156 C 3.828125 8.589844 3.757812 8.613281 3.65625 8.636719 C 3.503906 8.636719 3.382812 8.636719 3.246094 8.628906 C 3.210938 8.605469 3.199219 8.589844 3.191406 8.53125 C 3.191406 8.371094 3.191406 8.246094 3.207031 8.117188 C 3.238281 8.117188 3.25 8.117188 3.292969 8.117188 C 3.445312 8.117188 3.566406 8.117188 3.6875 8.117188 Z M 3.6875 8.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 3.6875 5.289062 C 3.78125 5.289062 3.875 5.285156 4 5.285156 C 4.019531 5.328125 4.011719 5.375 3.988281 5.449219 C 3.96875 5.480469 3.964844 5.492188 3.964844 5.492188 C 3.964844 5.492188 3.972656 5.5 3.957031 5.511719 C 3.9375 5.527344 3.925781 5.539062 3.929688 5.542969 C 3.933594 5.554688 3.945312 5.570312 3.953125 5.582031 C 3.945312 5.625 3.9375 5.664062 3.917969 5.734375 C 3.90625 5.761719 3.910156 5.753906 3.910156 5.753906 C 3.859375 5.832031 3.808594 5.910156 3.746094 6.035156 C 3.722656 6.117188 3.703125 6.148438 3.65625 6.183594 C 3.503906 6.183594 3.382812 6.183594 3.261719 6.148438 C 3.261719 5.988281 3.261719 5.863281 3.261719 5.734375 C 3.261719 5.734375 3.261719 5.734375 3.292969 5.734375 C 3.699219 5.8125 3.707031 5.566406 3.6875 5.285156 C 3.6875 5.285156 3.6875 5.289062 3.6875 5.289062 Z M 3.6875 5.289062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 3.261719 6.183594 C 3.382812 6.183594 3.503906 6.183594 3.660156 6.210938 C 3.734375 6.273438 3.769531 6.304688 3.808594 6.339844 C 3.800781 6.441406 3.796875 6.539062 3.78125 6.667969 C 3.757812 6.699219 3.742188 6.699219 3.675781 6.699219 C 3.503906 6.703125 3.382812 6.703125 3.261719 6.671875 C 3.261719 6.511719 3.261719 6.382812 3.261719 6.238281 C 3.261719 6.21875 3.261719 6.183594 3.261719 6.183594 Z M 3.261719 6.183594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 15.382812 7.148438 C 15.375 7.023438 15.371094 6.894531 15.386719 6.734375 C 15.429688 6.703125 15.441406 6.703125 15.484375 6.703125 C 15.636719 6.703125 15.757812 6.703125 15.878906 6.703125 C 15.878906 6.703125 15.878906 6.703125 15.878906 6.734375 C 15.878906 6.894531 15.878906 7.023438 15.851562 7.148438 C 15.699219 7.148438 15.578125 7.148438 15.4375 7.148438 C 15.40625 7.148438 15.394531 7.148438 15.382812 7.148438 Z M 15.382812 7.148438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,98.823529%,98.823529%)",
      fillOpacity: 1
    },
    d: "M 3.6875 8.636719 C 3.757812 8.613281 3.828125 8.589844 3.925781 8.566406 C 4 8.71875 4.046875 8.875 4.097656 9.058594 C 3.976562 9.085938 3.863281 9.085938 3.714844 9.085938 C 3.6875 9.085938 3.6875 9.085938 3.6875 9.054688 C 3.6875 8.894531 3.6875 8.765625 3.6875 8.636719 Z M 3.6875 8.636719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.078432%,96.078432%,96.470588%)",
      fillOpacity: 1
    },
    d: "M 15.457031 6.703125 C 15.441406 6.703125 15.429688 6.703125 15.394531 6.703125 C 15.347656 6.503906 15.320312 6.304688 15.292969 6.070312 C 15.335938 6.078125 15.378906 6.117188 15.4375 6.1875 C 15.457031 6.230469 15.457031 6.242188 15.457031 6.289062 C 15.457031 6.445312 15.457031 6.574219 15.457031 6.703125 Z M 15.457031 6.703125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.078432%,96.078432%,96.470588%)",
      fillOpacity: 1
    },
    d: "M 15.371094 7.175781 C 15.394531 7.148438 15.40625 7.148438 15.4375 7.183594 C 15.457031 7.367188 15.457031 7.515625 15.457031 7.6875 C 15.453125 7.71875 15.453125 7.734375 15.453125 7.746094 C 15.429688 7.746094 15.402344 7.742188 15.355469 7.742188 C 15.34375 7.5625 15.351562 7.382812 15.371094 7.175781 Z M 15.371094 7.175781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(98.431373%,97.254902%,97.254902%)",
      fillOpacity: 1
    },
    d: "M 3.816406 6.324219 C 3.769531 6.304688 3.734375 6.273438 3.691406 6.210938 C 3.703125 6.148438 3.722656 6.117188 3.746094 6.066406 C 3.773438 6.132812 3.800781 6.21875 3.816406 6.324219 Z M 3.816406 6.324219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 3.910156 5.761719 C 3.910156 5.753906 3.90625 5.761719 3.902344 5.761719 C 3.902344 5.761719 3.910156 5.765625 3.910156 5.761719 Z M 3.910156 5.761719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(96.078432%,96.078432%,96.470588%)",
      fillOpacity: 1
    },
    d: "M 15.292969 5.582031 C 15.304688 5.601562 15.296875 5.621094 15.265625 5.648438 C 15.257812 5.636719 15.265625 5.613281 15.292969 5.582031 Z M 15.292969 5.582031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 3.960938 5.566406 C 3.945312 5.570312 3.933594 5.554688 3.929688 5.542969 C 3.925781 5.539062 3.9375 5.527344 3.953125 5.515625 C 3.964844 5.519531 3.964844 5.535156 3.960938 5.566406 Z M 3.960938 5.566406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 3.972656 5.488281 C 3.964844 5.492188 3.96875 5.480469 3.96875 5.480469 C 3.96875 5.476562 3.980469 5.484375 3.972656 5.488281 Z M 3.972656 5.488281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(76.862746%,83.529413%,90.588236%)",
      fillOpacity: 1
    },
    d: "M 15.105469 5.308594 C 15.125 5.308594 15.140625 5.328125 15.160156 5.371094 C 15.140625 5.371094 15.121094 5.351562 15.105469 5.308594 Z M 15.105469 5.308594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 4.609375 2.902344 C 4.609375 3.03125 4.609375 3.160156 4.609375 3.320312 C 4.347656 3.355469 4.058594 3.410156 4.113281 2.933594 C 4.113281 2.902344 4.113281 2.90625 4.144531 2.90625 C 4.320312 2.90625 4.464844 2.90625 4.609375 2.90625 C 4.609375 2.90625 4.609375 2.902344 4.609375 2.902344 Z M 4.609375 2.902344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 4.113281 2.902344 C 3.992188 2.902344 3.867188 2.902344 3.714844 2.902344 C 3.6875 2.902344 3.6875 2.902344 3.6875 2.871094 C 3.6875 2.710938 3.6875 2.585938 3.6875 2.457031 C 3.6875 2.457031 3.6875 2.457031 3.714844 2.457031 C 3.871094 2.457031 3.992188 2.457031 4.113281 2.488281 C 4.113281 2.648438 4.113281 2.777344 4.113281 2.90625 C 4.113281 2.90625 4.113281 2.902344 4.113281 2.902344 Z M 4.113281 2.902344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 3.292969 4.320312 C 3.261719 4.191406 3.261719 4.0625 3.261719 3.902344 C 3.382812 3.871094 3.503906 3.871094 3.65625 3.871094 C 3.6875 4 3.6875 4.128906 3.6875 4.289062 C 3.566406 4.320312 3.445312 4.320312 3.292969 4.320312 Z M 3.292969 4.320312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 4.113281 3.839844 C 3.992188 3.871094 3.867188 3.871094 3.714844 3.871094 C 3.71875 3.726562 3.707031 3.523438 3.792969 3.453125 C 3.964844 3.308594 4.101562 3.464844 4.113281 3.839844 Z M 4.113281 3.839844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 15.457031 6.253906 C 15.457031 6.242188 15.457031 6.230469 15.453125 6.199219 C 15.429688 5.898438 15.449219 5.65625 15.851562 5.734375 C 15.878906 5.734375 15.878906 5.734375 15.878906 5.765625 C 15.878906 5.925781 15.878906 6.054688 15.878906 6.199219 C 15.878906 6.21875 15.882812 6.253906 15.851562 6.253906 C 15.699219 6.253906 15.578125 6.253906 15.457031 6.253906 Z M 15.457031 6.253906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 16.347656 5.285156 C 16.378906 5.414062 16.375 5.542969 16.375 5.703125 C 16.375 5.734375 16.375 5.734375 16.347656 5.734375 C 16.171875 5.734375 16.023438 5.734375 15.878906 5.734375 C 15.878906 5.605469 15.878906 5.480469 15.878906 5.320312 C 16.023438 5.285156 16.171875 5.285156 16.347656 5.285156 Z M 16.347656 5.285156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 15.03125 3.902344 C 15.152344 3.871094 15.273438 3.871094 15.425781 3.871094 C 15.457031 3.871094 15.453125 3.871094 15.453125 3.902344 C 15.453125 4.0625 15.453125 4.191406 15.453125 4.320312 C 15.457031 4.320312 15.457031 4.320312 15.457031 4.320312 C 15.332031 4.320312 15.210938 4.320312 15.058594 4.320312 C 15.03125 4.191406 15.03125 4.0625 15.03125 3.902344 Z M 15.03125 3.902344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 15.878906 4.320312 C 15.878906 4.449219 15.878906 4.574219 15.882812 4.734375 C 15.617188 4.789062 15.378906 4.777344 15.457031 4.351562 C 15.457031 4.320312 15.457031 4.320312 15.484375 4.320312 C 15.636719 4.320312 15.757812 4.320312 15.878906 4.320312 Z M 15.878906 4.320312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 3.714844 4.765625 C 3.6875 4.640625 3.6875 4.511719 3.6875 4.351562 C 3.808594 4.320312 3.929688 4.320312 4.082031 4.320312 C 4.113281 4.445312 4.113281 4.574219 4.113281 4.734375 C 3.992188 4.765625 3.867188 4.765625 3.714844 4.765625 Z M 3.714844 4.765625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 14.5625 2.90625 C 14.535156 2.777344 14.535156 2.648438 14.535156 2.488281 C 14.535156 2.457031 14.535156 2.457031 14.5625 2.457031 C 14.742188 2.457031 14.886719 2.457031 15.03125 2.457031 C 15.054688 2.789062 14.929688 2.960938 14.5625 2.90625 Z M 14.5625 2.90625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 15.457031 2.90625 C 15.457031 2.777344 15.457031 2.648438 15.457031 2.488281 C 15.457031 2.457031 15.457031 2.457031 15.484375 2.457031 C 15.636719 2.457031 15.757812 2.457031 15.878906 2.457031 C 15.878906 2.457031 15.878906 2.457031 15.878906 2.488281 C 15.878906 2.648438 15.878906 2.777344 15.878906 2.90625 C 15.878906 2.90625 15.878906 2.902344 15.878906 2.902344 C 15.757812 2.902344 15.636719 2.902344 15.484375 2.902344 C 15.457031 2.902344 15.457031 2.90625 15.457031 2.90625 Z M 15.457031 2.90625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 15.851562 3.425781 C 15.882812 3.550781 15.878906 3.679688 15.878906 3.839844 C 15.878906 3.871094 15.882812 3.871094 15.851562 3.871094 C 15.699219 3.871094 15.578125 3.871094 15.453125 3.871094 C 15.453125 3.871094 15.457031 3.871094 15.457031 3.871094 C 15.433594 3.59375 15.445312 3.347656 15.851562 3.425781 Z M 15.851562 3.425781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 15.453125 2.902344 C 15.453125 2.929688 15.457031 2.953125 15.453125 2.976562 C 15.433594 3.128906 15.53125 3.367188 15.253906 3.339844 C 15.171875 3.332031 15.050781 3.222656 15.039062 3.144531 C 14.996094 2.832031 15.234375 2.921875 15.425781 2.90625 C 15.457031 2.90625 15.457031 2.902344 15.453125 2.902344 Z M 15.453125 2.902344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 14.109375 1.96875 C 14.230469 1.9375 14.351562 1.9375 14.503906 1.9375 C 14.535156 1.9375 14.535156 1.9375 14.535156 1.96875 C 14.535156 2.152344 14.535156 2.304688 14.535156 2.457031 C 14.414062 2.457031 14.289062 2.457031 14.136719 2.457031 C 14.109375 2.304688 14.109375 2.152344 14.109375 1.96875 Z M 14.109375 1.96875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 4.609375 1.9375 C 4.730469 1.9375 4.851562 1.9375 5.003906 1.9375 C 5.035156 2.089844 5.035156 2.242188 5.035156 2.425781 C 4.914062 2.457031 4.789062 2.457031 4.636719 2.457031 C 4.609375 2.457031 4.609375 2.457031 4.609375 2.425781 C 4.609375 2.242188 4.609375 2.089844 4.609375 1.9375 Z M 4.609375 1.9375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 4.144531 2.90625 C 4.113281 2.777344 4.113281 2.648438 4.128906 2.488281 C 4.148438 2.457031 4.183594 2.457031 4.210938 2.457031 C 4.363281 2.457031 4.488281 2.457031 4.609375 2.457031 C 4.609375 2.585938 4.609375 2.710938 4.609375 2.871094 C 4.464844 2.90625 4.320312 2.90625 4.144531 2.90625 Z M 4.144531 2.90625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 16.375 11.394531 C 16.375 11.394531 16.375 11.429688 16.347656 11.449219 C 16.171875 11.46875 16.023438 11.46875 15.878906 11.46875 C 15.878906 11.46875 15.878906 11.433594 15.878906 11.382812 C 15.878906 11.203125 15.878906 11.074219 15.910156 10.945312 C 16.085938 10.945312 16.230469 10.945312 16.378906 10.980469 C 16.375 11.140625 16.375 11.265625 16.375 11.394531 Z M 16.375 11.394531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 15.878906 11.5 C 16.023438 11.46875 16.171875 11.46875 16.347656 11.46875 C 16.375 11.59375 16.375 11.722656 16.378906 11.882812 C 16.230469 11.914062 16.085938 11.914062 15.910156 11.914062 C 15.878906 11.789062 15.878906 11.660156 15.878906 11.5 Z M 15.878906 11.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 15.027344 10.53125 C 15.148438 10.5 15.273438 10.5 15.425781 10.5 C 15.457031 10.5 15.453125 10.5 15.453125 10.53125 C 15.453125 10.691406 15.453125 10.820312 15.453125 10.945312 C 15.457031 10.945312 15.457031 10.945312 15.457031 10.945312 C 15.191406 10.96875 14.953125 10.957031 15.027344 10.53125 Z M 15.027344 10.53125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 15.457031 11.882812 C 15.332031 11.914062 15.210938 11.914062 15.058594 11.914062 C 15.03125 11.785156 15.03125 11.660156 15.03125 11.496094 C 15.292969 11.445312 15.53125 11.457031 15.457031 11.882812 Z M 15.457031 11.882812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 14.960938 11.363281 C 14.839844 11.394531 14.714844 11.394531 14.5625 11.394531 C 14.535156 11.265625 14.535156 11.136719 14.535156 10.976562 C 14.796875 10.925781 15.035156 10.933594 14.960938 11.363281 Z M 14.960938 11.363281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 15.878906 10.945312 C 15.878906 11.074219 15.878906 11.203125 15.882812 11.363281 C 15.617188 11.417969 15.378906 11.40625 15.457031 10.976562 C 15.457031 10.945312 15.457031 10.945312 15.484375 10.945312 C 15.636719 10.945312 15.757812 10.945312 15.878906 10.945312 Z M 15.878906 10.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 15.457031 10.5 C 15.457031 10.347656 15.457031 10.195312 15.457031 10.011719 C 15.457031 9.980469 15.453125 9.980469 15.484375 9.980469 C 15.636719 9.980469 15.757812 9.980469 15.878906 10.011719 C 15.878906 10.195312 15.878906 10.347656 15.878906 10.5 C 15.878906 10.5 15.882812 10.5 15.851562 10.5 C 15.699219 10.5 15.578125 10.5 15.453125 10.5 C 15.453125 10.5 15.457031 10.5 15.457031 10.5 Z M 15.457031 10.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 15.058594 9.980469 C 15.03125 9.851562 15.03125 9.722656 15.03125 9.5625 C 15.152344 9.53125 15.273438 9.53125 15.425781 9.53125 C 15.457031 9.53125 15.453125 9.53125 15.453125 9.5625 C 15.453125 9.722656 15.453125 9.851562 15.453125 9.980469 C 15.453125 9.980469 15.457031 9.980469 15.457031 9.980469 C 15.332031 9.980469 15.210938 9.980469 15.058594 9.980469 Z M 15.058594 9.980469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 3.6875 9.980469 C 3.808594 9.980469 3.929688 9.980469 4.082031 9.980469 C 4.113281 10.128906 4.113281 10.28125 4.113281 10.46875 C 4.113281 10.5 4.113281 10.5 4.082031 10.5 C 3.929688 10.5 3.808594 10.5 3.6875 10.46875 C 3.6875 10.28125 3.6875 10.128906 3.6875 9.980469 Z M 3.6875 9.980469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 4.578125 10.5 C 4.609375 10.628906 4.609375 10.753906 4.609375 10.914062 C 4.609375 10.945312 4.609375 10.945312 4.578125 10.945312 C 4.402344 10.945312 4.257812 10.945312 4.113281 10.945312 C 4.113281 10.945312 4.113281 10.945312 4.113281 10.914062 C 4.113281 10.753906 4.113281 10.628906 4.113281 10.5 C 4.257812 10.5 4.402344 10.5 4.578125 10.5 Z M 4.578125 10.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 3.6875 9.085938 C 3.6875 9.210938 3.6875 9.339844 3.6875 9.5 C 3.6875 9.53125 3.6875 9.53125 3.65625 9.53125 C 3.503906 9.53125 3.382812 9.53125 3.261719 9.5 C 3.261719 9.339844 3.261719 9.210938 3.261719 9.085938 C 3.261719 9.085938 3.261719 9.085938 3.292969 9.085938 C 3.445312 9.085938 3.566406 9.085938 3.6875 9.085938 Z M 3.6875 9.085938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 4.113281 10.945312 C 4.257812 10.945312 4.402344 10.945312 4.578125 10.945312 C 4.609375 11.074219 4.609375 11.203125 4.609375 11.363281 C 4.609375 11.394531 4.609375 11.394531 4.582031 11.394531 C 4.40625 11.417969 4.257812 11.445312 4.113281 11.46875 C 4.113281 11.46875 4.113281 11.433594 4.113281 11.382812 C 4.113281 11.203125 4.113281 11.074219 4.113281 10.945312 Z M 4.113281 10.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 3.261719 9.53125 C 3.382812 9.53125 3.503906 9.53125 3.65625 9.53125 C 3.6875 9.660156 3.6875 9.789062 3.6875 9.945312 C 3.6875 9.980469 3.6875 9.980469 3.65625 9.980469 C 3.503906 9.980469 3.382812 9.980469 3.261719 9.945312 C 3.261719 9.789062 3.261719 9.660156 3.261719 9.53125 Z M 3.261719 9.53125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 15.457031 9.53125 C 15.457031 9.40625 15.457031 9.277344 15.457031 9.117188 C 15.457031 9.085938 15.457031 9.085938 15.484375 9.085938 C 15.636719 9.085938 15.757812 9.085938 15.878906 9.117188 C 15.878906 9.277344 15.878906 9.40625 15.851562 9.53125 C 15.699219 9.53125 15.578125 9.53125 15.453125 9.53125 C 15.453125 9.53125 15.457031 9.53125 15.457031 9.53125 Z M 15.457031 9.53125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 4.113281 11.5 C 4.257812 11.445312 4.40625 11.417969 4.582031 11.394531 C 4.609375 11.546875 4.609375 11.699219 4.609375 11.882812 C 4.464844 11.914062 4.320312 11.914062 4.144531 11.914062 C 4.113281 11.789062 4.113281 11.660156 4.113281 11.5 Z M 4.113281 11.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 2.339844 6.703125 C 2.339844 6.574219 2.339844 6.445312 2.339844 6.285156 C 2.339844 6.253906 2.339844 6.21875 2.371094 6.199219 C 2.523438 6.183594 2.644531 6.183594 2.765625 6.199219 C 2.765625 6.21875 2.765625 6.253906 2.765625 6.285156 C 2.765625 6.445312 2.765625 6.574219 2.734375 6.703125 C 2.582031 6.703125 2.460938 6.703125 2.339844 6.703125 Z M 2.339844 6.703125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 2.765625 6.183594 C 2.644531 6.183594 2.523438 6.183594 2.371094 6.183594 C 2.339844 6.054688 2.339844 5.925781 2.339844 5.765625 C 2.460938 5.734375 2.582031 5.734375 2.734375 5.734375 C 2.765625 5.734375 2.765625 5.734375 2.765625 5.765625 C 2.765625 5.925781 2.765625 6.054688 2.765625 6.183594 Z M 2.765625 6.183594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 2.339844 7.667969 C 2.21875 7.667969 2.097656 7.667969 1.945312 7.671875 C 1.914062 7.519531 1.914062 7.367188 1.914062 7.179688 C 2.035156 7.148438 2.15625 7.148438 2.308594 7.148438 C 2.339844 7.148438 2.339844 7.148438 2.339844 7.179688 C 2.339844 7.367188 2.339844 7.519531 2.339844 7.671875 C 2.339844 7.671875 2.339844 7.667969 2.339844 7.667969 Z M 2.339844 7.667969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 2.339844 6.734375 C 2.460938 6.703125 2.582031 6.703125 2.734375 6.703125 C 2.765625 6.703125 2.765625 6.703125 2.765625 6.734375 C 2.765625 6.894531 2.765625 7.019531 2.765625 7.148438 C 2.765625 7.148438 2.765625 7.148438 2.734375 7.148438 C 2.582031 7.148438 2.460938 7.148438 2.339844 7.148438 C 2.339844 7.019531 2.339844 6.894531 2.339844 6.734375 Z M 2.339844 6.734375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 17.230469 9.980469 C 17.230469 9.980469 17.265625 9.980469 17.28125 9.980469 C 17.296875 10.128906 17.296875 10.28125 17.296875 10.46875 C 17.296875 10.5 17.265625 10.5 17.214844 10.5 C 17.046875 10.5 16.925781 10.5 16.800781 10.46875 C 16.800781 10.28125 16.800781 10.128906 16.832031 9.980469 C 16.984375 9.980469 17.109375 9.980469 17.230469 9.980469 Z M 17.230469 9.980469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 16.800781 10.5 C 16.925781 10.5 17.046875 10.5 17.199219 10.5 C 17.25 10.777344 17.238281 11.027344 16.832031 10.945312 C 16.800781 10.945312 16.800781 10.945312 16.800781 10.914062 C 16.800781 10.753906 16.800781 10.628906 16.800781 10.5 Z M 16.800781 10.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 16.40625 11.394531 C 16.375 11.265625 16.375 11.140625 16.375 10.980469 C 16.375 10.945312 16.375 10.945312 16.40625 10.945312 C 16.558594 10.945312 16.679688 10.945312 16.800781 10.945312 C 16.824219 11.226562 16.8125 11.472656 16.40625 11.394531 Z M 16.40625 11.394531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 3.6875 11.449219 C 3.5625 11.441406 3.4375 11.417969 3.289062 11.394531 C 3.261719 11.265625 3.261719 11.136719 3.261719 10.980469 C 3.261719 10.945312 3.261719 10.945312 3.292969 10.945312 C 3.445312 10.945312 3.566406 10.945312 3.6875 10.945312 C 3.6875 10.945312 3.6875 10.945312 3.6875 10.976562 C 3.6875 11.136719 3.6875 11.265625 3.6875 11.394531 C 3.6875 11.394531 3.6875 11.429688 3.6875 11.449219 Z M 3.6875 11.449219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 3.714844 11.394531 C 3.6875 11.265625 3.6875 11.136719 3.71875 10.980469 C 3.867188 10.945312 3.992188 10.945312 4.113281 10.945312 C 4.113281 11.074219 4.113281 11.203125 4.113281 11.363281 C 3.992188 11.394531 3.867188 11.394531 3.714844 11.394531 Z M 3.714844 11.394531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 15.878906 3.871094 C 16.023438 3.871094 16.171875 3.871094 16.347656 3.871094 C 16.378906 3.871094 16.375 3.871094 16.375 3.902344 C 16.375 4.0625 16.375 4.191406 16.375 4.320312 C 16.230469 4.320312 16.085938 4.320312 15.910156 4.320312 C 15.878906 4.320312 15.878906 4.320312 15.878906 4.289062 C 15.882812 4.128906 15.882812 4 15.882812 3.871094 C 15.882812 3.871094 15.878906 3.871094 15.878906 3.871094 Z M 15.878906 3.871094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 16.40625 4.320312 C 16.375 4.191406 16.375 4.0625 16.375 3.902344 C 16.5 3.871094 16.621094 3.871094 16.773438 3.871094 C 16.800781 4 16.800781 4.128906 16.800781 4.289062 C 16.679688 4.320312 16.558594 4.320312 16.40625 4.320312 Z M 16.40625 4.320312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 1.914062 9.085938 C 1.914062 9.085938 1.878906 9.085938 1.859375 9.085938 C 1.84375 8.933594 1.84375 8.78125 1.84375 8.597656 C 1.84375 8.5625 1.878906 8.5625 1.925781 8.5625 C 2.09375 8.5625 2.21875 8.5625 2.339844 8.597656 C 2.339844 8.78125 2.339844 8.933594 2.308594 9.085938 C 2.15625 9.085938 2.035156 9.085938 1.914062 9.085938 Z M 1.914062 9.085938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 17.226562 9.050781 C 17.105469 9.085938 16.984375 9.085938 16.832031 9.085938 C 16.800781 9.085938 16.800781 9.085938 16.800781 9.054688 C 16.800781 8.867188 16.800781 8.714844 16.800781 8.5625 C 16.921875 8.5625 17.042969 8.5625 17.195312 8.5625 C 17.226562 8.714844 17.226562 8.867188 17.226562 9.050781 Z M 17.226562 9.050781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 17.230469 7.148438 C 17.230469 7.148438 17.265625 7.148438 17.28125 7.148438 C 17.296875 7.300781 17.296875 7.453125 17.296875 7.636719 C 17.296875 7.671875 17.265625 7.671875 17.214844 7.667969 C 17.046875 7.667969 16.925781 7.671875 16.800781 7.636719 C 16.800781 7.453125 16.800781 7.300781 16.832031 7.148438 C 16.984375 7.148438 17.105469 7.148438 17.230469 7.148438 Z M 17.230469 7.148438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 16.800781 2.425781 C 16.679688 2.457031 16.558594 2.457031 16.40625 2.457031 C 16.375 2.457031 16.378906 2.457031 16.375 2.425781 C 16.375 2.242188 16.375 2.089844 16.378906 1.9375 C 16.378906 1.9375 16.375 1.9375 16.375 1.9375 C 16.5 1.9375 16.621094 1.9375 16.773438 1.9375 C 16.800781 2.089844 16.800781 2.242188 16.800781 2.425781 Z M 16.800781 2.425781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 15.910156 2.90625 C 15.878906 2.777344 15.878906 2.648438 15.910156 2.488281 C 16.085938 2.457031 16.230469 2.457031 16.378906 2.457031 C 16.378906 2.457031 16.375 2.457031 16.375 2.457031 C 16.375 2.585938 16.375 2.710938 16.378906 2.871094 C 16.230469 2.90625 16.085938 2.90625 15.910156 2.90625 Z M 15.910156 2.90625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 16.375 2.425781 C 16.230469 2.457031 16.085938 2.457031 15.910156 2.457031 C 15.878906 2.457031 15.878906 2.457031 15.878906 2.425781 C 15.878906 2.242188 15.878906 2.089844 15.878906 1.9375 C 16.023438 1.9375 16.171875 1.9375 16.347656 1.9375 C 16.375 2.089844 16.375 2.242188 16.375 2.425781 Z M 16.375 2.425781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 14.5625 2.457031 C 14.535156 2.304688 14.535156 2.152344 14.535156 1.96875 C 14.679688 1.9375 14.824219 1.9375 15 1.9375 C 15.03125 2.089844 15.03125 2.242188 15.03125 2.425781 C 14.886719 2.457031 14.742188 2.457031 14.5625 2.457031 Z M 14.5625 2.457031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 15.851562 1.9375 C 15.878906 2.089844 15.878906 2.242188 15.878906 2.425781 C 15.757812 2.457031 15.636719 2.457031 15.484375 2.457031 C 15.453125 2.304688 15.457031 2.152344 15.453125 1.96875 C 15.578125 1.9375 15.699219 1.9375 15.851562 1.9375 Z M 15.851562 1.9375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 4.183594 2.457031 C 4.183594 2.457031 4.148438 2.457031 4.128906 2.457031 C 3.992188 2.457031 3.871094 2.457031 3.71875 2.425781 C 3.6875 2.242188 3.6875 2.089844 3.6875 1.9375 C 3.808594 1.9375 3.929688 1.9375 4.082031 1.9375 C 4.113281 1.9375 4.148438 1.9375 4.164062 1.96875 C 4.183594 2.152344 4.183594 2.304688 4.183594 2.457031 Z M 4.183594 2.457031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 4.210938 2.457031 C 4.183594 2.304688 4.183594 2.152344 4.183594 1.96875 C 4.304688 1.9375 4.425781 1.9375 4.578125 1.9375 C 4.609375 2.089844 4.609375 2.242188 4.609375 2.425781 C 4.488281 2.457031 4.363281 2.457031 4.210938 2.457031 Z M 4.210938 2.457031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 3.65625 1.9375 C 3.6875 2.089844 3.6875 2.242188 3.6875 2.425781 C 3.6875 2.457031 3.6875 2.457031 3.65625 2.457031 C 3.503906 2.457031 3.382812 2.457031 3.261719 2.457031 C 3.261719 2.304688 3.261719 2.152344 3.261719 1.96875 C 3.382812 1.9375 3.503906 1.9375 3.65625 1.9375 Z M 3.65625 1.9375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 2.339844 8.117188 C 2.339844 7.988281 2.339844 7.863281 2.339844 7.703125 C 2.339844 7.667969 2.339844 7.671875 2.371094 7.671875 C 2.523438 7.671875 2.644531 7.671875 2.765625 7.671875 C 2.765625 7.671875 2.765625 7.671875 2.765625 7.703125 C 2.765625 7.863281 2.765625 7.988281 2.765625 8.117188 C 2.765625 8.117188 2.765625 8.117188 2.734375 8.117188 C 2.582031 8.117188 2.460938 8.117188 2.339844 8.117188 Z M 2.339844 8.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 2.339844 8.5625 C 2.21875 8.5625 2.09375 8.5625 1.941406 8.5625 C 1.890625 8.285156 1.902344 8.039062 2.308594 8.117188 C 2.339844 8.117188 2.339844 8.117188 2.339844 8.148438 C 2.339844 8.308594 2.339844 8.4375 2.339844 8.5625 Z M 2.339844 8.5625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 16.800781 8.117188 C 16.800781 8.246094 16.800781 8.371094 16.800781 8.53125 C 16.800781 8.5625 16.800781 8.5625 16.773438 8.5625 C 16.621094 8.5625 16.5 8.5625 16.375 8.53125 C 16.375 8.371094 16.375 8.246094 16.40625 8.117188 C 16.558594 8.117188 16.679688 8.117188 16.800781 8.117188 Z M 16.800781 8.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 16.800781 7.671875 C 16.925781 7.671875 17.046875 7.667969 17.199219 7.667969 C 17.25 7.945312 17.238281 8.195312 16.832031 8.117188 C 16.800781 8.117188 16.800781 8.117188 16.800781 8.085938 C 16.800781 7.925781 16.800781 7.796875 16.800781 7.671875 Z M 16.800781 7.671875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 15.882812 6.253906 C 15.882812 6.253906 15.878906 6.21875 15.910156 6.199219 C 16.085938 6.179688 16.230469 6.179688 16.378906 6.179688 C 16.378906 6.179688 16.375 6.21875 16.375 6.269531 C 16.375 6.445312 16.378906 6.574219 16.347656 6.703125 C 16.171875 6.703125 16.023438 6.703125 15.878906 6.703125 C 15.878906 6.703125 15.878906 6.703125 15.878906 6.671875 C 15.878906 6.511719 15.878906 6.382812 15.882812 6.253906 Z M 15.882812 6.253906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 16.375 6.148438 C 16.230469 6.179688 16.085938 6.179688 15.910156 6.179688 C 15.878906 6.054688 15.878906 5.925781 15.878906 5.765625 C 16.023438 5.734375 16.171875 5.734375 16.347656 5.734375 C 16.378906 5.863281 16.375 5.988281 16.375 6.148438 Z M 16.375 6.148438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 17.230469 7.117188 C 17.105469 7.148438 16.984375 7.148438 16.832031 7.148438 C 16.800781 7.148438 16.800781 7.148438 16.800781 7.117188 C 16.800781 6.957031 16.800781 6.828125 16.800781 6.703125 C 17.066406 6.679688 17.304688 6.691406 17.230469 7.117188 Z M 17.230469 7.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 16.378906 6.703125 C 16.378906 6.574219 16.375 6.445312 16.375 6.285156 C 16.640625 6.230469 16.878906 6.246094 16.800781 6.671875 C 16.800781 6.703125 16.800781 6.703125 16.773438 6.703125 C 16.621094 6.703125 16.5 6.703125 16.375 6.703125 C 16.375 6.703125 16.378906 6.703125 16.378906 6.703125 Z M 16.378906 6.703125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 17.230469 9.945312 C 17.109375 9.980469 16.984375 9.980469 16.832031 9.980469 C 16.800781 9.980469 16.800781 9.980469 16.800781 9.945312 C 16.800781 9.789062 16.800781 9.660156 16.800781 9.53125 C 17.066406 9.507812 17.304688 9.519531 17.230469 9.945312 Z M 17.230469 9.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 16.800781 9.085938 C 16.800781 9.210938 16.800781 9.339844 16.800781 9.5 C 16.800781 9.53125 16.800781 9.53125 16.773438 9.53125 C 16.621094 9.53125 16.5 9.53125 16.375 9.5 C 16.375 9.339844 16.375 9.210938 16.40625 9.085938 C 16.558594 9.085938 16.679688 9.085938 16.800781 9.085938 Z M 16.800781 9.085938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 2.339844 9.980469 C 2.339844 9.851562 2.339844 9.722656 2.339844 9.5625 C 2.339844 9.53125 2.339844 9.53125 2.371094 9.53125 C 2.523438 9.53125 2.644531 9.53125 2.765625 9.53125 C 2.765625 9.53125 2.765625 9.53125 2.765625 9.5625 C 2.765625 9.722656 2.765625 9.851562 2.734375 9.980469 C 2.582031 9.980469 2.460938 9.980469 2.339844 9.976562 C 2.339844 9.976562 2.339844 9.980469 2.339844 9.980469 Z M 2.339844 9.980469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 1.914062 9.117188 C 2.035156 9.085938 2.15625 9.085938 2.308594 9.085938 C 2.339844 9.085938 2.339844 9.085938 2.339844 9.117188 C 2.339844 9.277344 2.339844 9.40625 2.339844 9.53125 C 2.074219 9.554688 1.839844 9.542969 1.914062 9.117188 Z M 1.914062 9.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 2.796875 10.945312 C 2.765625 10.820312 2.765625 10.691406 2.765625 10.53125 C 2.765625 10.5 2.765625 10.5 2.796875 10.5 C 2.972656 10.5 3.117188 10.5 3.261719 10.5 C 3.261719 10.5 3.261719 10.5 3.261719 10.53125 C 3.261719 10.691406 3.261719 10.820312 3.261719 10.945312 C 3.117188 10.945312 2.972656 10.945312 2.796875 10.945312 Z M 2.796875 10.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 2.339844 10.011719 C 2.460938 9.980469 2.582031 9.980469 2.734375 9.980469 C 2.765625 9.980469 2.765625 9.980469 2.765625 10.011719 C 2.765625 10.195312 2.765625 10.347656 2.765625 10.5 C 2.644531 10.5 2.523438 10.5 2.371094 10.5 C 2.339844 10.347656 2.339844 10.195312 2.339844 10.011719 Z M 2.339844 10.011719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 3.261719 2.488281 C 3.382812 2.457031 3.503906 2.457031 3.65625 2.457031 C 3.6875 2.585938 3.6875 2.710938 3.6875 2.871094 C 3.566406 2.90625 3.445312 2.90625 3.292969 2.90625 C 3.261719 2.777344 3.261719 2.648438 3.261719 2.488281 Z M 3.261719 2.488281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 2.765625 6.199219 C 2.765625 6.054688 2.765625 5.925781 2.765625 5.765625 C 2.910156 5.734375 3.054688 5.734375 3.230469 5.734375 C 3.261719 5.863281 3.261719 5.988281 3.261719 6.148438 C 3.261719 6.183594 3.261719 6.21875 3.230469 6.238281 C 3.054688 6.253906 2.910156 6.253906 2.765625 6.253906 C 2.765625 6.253906 2.765625 6.21875 2.765625 6.199219 Z M 2.765625 6.199219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 3.65625 5.285156 C 3.707031 5.566406 3.699219 5.8125 3.292969 5.734375 C 3.261719 5.605469 3.261719 5.480469 3.261719 5.320312 C 3.382812 5.285156 3.503906 5.285156 3.65625 5.285156 Z M 3.65625 5.285156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 16.375 8.117188 C 16.375 8.246094 16.375 8.371094 16.375 8.53125 C 16.375 8.5625 16.378906 8.5625 16.347656 8.5625 C 16.171875 8.5625 16.023438 8.5625 15.878906 8.5625 C 15.878906 8.4375 15.878906 8.308594 15.878906 8.148438 C 15.878906 8.117188 15.878906 8.117188 15.910156 8.117188 C 16.085938 8.117188 16.230469 8.117188 16.378906 8.117188 C 16.375 8.117188 16.375 8.117188 16.375 8.117188 Z M 16.375 8.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 15.878906 9.085938 C 15.757812 9.085938 15.636719 9.085938 15.484375 9.085938 C 15.460938 8.824219 15.363281 8.480469 15.851562 8.5625 C 15.878906 8.5625 15.878906 8.5625 15.878906 8.597656 C 15.878906 8.78125 15.878906 8.933594 15.878906 9.085938 Z M 15.878906 9.085938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 15.453125 7.777344 C 15.453125 7.734375 15.453125 7.71875 15.484375 7.6875 C 15.636719 7.667969 15.757812 7.667969 15.882812 7.703125 C 15.878906 7.863281 15.878906 7.988281 15.878906 8.117188 C 15.679688 8.105469 15.40625 8.203125 15.453125 7.777344 Z M 15.453125 7.777344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.725491%,93.725491%,93.725491%)",
      fillOpacity: 1
    },
    d: "M 3.261719 7.148438 C 3.238281 7.304688 3.21875 7.457031 3.164062 7.640625 C 3.007812 7.667969 2.886719 7.671875 2.765625 7.671875 C 2.765625 7.671875 2.765625 7.671875 2.765625 7.636719 C 2.765625 7.453125 2.765625 7.300781 2.765625 7.148438 C 2.765625 7.148438 2.765625 7.148438 2.796875 7.148438 C 2.972656 7.148438 3.117188 7.148438 3.261719 7.148438 Z M 3.261719 7.148438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 2.765625 7.703125 C 2.886719 7.671875 3.007812 7.667969 3.160156 7.667969 C 3.191406 7.671875 3.226562 7.671875 3.242188 7.703125 C 3.261719 7.863281 3.261719 7.988281 3.261719 8.117188 C 3.25 8.117188 3.238281 8.117188 3.175781 8.117188 C 3.007812 8.117188 2.886719 8.117188 2.765625 8.117188 C 2.765625 7.988281 2.765625 7.863281 2.765625 7.703125 Z M 2.765625 7.703125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 3.292969 8.117188 C 3.261719 7.988281 3.261719 7.863281 3.261719 7.703125 C 3.527344 7.644531 3.757812 7.660156 3.6875 8.085938 C 3.566406 8.117188 3.445312 8.117188 3.292969 8.117188 Z M 3.292969 8.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 3.261719 6.703125 C 3.382812 6.703125 3.503906 6.703125 3.65625 6.703125 C 3.710938 6.984375 3.695312 7.226562 3.292969 7.148438 C 3.261719 7.148438 3.261719 7.148438 3.261719 7.117188 C 3.261719 6.957031 3.261719 6.828125 3.261719 6.703125 Z M 3.261719 6.703125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,98.823529%,98.823529%)",
      fillOpacity: 1
    },
    d: "M 3.191406 8.5625 C 3.199219 8.589844 3.210938 8.605469 3.246094 8.664062 C 3.261719 8.828125 3.261719 8.957031 3.261719 9.085938 C 3.261719 9.085938 3.261719 9.085938 3.230469 9.085938 C 3.054688 9.085938 2.910156 9.085938 2.765625 9.050781 C 2.765625 8.867188 2.765625 8.714844 2.796875 8.5625 C 2.945312 8.5625 3.070312 8.5625 3.191406 8.5625 Z M 3.191406 8.5625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 3.191406 8.53125 C 3.070312 8.5625 2.945312 8.5625 2.796875 8.5625 C 2.765625 8.5625 2.765625 8.5625 2.765625 8.53125 C 2.765625 8.371094 2.765625 8.246094 2.765625 8.117188 C 2.886719 8.117188 3.007812 8.117188 3.160156 8.117188 C 3.191406 8.246094 3.191406 8.371094 3.191406 8.53125 Z M 3.191406 8.53125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 3.292969 9.085938 C 3.261719 8.957031 3.261719 8.828125 3.261719 8.671875 C 3.382812 8.636719 3.503906 8.636719 3.65625 8.636719 C 3.6875 8.765625 3.6875 8.894531 3.6875 9.054688 C 3.566406 9.085938 3.445312 9.085938 3.292969 9.085938 Z M 3.292969 9.085938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 2.765625 6.285156 C 2.910156 6.253906 3.054688 6.253906 3.230469 6.253906 C 3.261719 6.382812 3.261719 6.511719 3.261719 6.671875 C 3.261719 6.703125 3.261719 6.703125 3.230469 6.703125 C 3.054688 6.703125 2.910156 6.703125 2.765625 6.703125 C 2.765625 6.574219 2.765625 6.445312 2.765625 6.285156 Z M 2.765625 6.285156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 15.878906 6.734375 C 16.023438 6.703125 16.171875 6.703125 16.347656 6.703125 C 16.378906 6.703125 16.375 6.703125 16.375 6.734375 C 16.375 6.894531 16.375 7.019531 16.375 7.148438 C 16.375 7.148438 16.378906 7.148438 16.347656 7.148438 C 16.171875 7.148438 16.023438 7.148438 15.878906 7.148438 C 15.878906 7.148438 15.882812 7.148438 15.882812 7.148438 C 15.878906 7.023438 15.878906 6.894531 15.878906 6.734375 Z M 15.878906 6.734375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 15.882812 7.667969 C 15.757812 7.667969 15.636719 7.667969 15.484375 7.667969 C 15.457031 7.515625 15.457031 7.367188 15.457031 7.183594 C 15.578125 7.148438 15.699219 7.148438 15.851562 7.148438 C 15.882812 7.148438 15.878906 7.148438 15.878906 7.179688 C 15.878906 7.367188 15.878906 7.519531 15.878906 7.671875 C 15.878906 7.671875 15.882812 7.667969 15.882812 7.667969 Z M 15.882812 7.667969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 15.851562 6.253906 C 15.878906 6.382812 15.878906 6.511719 15.878906 6.671875 C 15.757812 6.703125 15.636719 6.703125 15.484375 6.703125 C 15.457031 6.574219 15.457031 6.445312 15.457031 6.289062 C 15.578125 6.253906 15.699219 6.253906 15.851562 6.253906 Z M 15.851562 6.253906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 15.851562 3.871094 C 15.882812 4 15.882812 4.128906 15.882812 4.289062 C 15.757812 4.320312 15.636719 4.320312 15.484375 4.320312 C 15.453125 4.191406 15.453125 4.0625 15.453125 3.902344 C 15.578125 3.871094 15.699219 3.871094 15.851562 3.871094 Z M 15.851562 3.871094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 16.375 10.945312 C 16.230469 10.945312 16.085938 10.945312 15.910156 10.945312 C 15.878906 10.945312 15.878906 10.945312 15.878906 10.914062 C 15.882812 10.753906 15.882812 10.628906 15.882812 10.5 C 15.882812 10.5 15.878906 10.5 15.910156 10.5 C 16.085938 10.5 16.230469 10.5 16.375 10.5 C 16.375 10.5 16.375 10.5 16.375 10.53125 C 16.375 10.691406 16.375 10.820312 16.375 10.945312 Z M 16.375 10.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 15.851562 10.5 C 15.882812 10.628906 15.882812 10.753906 15.882812 10.914062 C 15.757812 10.945312 15.636719 10.945312 15.484375 10.945312 C 15.453125 10.820312 15.453125 10.691406 15.453125 10.53125 C 15.578125 10.5 15.699219 10.5 15.851562 10.5 Z M 15.851562 10.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,98.823529%,98.823529%)",
      fillOpacity: 1
    },
    d: "M 16.378906 10.5 C 16.230469 10.5 16.085938 10.5 15.910156 10.5 C 15.878906 10.347656 15.878906 10.195312 15.878906 10.011719 C 15.878906 9.980469 15.878906 9.980469 15.910156 9.980469 C 16.085938 9.980469 16.230469 9.980469 16.378906 9.980469 C 16.375 9.980469 16.375 9.980469 16.375 10.011719 C 16.375 10.195312 16.378906 10.347656 16.378906 10.5 Z M 16.378906 10.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 15.453125 9.5625 C 15.578125 9.53125 15.699219 9.53125 15.851562 9.53125 C 15.878906 9.53125 15.878906 9.53125 15.878906 9.5625 C 15.878906 9.722656 15.878906 9.851562 15.878906 9.980469 C 15.757812 9.980469 15.636719 9.980469 15.484375 9.980469 C 15.453125 9.851562 15.453125 9.722656 15.453125 9.5625 Z M 15.453125 9.5625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 3.261719 9.980469 C 3.382812 9.980469 3.503906 9.980469 3.65625 9.980469 C 3.6875 10.128906 3.6875 10.28125 3.6875 10.46875 C 3.6875 10.5 3.6875 10.5 3.65625 10.5 C 3.503906 10.5 3.382812 10.5 3.261719 10.5 C 3.261719 10.5 3.261719 10.5 3.261719 10.46875 C 3.261719 10.28125 3.261719 10.128906 3.261719 9.980469 Z M 3.261719 9.980469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 4.113281 10.914062 C 3.992188 10.945312 3.867188 10.945312 3.714844 10.945312 C 3.6875 10.945312 3.6875 10.945312 3.6875 10.914062 C 3.6875 10.753906 3.6875 10.628906 3.6875 10.5 C 3.808594 10.5 3.929688 10.5 4.082031 10.5 C 4.113281 10.628906 4.113281 10.753906 4.113281 10.914062 Z M 4.113281 10.914062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 2.765625 9.085938 C 2.910156 9.085938 3.054688 9.085938 3.230469 9.085938 C 3.261719 9.210938 3.261719 9.339844 3.261719 9.5 C 3.261719 9.53125 3.261719 9.53125 3.230469 9.53125 C 3.054688 9.53125 2.910156 9.53125 2.765625 9.53125 C 2.765625 9.53125 2.765625 9.53125 2.765625 9.5 C 2.765625 9.339844 2.765625 9.210938 2.765625 9.085938 Z M 2.765625 9.085938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 2.765625 9.5625 C 2.910156 9.53125 3.054688 9.53125 3.230469 9.53125 C 3.261719 9.660156 3.261719 9.789062 3.261719 9.945312 C 3.261719 9.980469 3.261719 9.980469 3.230469 9.980469 C 3.054688 9.980469 2.910156 9.980469 2.765625 9.980469 C 2.765625 9.851562 2.765625 9.722656 2.765625 9.5625 Z M 2.765625 9.5625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 16.375 9.085938 C 16.375 9.210938 16.375 9.339844 16.375 9.5 C 16.375 9.53125 16.378906 9.53125 16.347656 9.53125 C 16.171875 9.53125 16.023438 9.53125 15.878906 9.53125 C 15.878906 9.40625 15.878906 9.277344 15.878906 9.117188 C 15.878906 9.085938 15.878906 9.085938 15.910156 9.085938 C 16.085938 9.085938 16.230469 9.085938 16.375 9.085938 Z M 16.375 9.085938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 2.734375 7.148438 C 2.765625 7.300781 2.765625 7.453125 2.765625 7.636719 C 2.644531 7.671875 2.523438 7.671875 2.371094 7.671875 C 2.339844 7.519531 2.339844 7.367188 2.339844 7.179688 C 2.460938 7.148438 2.582031 7.148438 2.734375 7.148438 Z M 2.734375 7.148438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 2.765625 6.734375 C 2.910156 6.703125 3.054688 6.703125 3.230469 6.703125 C 3.261719 6.828125 3.261719 6.957031 3.261719 7.117188 C 3.117188 7.148438 2.972656 7.148438 2.796875 7.148438 C 2.765625 7.019531 2.765625 6.894531 2.765625 6.734375 Z M 2.765625 6.734375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 16.375 10.5 C 16.378906 10.347656 16.375 10.195312 16.40625 10.011719 C 16.558594 9.980469 16.679688 9.980469 16.800781 9.980469 C 16.800781 10.128906 16.800781 10.28125 16.800781 10.46875 C 16.800781 10.5 16.800781 10.5 16.773438 10.5 C 16.621094 10.5 16.5 10.5 16.375 10.5 Z M 16.375 10.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 16.375 10.53125 C 16.5 10.5 16.621094 10.5 16.773438 10.5 C 16.800781 10.628906 16.800781 10.753906 16.800781 10.914062 C 16.679688 10.945312 16.558594 10.945312 16.40625 10.945312 C 16.375 10.820312 16.375 10.691406 16.375 10.53125 Z M 16.375 10.53125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 3.65625 10.5 C 3.6875 10.628906 3.6875 10.753906 3.6875 10.914062 C 3.566406 10.945312 3.445312 10.945312 3.292969 10.945312 C 3.261719 10.820312 3.261719 10.691406 3.261719 10.53125 C 3.382812 10.5 3.503906 10.5 3.65625 10.5 Z M 3.65625 10.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 2.765625 8.5625 C 2.765625 8.714844 2.765625 8.867188 2.765625 9.050781 C 2.765625 9.085938 2.765625 9.085938 2.734375 9.085938 C 2.582031 9.085938 2.460938 9.085938 2.339844 9.085938 C 2.339844 8.933594 2.339844 8.78125 2.339844 8.597656 C 2.339844 8.5625 2.339844 8.5625 2.371094 8.5625 C 2.523438 8.5625 2.644531 8.5625 2.765625 8.5625 Z M 2.765625 8.5625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,99.215686%,99.215686%)",
      fillOpacity: 1
    },
    d: "M 16.800781 9.054688 C 16.679688 9.085938 16.558594 9.085938 16.40625 9.085938 C 16.375 9.085938 16.375 9.085938 16.375 9.050781 C 16.375 8.867188 16.375 8.714844 16.378906 8.5625 C 16.378906 8.5625 16.375 8.5625 16.375 8.5625 C 16.5 8.5625 16.621094 8.5625 16.773438 8.5625 C 16.800781 8.714844 16.800781 8.867188 16.800781 9.054688 Z M 16.800781 9.054688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(92.941177%,92.941177%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 16.800781 7.148438 C 16.800781 7.300781 16.800781 7.453125 16.800781 7.636719 C 16.800781 7.671875 16.800781 7.671875 16.773438 7.671875 C 16.621094 7.667969 16.5 7.667969 16.375 7.671875 C 16.375 7.671875 16.378906 7.671875 16.375 7.636719 C 16.375 7.453125 16.378906 7.300781 16.378906 7.148438 C 16.378906 7.148438 16.375 7.148438 16.40625 7.148438 C 16.558594 7.148438 16.679688 7.148438 16.800781 7.148438 Z M 16.800781 7.148438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 2.765625 8.53125 C 2.644531 8.5625 2.523438 8.5625 2.371094 8.5625 C 2.339844 8.4375 2.339844 8.308594 2.339844 8.148438 C 2.460938 8.117188 2.582031 8.117188 2.734375 8.117188 C 2.765625 8.246094 2.765625 8.371094 2.765625 8.53125 Z M 2.765625 8.53125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 16.375 7.667969 C 16.5 7.667969 16.621094 7.667969 16.773438 7.667969 C 16.800781 7.796875 16.800781 7.925781 16.800781 8.085938 C 16.679688 8.117188 16.558594 8.117188 16.40625 8.117188 C 16.375 8.117188 16.375 8.117188 16.375 8.085938 C 16.375 7.925781 16.375 7.796875 16.375 7.667969 Z M 16.375 7.667969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 16.800781 7.117188 C 16.679688 7.148438 16.558594 7.148438 16.40625 7.148438 C 16.375 7.019531 16.375 6.894531 16.375 6.734375 C 16.5 6.703125 16.621094 6.703125 16.773438 6.703125 C 16.800781 6.828125 16.800781 6.957031 16.800781 7.117188 Z M 16.800781 7.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 16.800781 9.945312 C 16.679688 9.980469 16.558594 9.980469 16.40625 9.980469 C 16.375 9.980469 16.375 9.980469 16.375 9.945312 C 16.375 9.789062 16.378906 9.660156 16.378906 9.53125 C 16.378906 9.53125 16.375 9.53125 16.375 9.53125 C 16.5 9.53125 16.621094 9.53125 16.773438 9.53125 C 16.800781 9.660156 16.800781 9.789062 16.800781 9.945312 Z M 16.800781 9.945312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 2.339844 9.117188 C 2.460938 9.085938 2.582031 9.085938 2.734375 9.085938 C 2.765625 9.210938 2.765625 9.339844 2.765625 9.5 C 2.644531 9.53125 2.523438 9.53125 2.371094 9.53125 C 2.339844 9.40625 2.339844 9.277344 2.339844 9.117188 Z M 2.339844 9.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.725491%,93.725491%,93.725491%)",
      fillOpacity: 1
    },
    d: "M 2.765625 10.011719 C 2.910156 9.980469 3.054688 9.980469 3.230469 9.980469 C 3.261719 10.128906 3.261719 10.28125 3.261719 10.46875 C 3.117188 10.5 2.972656 10.5 2.796875 10.5 C 2.765625 10.347656 2.765625 10.195312 2.765625 10.011719 Z M 2.765625 10.011719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.725491%,93.725491%,93.725491%)",
      fillOpacity: 1
    },
    d: "M 16.347656 8.5625 C 16.375 8.714844 16.375 8.867188 16.375 9.050781 C 16.230469 9.085938 16.085938 9.085938 15.910156 9.085938 C 15.878906 8.933594 15.878906 8.78125 15.878906 8.597656 C 16.023438 8.5625 16.171875 8.5625 16.347656 8.5625 Z M 16.347656 8.5625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 16.375 7.671875 C 16.375 7.796875 16.375 7.925781 16.375 8.085938 C 16.230469 8.117188 16.085938 8.117188 15.910156 8.117188 C 15.878906 7.988281 15.878906 7.863281 15.882812 7.703125 C 15.882812 7.667969 15.878906 7.671875 15.910156 7.671875 C 16.085938 7.671875 16.230469 7.671875 16.378906 7.671875 C 16.378906 7.671875 16.375 7.671875 16.375 7.671875 Z M 16.375 7.671875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(99.215686%,98.823529%,98.823529%)",
      fillOpacity: 1
    },
    d: "M 16.375 7.636719 C 16.230469 7.671875 16.085938 7.671875 15.910156 7.671875 C 15.878906 7.519531 15.878906 7.367188 15.878906 7.179688 C 16.023438 7.148438 16.171875 7.148438 16.347656 7.148438 C 16.378906 7.300781 16.375 7.453125 16.375 7.636719 Z M 16.375 7.636719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(93.333334%,93.333334%,93.333334%)",
      fillOpacity: 1
    },
    d: "M 16.347656 9.53125 C 16.378906 9.660156 16.375 9.789062 16.375 9.945312 C 16.230469 9.980469 16.085938 9.980469 15.910156 9.980469 C 15.878906 9.851562 15.878906 9.722656 15.878906 9.5625 C 16.023438 9.53125 16.171875 9.53125 16.347656 9.53125 Z M 16.347656 9.53125 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThb);
export default __webpack_public_path__ + "static/media/thb.1167b42e32fd912e88764b25a041993d.svg";
export { ForwardRef as ReactComponent };